import * as Sentry from "@sentry/browser";
import {
  Badge,
  Card as AntdCard,
  Button,
  Checkbox,
  Col,
  Collapse,
  Descriptions,
  Divider,
  Drawer,
  Empty,
  Input,
  message,
  Radio,
  Row,
  Spin,
  Table,
  Tag,
  Tooltip,
  Typography,
  Popconfirm,
} from "antd";
import { Moment } from "moment";
import React, { Fragment, RefObject } from "react";
import { RouteComponentProps } from "react-router";
import {
  Activity,
  Attachment,
  AssociatedAddress,
  AssociatedEmail,
  AssociatedPhone,
  BranchMap,
  Changelog,
  CloseInteractionPayload,
  Company,
  CompanyContact,
  FinancialInstitution,
  ContactLevel,
  CompanyStatement,
  Contribution,
  Country,
  Customer,
  CustomerLien,
  Director,
  PaymentAccount,
  DocumentTypes,
  FileTypes,
  Entitlement,
  FailedDeduction,
  FormFieldConfig,
  LayoutConfig,
  Liens,
  Note,
  NotificationRecord,
  Opportunity,
  PaginatedResourcePageSelected,
  Payment,
  EmailInterface,
  PhoneInterface,
  AddressInterface,
  Port,
  ProductContributionSubscriptionMapping,
  RedemptionsRequest,
  SalesPerson,
  Schedule,
  SelectOptionsInterface,
  Subscription,
  Ticket,
  TransferRequest,
  UpdatePaymentInformationFnProps,
  FileUpload,
  User,
  VestingRule,
  CustomerVestingRule,
  APIError,
  CompanyInteractionAttachment,
  Template,
  InteractionNotificationPreview,
} from "../helpers/shared-interfaces";
import {
  convertPortToSelectOptions,
  convertCustomersToSelectOptions,
  createAbsoluteHttpLink,
  dateFormatMonthYear,
  extractFileName,
  formatSnakeCase,
  subscriptionInitialTags,
  formatter,
  generateCompanySegments,
  generateDisplayErrorMessage,
  generateNameFromPort,
  getStateColor,
  handleValidationErrors,
  injectKey,
  isAutomaticTag,
  mapAPIErrorToFormError,
  mapSubscriptionToContribution,
  request,
  responseHandler,
  transferRequestStates,
  transferTypes,
  isSavingsBoosterProduct,
} from "../helpers/utilities";
import { contributionTypes } from "../helpers/constants";

import {
  EyeOutlined,
  LeftOutlined,
  LinkOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { CheckboxValueType } from "antd/lib/checkbox/Group";
import { FormInstance } from "antd/lib/form";
import Search from "antd/lib/input/Search";
import { ColumnsType } from "antd/lib/table/Table";
import { AxiosResponse } from "axios";
import debounce from "lodash.debounce";
import moment from "moment";
import { NavLink } from "react-router-dom";
import ActivitiesSection from "../components/ActivitiesSection";
import Card from "../components/Card";
import ContactDetailsView from "../components/ContactDetailsView";
import EntitledEntity from "../components/EntitledEntity";
import EntitledSection from "../components/EntitledSection";
import ReturnedChequeNotificationModal from "../components/ReturnedChequeNotificationModal";
import BaseForm from "../components/Form/BaseForm";
import { GenerateStatementUI } from "../components/GenerateStatementUI";
import CompanyInteractionSection from "../components/InteractionSection";
import InteractionsSection from "../components/InteractionsSection";
import { MergerSection } from "../components/MergerSection";
import ModalCreator from "../components/ModalCreator";
import PaymentAccountsView from "../components/PaymentsAccountsView";
import CreateCustomerSubscription from "../components/ProductSubscription";
import TagsManagement, {
  AssignTagsOptions,
} from "../components/TagsManagement";
import TagsSection from "../components/TagsSection";
import {
  createAddressFields,
  createEmailFields,
  createPhoneFields,
} from "../components/AssociatedEntitiesSection";
import entitlements from "../config/entitlements";
import { GET_ROLE_SUMMARY } from "../gql/roles";
import { GET_SALES_PEOPLE } from "../gql/users";
import CompanyActivityList from "./CompanyActivityList";
import NewRedemptionRequest from "./NewRedemptionRequest";
import NewTransferRequest from "./NewTransferRequest";
import CompanyOnboardingDetails, { Views as CompanyOnboardingViews, createDocumentUploadFormFields, UploadedDocumentCard, ModalToggler } from "../components/CompanyOnboardingDetails";
import {
  notificationColumns,
  NotificationRecordTableFactory,
} from "./NotificationRecords";
import {
  breakdownColumnCreator,
  genDyFields,
  RedemptionsRequestsTableFactory,
} from "./ViewCustomer";
import {
  ALL_PORTS_QUERY,
  GET_COUNTRIES,
  GET_INDUSTRY_SECTORS,
  GET_TRUSTEES_SUMMARY,
  UPDATE_VESTING_RULE,
  CREATE_VESTING_RULE,
  DELETE_VESTING_RULE,
  CREATE_CUSTOMER_VESTING_RULE,
  CREATE_NOTE,
  DELETE_FILE,
  GET_TAGS,
} from "../gql/general";
import {
  ASSIGN_ATTACHMENT_TO_COMPANY_INTERACTION,
  ASSIGN_NOTE_TO_COMPANY_INTERACTION,
  ASSIGN_PORT_TO_COMPANY,
  ADD_COMPANY_CLOSED_INTERVAL,
  ASSIGN_TAGS_TO_COMPANY,
  ASSIGN_TAGS_TO_COMPANY_SUBSCRIPTION,
  DELETE_COMPANY_CLOSED_INTERVAL,
  GET_COMPANY_TAGS,
  CLOSE_COMPANY_INTERACTION,
  COMPANY_PAYMENTS,
  COMPANY_SCHEDULES,
  CREATE_COMAPANY_INTERACTION,
  CREATE_COMPANY_TICKET,
  DELETE_COMPANY_SUBSCRIPTION,
  GENERATE_COMPANY_STATEMENT,
  GET_COMPANY_CHANGELOG,
  GET_COMPANY_CONTRIBUTIONS,
  GET_COMPANY_INTERACTIONS_QUERY,
  GET_COMPANY_NOTIFICATIONS,
  GET_COMPANY_QUERY,
  GET_COMPANY_REDEMPTION_REQUESTS,
  GET_COMPANY_TICKETS,
  GET_COMPANY_TRANSFER_REQUESTS,
  HOLD_COMPANY_INTERACTION,
  MERGE_COMPANIES,
  OPEN_COMPANY_INTERACTION,
  UPDATE_COMPANY_INTERACTION,
  UPDATE_COMPANY_SUBSCRIPTION,
  GET_COMPANY_INTERACTION_CHANGELOG,
  GET_COMPANY_STATEMENTS,
  GET_COMPANY_SUBSCRIPTIONS,
  SEARCH_COMPANY_BY_PETRAID,
  SEARCH_CURRENT_EMPLOYEE,
  REVERSE_MERGE_COMPANIES,
  BULK_REVERSE_MERGE_COMPANIES,
  UNASSIGN_ATTACHMENT_FROM_COMPANY_INTERACTION,
  ASSIGN_ADDRESS_TO_COMPANY,
  ASSIGN_EMAIL_TO_COMPANY,
  ASSIGN_PHONE_TO_COMPANY,
  UNASSIGN_ADDRESS_FROM_COMPANY,
  UNASSIGN_EMAIL_FROM_COMPANY,
  UNASSIGN_PHONE_FROM_COMPANY,
  UPDATE_COMPANY_ADDRESS,
  UPDATE_COMPANY_EMAIL,
  UPDATE_COMPANY_PHONE,
  MARK_COMPANY_EMAIL_AS_PRIMARY,
  MARK_COMPANY_PHONE_AS_PRIMARY,
  MARK_COMPANY_ADDRESS_AS_PRIMARY,
  CREATE_CONTACT_PERSON_MUTATION,
  UPDATE_COMPANY_CONTACT_PERSON_MUTATION,
  DELETE_COMPANY_CONTACT_PERSON_MUTATION,
  CREATE_COMPANY_DIRECTOR,
  CREATE_DIRECTOR_CONTACT,
  DELETE_DIRECTOR_CONTACT,
  REMOVE_DIRECTOR,
  UPDATE_COMPANY_MUTATION,
  GET_RETURNED_CHEQUE_NOTIFICATION_PREVIEW,
  NOTIFY_RETURNED_CHEQUE,
} from "../gql/companies";
import { ColumnType } from "antd/lib/table";
import { DEBOUNCE_TIME, tabPaneStyle } from "../helpers/constants";
import { Constants as AssociatedEntityConstants } from "../components/AssociatedEntitiesSection";
import { GET_CONTACT_LEVELS } from "../gql/templates";
import { SEARCH_CUSTOMER } from "../gql/customers";
import { CREATE_ADDRESS, CREATE_EMAIL, CREATE_PHONE, GET_FINANCIAL_INSTITUTIONS } from "../gql/general";


const { Panel } = Collapse;
const { Text } = Typography;

const relationshipManagerRoleId = "29";
const directorContactFieldsToValidate = ["emailAddress", "phoneNumber"];

interface State {
  isEditingInteraction: boolean;
  id: string | number;
  isLoading: boolean;
  company?: Company;
  countries: Country[];
  activities: Activity[];
  changeLogs: Changelog[];
  showChangeLog: boolean;
  layoutConfig: LayoutConfig;
  isFiltering: boolean;
  filterBy: string;
  filteredChangelogs: Changelog[];
  contributions: Contribution[];
  contributionsLoader: boolean;
  showDrawer: boolean;
  activeDrawerContent?: ActiveDrawerContent;
  currentInteractionId?: string;
  interactionsChangeLogs: Changelog[];
  currentSubscriptionId?: string;
  showStatementModal: boolean;
  isStatementLoading: boolean;
  generatedStatementUrl?: string;
  attachmentIds: string[];
  attachments: Attachment[];
  tickets: Ticket[];
  canCreateTicket: boolean;
  isTicketLoading: boolean;
  ports: Port[];
  showAccountMergerModal: boolean;
  selectedCompanies: string[];
  companySearchQuery: string;
  companies: Company[];
  payments: Payment[];
  schedules: Schedule[];
  isSearchingForCompany: boolean;
  isMerging: boolean;
  showInteractionModal: boolean;
  isCreateInteractionLoading: boolean;
  currentSubscription?: Subscription;
  showAddDocumentModal: boolean;
  showDeleteConfirmationModal: boolean;
  modalTarget: string | null;
  idToBeDeleted?: string;
  hasLoadedContributions: string[];
  loadedCountries: boolean;
  loadedAudits: boolean;
  loadedNotifierRecords: boolean;
  notifierRecords: NotificationRecord[];
  redemptionRequests: RedemptionsRequest[];
  transferRequests: TransferRequest[];
  activitiesCount: number;
  activitiesPage: number;
  areInteractionsLoading: boolean;
  contactPersons?: CompanyContact[];
  currentRequestsToProcess: number;
  currentEmployeesPage: number;
  formerEmployeesPage: number;
  phoenixTickets: Ticket[];
  contributionsPagination: {
    fundCode: string;
    page: number;
    total: number;
  }[];
  showConfirmProductDelete: boolean;
  subscriptionIdToDelete: string | undefined;
  showSubscriptionEditModal: boolean;
  subscriptionToEdit?: Subscription;
  isSavingSubscriptionEdits: boolean;
  relationshipManagers: User[];
  relationshipManagerSearchTerm: string;
  salesPersons: SalesPerson[];
  salesPersonSearchTerm: string;
  numberPerPage: number;
  companyStatements: CompanyStatement[];
  companySubscriptions?: Subscription[];
  disableCreateInteractionButton: boolean;
  isReversingMerge: boolean;
  isBulkReversingMerge: boolean;
  showReverseMergeModal: boolean;
  notes?: Note[];
  companyInteractionAttachments: CompanyInteractionAttachment[];
  allCompanyTags: import("../helpers/shared-interfaces").TagRecord[];
  companyClosedIntervals: import("../helpers/shared-interfaces").CompanyClosedInterval[];
  showAddIntervalModal: boolean;
  // Keys the closure-period form so its FileUploads, which hold their own file
  // list and expose no reset, are rebuilt on every open.
  intervalFormSession: number;
  isSubmittingInterval: boolean;
  isLoadingCompanyTags: boolean;
  productTags: SelectOptionsInterface[];
  showCompanyContactModal: boolean;
  showCompanyDirectorModal: boolean;
  showCompanyDirectorContactModal: boolean;
  showCompanyContactDeleteModal: boolean;
  currentCompanyContact?: CompanyContact;
  currentCompanyDirector?: Director;
  companyContactFieldsToHide: string[];
  contactLevels: ContactLevel[];
  customers: Customer[];
  customerSearchTerm: string;
  isExistingCustomer: boolean;
  contactPersonRequired: boolean;
  documentUrl: string;
  showContactModal: boolean;
  showContactDeleteModal: boolean;
  contactModalType: "email" | "phone" | "address" | null;
  contactModalMode: "add" | "edit";
  contactModalLoading: boolean;
  deleteContactType: "email" | "phone" | "address" | null;
  deleteContactId: string | null;
  selectedEmail?: AssociatedEmail | null;
  selectedPhone?: AssociatedPhone | null;
  selectedAddress?: AssociatedAddress | null;
  addressType: string;
  financialInstitutions: FinancialInstitution[];
  branchMap: BranchMap;
  showCompanyEditModal: boolean;
  isCompanyEditSaving: boolean;
  industrySectors: SelectOptionsInterface[];
  trustees: SelectOptionsInterface[];
  showCompanyPaymentModal: boolean;
  showCompanyDirectorDeleteModal: boolean;
  directorToDelete?: Director;
  selectedReturnedChequePayment: Payment | null;
  returnedChequePreview?: InteractionNotificationPreview | null;
  isReturnedChequePreviewLoading: boolean;
  isSendingReturnedCheque: boolean;
  paymentStatusFilter: "all" | "identified" | "returned";
}

type ActiveDrawerContent =
  | "audits"
  | "notifierRecords"
  | "requests"
  | "companyInteraction"
  | "redemptions"
  | "redemptionRequests"
  | "productSubscription"
  | "mergers"
  | "vestingRules"
  | "";

interface Props
  extends RouteComponentProps<
    RouteParams,
    any,
    { type: string; requests?: Company[] }
  > {
  entitlement: Entitlement;
  user: User;
  companyInteractionId?: string;
}

interface RouteParams {
  id: string;
}

export const changelogColumns = [
  {
    title: "Date",
    dataIndex: "createdAt",
    key: "date",
    width: "25%",
    render(text: string): JSX.Element {
      const [date, time] = text.split(" ");
      return (
        <span>
          {moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY")}
          <br />
          at {time}
        </span>
      );
    },
  },
  {
    title: "Audit",
    dataIndex: "auditItem",
    key: "audit",
    align: "left" as const,
    render(text: string): JSX.Element {
      return <span>{text}</span>;
    },
  },
  {
    title: "User",
    dataIndex: "user",
    key: "user",
    align: "left" as const,
    render(text: string): JSX.Element {
      return <span>{text}</span>;
    },
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
    align: "left" as const,
    render(text: string): JSX.Element {
      return <span>{text}</span>;
    },
  },
  {
    title: "Comments",
    dataIndex: "comment",
    key: "comment",
    align: "left" as const,
    render(text: string): JSX.Element {
      return <span>{text}</span>;
    },
  },
];

export const transferRequestsColumns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    render(text: string, record: TransferRequest): JSX.Element {
      return (
        <NavLink to={`/transfer-requests/${record.id}`}>{record.id}</NavLink>
      );
    },
  },
  {
    title: "Request Date",
    dataIndex: "requestDate",
    key: "requestDate",
    render(text: string, record: TransferRequest): JSX.Element {
      return (
        <span>
          {record.requestDate
            ? moment(record.requestDate, "YYYY-MM-DD HH:mm:ss").format(
                "DD/MM/YYYY",
              )
            : "N/A"}
        </span>
      );
    },
  },
  {
    title: "Status",
    dataIndex: "transferStatus",
    key: "transferStatus",
    render(text: string, record: TransferRequest): JSX.Element {
      return (
        <Tag color={getStateColor(record.transferStatus)} key={text}>
          {transferRequestStates[record.transferStatus]}
        </Tag>
      );
    },
  },
  {
    title: "Trustee Name",
    dataIndex: "trustee",
    key: "trustee",
    render(text: string, record: TransferRequest): JSX.Element {
      return <span>{record.trusteeScheme?.trustee?.name || "N/A"}</span>;
    },
  },
  {
    title: "Transfer Type",
    dataIndex: "transferType",
    key: "transferType",
    render(text: string, record: TransferRequest): JSX.Element {
      return <span>{transferTypes[record.transferType]}</span>;
    },
  },
  {
    title: "From Product",
    dataIndex: "fromProduct",
    key: "fromProduct",
    render(text: string, record: TransferRequest): JSX.Element {
      return <span>{record.fromProduct?.name || "N/A"}</span>;
    },
  },
  {
    title: "To Product",
    dataIndex: "toProduct",
    key: "toProduct",
    render(text: string, record: TransferRequest): JSX.Element {
      return <span>{record.toProduct?.name || "N/A"}</span>;
    },
  },
  {
    title: "FCD",
    dataIndex: "firstContributionDate",
    key: "firstContributionDate",
    render(text: string, record: TransferRequest): JSX.Element {
      return (
        <span>
          {record.firstContributionDate
            ? moment(record.firstContributionDate, "YYYY-MM-DD").format(
                "DD/MM/YYYY",
              )
            : "N/A"}
        </span>
      );
    },
  },
  {
    title: "Requested By",
    dataIndex: "user",
    key: "user",
    render(text: string, record: TransferRequest): JSX.Element {
      return <span>{record.user?.name}</span>;
    },
  },
];

export const failedDeductionsColumns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    render(text: string, record: FailedDeduction): JSX.Element {
      return <span>{record.id}</span>;
    },
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    render(text: string, record: FailedDeduction): JSX.Element {
      return (
        <span>
          {record.date
            ? moment(record.date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY")
            : "N/A"}
        </span>
      );
    },
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    render(text: string, record: FailedDeduction): JSX.Element {
      return <span>{formatter.format(record.amount)}</span>;
    },
  },
  {
    title: "Rejection Reason",
    dataIndex: "reason",
    key: "reason",
    render(text: string, record: FailedDeduction): JSX.Element {
      return <span>{record.reason}</span>;
    },
  },
];

export const changeTotalBalanceColumn = [
  {
    title: "Product Name",
    dataIndex: ["subscription", "product", "name"],
    key: "productContribution",
    render(
      text: string,
      record: ProductContributionSubscriptionMapping,
    ): JSX.Element {
      return <p>{record.subscription.product.name}</p>;
    },
  },
  {
    title: "Total Balance",
    dataIndex: ["productContribution", "balance"],
    key: "balance",
    render(value: number): JSX.Element {
      return <p>{formatter.format(value)}</p>;
    },
  },
  {
    title: "Redeemable Balance",
    dataIndex: ["productContribution", "redeemableBalance"],
    key: "redeemableBalance",
    render(value: number): JSX.Element {
      return <p>{formatter.format(value)}</p>;
    },
  },
  {
    title: "Product Lien",
    dataIndex: ["subscription", "customerLiens"],
    key: "amount",
    render(
      text: string,
      record: ProductContributionSubscriptionMapping,
    ): JSX.Element {
      let total = 0;

      if (
        record.subscription.customerLiens &&
        record.subscription.customerLiens.length > 0
      ) {
        record.subscription.customerLiens.forEach(
          (customerLien: CustomerLien) => {
            total = customerLien.currentAmount + total;
          },
        );
      } else {
        record.subscription.companyLiens &&
          record.subscription.companyLiens.forEach((companyLien: Liens) => {
            total = companyLien.amount + total;
          });
      }

      return <p>{formatter.format(total)}</p>;
    },
  },
  {
    title: "Date Joined Scheme",
    dataIndex: ["subscription", "createdAt"],
    key: "createdAt",
    render(
      text: string,
      record: ProductContributionSubscriptionMapping,
    ): JSX.Element {
      const date = record.subscription.createdAt;
      return date ? (
        <span>{moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY")}</span>
      ) : (
        <span></span>
      );
    },
  },
];

export const paymentColumns = [
  {
    title: "Scheme",
    dataIndex: "scheme",
    key: "scheme",
    render(text: string, record: Payment): JSX.Element {
      return <span>{record.scheme}</span>;
    },
  },
  {
    title: "Payment ID",
    dataIndex: "taId",
    key: "taId",
    render(text: string, record: Payment): JSX.Element {
      return <span>{record.taId}</span>;
    },
  },
  {
    title: "Description",
    dataIndex: ["contributions", "contribution_type"],
    key: "contribution_type",
    render(text: string, record: Payment): JSX.Element {
      return record?.contributions?.length > 0 ? (
        <Text>
          {`${record.contributions?.[0]?.["contribution_type"]}
            [${Array.from(
              record.contributions?.[0]?.["contribution_dates"] as string[],
            ).map((item) => dateFormatMonthYear(item))}]
          `}
        </Text>
      ) : (
        <Text></Text>
      );
    },
  },
  {
    title: "Contribution Date",
    dataIndex: "transactionDate",
    key: "transactionDate",
    render(text: string): JSX.Element {
      return (
        <Text>{moment(text, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY")}</Text>
      );
    },
  },
  {
    title: "Price Date",
    dataIndex: "valueDate",
    key: "valueDate",
    render(text: string): JSX.Element {
      return (
        <Text>{moment(text, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY")}</Text>
      );
    },
  },
  {
    title: "Transaction Amount",
    dataIndex: "transactionAmount",
    key: "transactionAmount",
    render(value: number): JSX.Element {
      return <p>{formatter.format(value)}</p>;
    },
  },
];

export const buildPaymentColumns = (
  onNotifyReturnedCheque: (payment: Payment) => void,
) => [
  ...paymentColumns,
  {
    title: "Status",
    dataIndex: "returnedAt",
    key: "returnedAtStatus",
    render(_: string, record: Payment): JSX.Element {
      if (!record.returnedAt) return <></>;

      return (
        <>
          <Tag color="red">Returned</Tag>
          {record.returnedChequeNotified && (
            <Tag color="green">Notified</Tag>
          )}
        </>
      );
    },
  },
  {
    title: "",
    dataIndex: "returnedAt",
    key: "notifyReturnedCheque",
    render(_: string, record: Payment): JSX.Element {
      if (
        !record.returnedAt ||
        record.returnPaymentType !== "Cheque" ||
        record.returnedChequeNotified
      )
        return <></>;

      return (
        <EntitledSection
          entitlement={entitlements.Companies.notifyReturnedCheque}
        >
          <Button
            size="small"
            type="primary"
            color="blue"
            onClick={() => onNotifyReturnedCheque(record)}
          >
            Notify
          </Button>
        </EntitledSection>
      );
    },
  },
];

export const scheduleColumns = [
  {
    title: "Scheme",
    dataIndex: "scheme",
    key: "scheme",
    render(text: string, record: Schedule): JSX.Element {
      return <span>{record.scheme}</span>;
    },
  },
  {
    title: "Schedule ID",
    dataIndex: "taId",
    key: "taId",
    render(taId: string): JSX.Element {
      return <Text>{taId}</Text>;
    },
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    render(text: any, record: Schedule): JSX.Element {
      return (
        <Text>{`${record.contributionType} [${Array.from(
          record.contributionDates,
        ).map((item) => dateFormatMonthYear(item))}]`}</Text>
      );
    },
  },
  {
    title: "Tier",
    dataIndex: "tier",
    key: "tier",
    render(text: string): JSX.Element {
      return <Text>{text}</Text>;
    },
  },
  {
    title: "Validity",
    dataIndex: "isValid",
    key: "isValid",
    render(status: boolean): JSX.Element {
      return (
        <span>
          {status ? (
            <Tag color="success">Valid</Tag>
          ) : (
            <Tag color="error">Invalid</Tag>
          )}
        </span>
      );
    },
  },
  {
    title: "Created Date",
    dataIndex: "createdAt",
    key: "createdAt",
    render(text: string): JSX.Element {
      return (
        <Text>{moment(text, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY")}</Text>
      );
    },
  },
  {
    title: "Match Created Date",
    dataIndex: "matchProcessedAt",
    key: "matchProcessedAt",
    render(text: string, record: Schedule): JSX.Element {
      if (record.isValid) {
        return (
          <Text>
            {record.matchProcessedAt
              ? moment(record.matchProcessedAt, "YYYY-MM-DD HH:mm:ss").format(
                  "DD/MM/YYYY",
                )
              : "01/01/0001 12:00:00"}
          </Text>
        );
      } else {
        return <Text></Text>;
      }
    },
  },
  {
    title: "Total Amount",
    dataIndex: "totalAmount",
    key: "totalAmount",
    render(value: number): JSX.Element {
      return <p>{formatter.format(value)}</p>;
    },
  },
  {
    title: "Total Salary",
    dataIndex: "totalSalary",
    key: "totalSalary",
    render(value: number): JSX.Element {
      return <p>{formatter.format(value)}</p>;
    },
  },
];

export const ticketColumns = [
  {
    title: "Ticket Number",
    dataIndex: "reference",
    key: "reference",
    defaultSortOrder: "descend" as const,
    sorter: (a: Ticket, b: Ticket) => Number(a.reference) - Number(b.reference),
    render(reference: string, record: Ticket): JSX.Element {
      return <Text>{record?.reference}</Text>;
    },
  },
  {
    title: "Title",
    dataIndex: ["properties", "title"],
    key: "subject",
    render(_: any, record: Ticket): JSX.Element {
      if (typeof record?.properties === "string") {
        const formattedRecord = JSON.parse(record?.properties);
        return <Text>{formattedRecord?.title}</Text>;
      } else {
        return <Text>{record?.properties?.title}</Text>;
      }
    },
  },
  {
    title: "State",
    dataIndex: "state",
    key: "state",
    render(_: any, record: Ticket): JSX.Element {
      if (record?.state) {
        return (
          <Tag color={getStateColor(record?.state)}>
            {record?.state}
          </Tag>
        );
      } else if (typeof record?.properties === "string") {
        const formattedRecord = JSON.parse(record?.properties);
        return (
          <Tag color={getStateColor(formattedRecord?.state)}>
            {formattedRecord?.state}
          </Tag>
        );
      } else {
        return (
          <Tag color={getStateColor(record?.properties?.state)}>
            {record?.properties?.state}
          </Tag>
        );
      }
    },
  },
  {
    title: "Link",
    dataIndex: "url",
    key: "url",
    render(_: any, record: Ticket): JSX.Element {
      const url = createAbsoluteHttpLink(record?.url);
      return (
        <a href={`${url}`} target="_blank" rel="noopener noreferrer">
          <EyeOutlined />
        </a>
      );
    },
  },
];

export function ChangelogTableFactory(data: Changelog[]): JSX.Element {
  const tempData: Changelog[] = data.map(
    (log: Changelog, index: number): Changelog => {
      return { ...log, key: String(index) };
    },
  );
  return (
    <Table
      style={{ width: "100%" }}
      bordered={true}
      columns={changelogColumns}
      dataSource={tempData}
      pagination={false}
    />
  );
}
export const contributionColumnsFirstHalf = [
  {
    title: "Description",
    dataIndex: "dealDescription",
    key: "description",
    width: "25%",
    render(text: string, record: Contribution): JSX.Element {
      return <p>{record.dealDescription}</p>;
    },
  },
  {
    title: "Price Date",
    dataIndex: "priceDate",
    key: "priceDate",
    width: "25%",
    render(text: string, record: Contribution): JSX.Element {
      return (
        <p>
          {record.priceDate
            ? moment(record.priceDate, "YYYY-MM-DD HH:mm:ss").format("L")
            : "N/A"}
        </p>
      );
    },
  },
];

export const contributionColumnsSecondHalf = [
  {
    title: "Total Amount",
    dataIndex: "totalAmount",
    key: "totalAmount",
    width: "25%",
    render(text: string, record: Contribution): JSX.Element {
      return record.dealType === "redemption" ? (
        <span
          style={{
            color: "red",
            marginLeft: "12px",
          }}
        >
          {formatter.format(record.totalAmount)}
        </span>
      ) : (
        <span
          style={{
            color: "green",
            marginLeft: "12px",
          }}
        >
          {formatter.format(record.totalAmount)}
        </span>
      );
    },
  },
  {
    title: "Total Units",
    dataIndex: "totalUnits",
    key: "totalUnits",
    width: "25%",
    render(text: string, record: Contribution): JSX.Element {
      return record.dealType === "redemption" ? (
        <span
          style={{
            color: "red",
            marginLeft: "12px",
          }}
        >
          {record.totalUnits}
        </span>
      ) : (
        <span
          style={{
            color: "green",
            marginLeft: "12px",
          }}
        >
          {record.totalUnits}
        </span>
      );
    },
  },
];

export const generateCompanyContributionColumns = (
  contribution: Contribution,
) => {
  const dyFields = genDyFields(contribution);
  const columns = [
    ...contributionColumnsFirstHalf,
    ...breakdownColumnCreator(dyFields),
    ...contributionColumnsSecondHalf,
  ];
  return columns;
};

export function ContributionsTableFactory(
  data: Contribution[],
  columns: ColumnsType<Contribution>,
  nextPage: (page: number, fundCode: string) => void,
  page: number,
  totalCount: number,
  fundCode: string,
): JSX.Element {
  const tempData: Contribution[] = data.map((c: Contribution): Contribution => {
    return { ...c, key: c.id };
  });
  return (
    <Table
      bordered={true}
      columns={columns}
      dataSource={tempData}
      pagination={{
        current: page,
        defaultPageSize: 10,
        total: totalCount,
        onChange: (page: number) => nextPage(page, fundCode),
      }}
    />
  );
}

export const documentColumns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    width: "70%",
    render(text: string): JSX.Element {
      return <span>{text}</span>;
    },
  },
  {
    title: "Url",
    dataIndex: "url",
    key: "url",
    width: "30%",
    render(text: string): JSX.Element {
      return (
        <a target="_blank" href={text} rel="noopener noreferrer">
          View File
        </a>
      );
    },
  },
];

export function DocumentTableFactory(data: FileUpload[], setEntityToBeDeleted?: (entity: string) => void, toggleDeleteConfirmationModal?: (id?: string) => void): JSX.Element {
  // Without delete handlers (e.g. the archived companies view) the cards render read-only.
  const isEditing = Boolean(setEntityToBeDeleted && toggleDeleteConfirmationModal);

  return (
    <Row gutter={[16, 16]}>
      {data.map((document: FileUpload) => (
        <Col key={document.id} xs={24} sm={12} md={8} lg={8} xl={8}>
          <UploadedDocumentCard
            document={document}
            isEditing={isEditing}
            setEntityToBeDeleted={setEntityToBeDeleted}
            toggleDeleteConfirmationModal={toggleDeleteConfirmationModal}
            type={document.fileType ?? ''}
            setIdToBeDeleted={() => {}}
          />
        </Col>
      ))}
    </Row>
  );
}

export function getCompanyStatementTableColumns<
  T extends CompanyStatement,
>(): ColumnType<T>[] {
  return [
    {
      title: "Period",
      dataIndex: "period",
      key: "period",
      render(text: string): JSX.Element {
        return <span>{text}</span>;
      },
    },
    {
      title: "Statement Type",
      dataIndex: "statementType",
      key: "statementType",
      render(text: string): JSX.Element {
        return <span>{text}</span>;
      },
    },
    {
      title: "Product",
      dataIndex: "product",
      key: "product",
      render(text: string): JSX.Element {
        return <span>{text}</span>;
      },
    },
    {
      title: "Email Sent",
      dataIndex: "emailSent",
      key: "emailSent",
      render(text: string): JSX.Element {
        return <span>{text.toString()}</span>;
      },
    },
    {
      title: "Date Sent",
      dataIndex: "dateSent",
      key: "dateSent",
      render(text: string): JSX.Element {
        return (
          <span>
            {text ? moment(text, "YYYY-MM-DD HH:mm:ss").format("ll") : "N/A"}
          </span>
        );
      },
    },
    {
      title: "URL",
      dataIndex: "url",
      key: "url",
      align: "center" as const,

      render(text: string, record: CompanyStatement): JSX.Element {
        return (
          <a href={`${record?.url}`} target="_blank" rel="noopener noreferrer">
            <LinkOutlined />
          </a>
        );
      },
    },
  ];
}

export const transformDocumentsData = function (
  props: Opportunity,
): FileUpload[] {
  const response: FileUpload[] = [];

  if (props.employeeDatasheet) {
    response.push({
      id: props.employeeDatasheet.id,
      url: props.employeeDatasheet.url,
      name: DocumentTypes.eds,
      fileType: DocumentTypes.eds,
    });
  }

  if (props.signedApplicationForm) {
    response.push({
      id: props.signedApplicationForm.id,
      url: props.signedApplicationForm.url,
      name: DocumentTypes.signedApplicationForm,
      fileType: DocumentTypes.signedApplicationForm,
    });
  }

  if (props.npraForm) {
    response.push({
      id: props.npraForm.id,
      url: props.npraForm.url,
      name: DocumentTypes.npraForm,
      fileType: DocumentTypes.npraForm,
    });
  }

  if (props.vestingRuleDocument) {
    response.push({
      id: props.vestingRuleDocument.id,
      url: props.vestingRuleDocument.url,
      name: DocumentTypes.vestingRuleDocument,
      fileType: DocumentTypes.vestingRuleDocument,
    });
  }

  return response;
};

export function reassignPortDefaultView(port: Port): JSX.Element {
  return (
    <Fragment>
      <Col
        span={14}
        style={{
          alignContent: "flex-start",
        }}
      >
        <div
          style={{
            textAlign: "left",
            width: "100%",
          }}
        >
          <span
            style={{
              fontSize: "14px",
              color: "rgba(0, 0, 0, 0.85)",
              width: "100%",
            }}
          >
            <b>Assigned To Port</b>
          </span>
          {": "}
          {generateNameFromPort(port)}
        </div>
      </Col>
    </Fragment>
  );
}

export const mapSegmentToColor: Record<string, string> = {
  red: "#e00404",
  blue: "#0763f7",
  amber: "#ffbf00",
  green: "#00ff00",
};

export const ReverseMergeUI = (props: {
  company: Company | undefined;
  isReversingMerge: boolean;
}): JSX.Element => {
  return (
    <Fragment>
      <Spin spinning={props.isReversingMerge}>
        <Row>
          <Col
            span={24}
            style={{
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                marginTop: "10px",
              }}
            >
              You are about to reverse a merge between this account(
              {props.company && props.company.petraId}) and another.
            </div>
          </Col>
        </Row>
      </Spin>
    </Fragment>
  );
};

export const Details = (props: {
  company: Company;
  contactPersons: CompanyContact[];
  toggleDrawer: (value: ActiveDrawerContent) => () => void;
  toggleDrawerWithDataLoad: (value: ActiveDrawerContent) => void;
  contributions: Contribution[];
  portReference: RefObject<FormInstance>;
  ports: Port[];
  assignPortToCompany: () => void;
  toggleAccountMergerModal: () => void;
  toggleReverseMergeModal: () => void;
  extra?: JSX.Element;
  currentEmployeesPage: number;
  numberPerPage?: number;
  paginatedResourceNextPage: (
    page: number,
    paginatedResource: PaginatedResourcePageSelected,
    numberPerPage: number,
  ) => void;
  onReverse: (duplicateId: string) => void;
  isReversingMerge: boolean;
  onReverseAll: (duplicateIds?: string[]) => void;
  isBulkReversing: boolean;
  openContactModal: (
    type: "email" | "phone" | "address",
    mode: "add" | "edit",
    record?: AssociatedEmail | AssociatedPhone | AssociatedAddress,
  ) => void;
  openDeleteContactModal: (
    type: "email" | "phone" | "address",
    id: string,
  ) => void;
  onMakePrimaryEmail: (email: AssociatedEmail) => void;
  onMakePrimaryPhone: (phone: AssociatedPhone) => void;
  onMakePrimaryAddress: (address: AssociatedAddress) => void;
  onReactivateEmail: (email: AssociatedEmail) => void;
  onReactivatePhone: (phone: AssociatedPhone) => void;
  onReactivateAddress: (address: AssociatedAddress) => void;
  onAddCompanyDirector?: () => void;
  onDeleteCompanyDirector?: (director: Director) => void;
  onAddDirectorContact?: (director: Director) => void;
  onDeleteDirectorContact?: (contact: string, directorId: string) => void;
  onAddCompanyContact: () => void;
  onEditCompanyContact: (contact: CompanyContact) => void;
  onDeleteCompanyContact: (contact: CompanyContact) => void;
  onUploadCompanyInfoFile?: () => void;
  onDeleteCompanyInfoFile?: (id?: string) => void;
  onSetEntityToBeDeleted?: (entity: string) => void;
  openCompanyEditModal: () => void;
}): JSX.Element => {
  return (
    <Fragment>
      <Row className="view-opportunity-row">
        <Row style={{ width: "100%", marginBottom: "20px", gap: "5px" }}>
          <EntitledSection entitlement={entitlements.Companies.changelogList}>
            <Button
              className="base-button"
              onClick={async () => {
                await props.toggleDrawerWithDataLoad("audits");
              }}
            >
              Audit Logs
            </Button>
            <Button
              className="base-button"
              onClick={async () => {
                await props.toggleDrawerWithDataLoad("notifierRecords");
              }}
            >
              Notifications
            </Button>
          </EntitledSection>

          <EntitledSection
            entitlement={entitlements.CompanySubscriptions.create}
          >
            <Button
              className="base-button"
              onClick={props.toggleDrawer("productSubscription")}
            >
              Add Product
            </Button>
          </EntitledSection>
          {props?.extra}
        </Row>
        <AntdCard
          title={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 10,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span>Company</span>
                {props.company.tags.length > 0 && (
                  <TagsSection
                    compact
                    style={{ margin: 0 }}
                    tags={props.company.tags}
                  />
                )}
                {!!props.company.exclusionListTags?.length && (
                  <TagsSection
                    compact
                    color="purple"
                    style={{ margin: 0 }}
                    tags={props.company.exclusionListTags}
                  />
                )}
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <EntitledSection entitlement={entitlements.Companies.edit}>
                  <Button
                    className="base-button"
                    onClick={props.openCompanyEditModal}
                  >
                    Edit
                  </Button>
                </EntitledSection>
              </div>
            </div>
          }
        >
          <Descriptions>
            <Descriptions.Item label={<b>Petra ID</b>} key="Petra ID">
              {props.company.petraId || "N/A"}
            </Descriptions.Item>
            <Descriptions.Item label={<b>TIN</b>} key="TIN">
              {props.company.tinNumber || "N/A"}
            </Descriptions.Item>
            <Descriptions.Item
              label={<b>Date of Establishment</b>}
              key="dateOfEstablishment"
            >
              {props.company.dateOfEstablishment || "N/A"}
            </Descriptions.Item>
            <Descriptions.Item label={<b>Former Trustee</b>} key="Trustee">
              {props.company.trustee?.name || "N/A"}
            </Descriptions.Item>

            <Descriptions.Item
              label={<b>Industry Sector</b>}
              key="Industry Sector"
            >
              {props.company.industrySector?.name || "N/A"}
            </Descriptions.Item>

            <Descriptions.Item
              label={<b>Company Segment</b>}
              key="Company Segment"
            >
              <span>{props.company.companySegment || "N/A"}</span>
            </Descriptions.Item>

            <Descriptions.Item
              label={<b>Number of Employees</b>}
              key="Number Of Employees"
            >
              {props.company.numberOfEmployees ?? "N/A"}
            </Descriptions.Item>

            <Descriptions.Item label={<b>SSNIT Number</b>} key="ssnitNumber">
              {props.company.ssnitNumber || "N/A"}
            </Descriptions.Item>

            <Descriptions.Item label={<b>RDG/ROC Number</b>} key="rocNumber">
              {props.company.rocNumber || "N/A"}
            </Descriptions.Item>
            <Descriptions.Item
              label={<b>Relationship Manager</b>}
              key="Relationship Manager"
            >
              {props.company.relationshipManager?.name || "N/A"}
            </Descriptions.Item>
            <Descriptions.Item>
              <EntitledSection
                entitlement={entitlements.Companies.ports.assignToPort}
                defaultView={reassignPortDefaultView(props.company.port)}
              >
                <BaseForm
                  layout="horizontal"
                  reference={props.portReference}
                  fields={[
                    {
                      id: "portId",
                      name: "portId",
                      placeholder: "Select port",
                      required: false,
                      inputType: "select",
                      label: "Port Assigned To",
                      changeHandler: props.assignPortToCompany,
                      initialValue: props.company.port && props.company.port.id,
                      selectOptions: convertPortToSelectOptions(props.ports),
                      elementStyle: {
                        width: "100%",
                        color: "#333",
                        alignContent: "flex-start",
                      },
                      colConfig: {
                        span: 24,
                      },
                    },
                  ]}
                  fieldsToHide={[]}
                ></BaseForm>
              </EntitledSection>
            </Descriptions.Item>
          </Descriptions>
        </AntdCard>
      </Row>

      <ContactDetailsView
        editEntitlement={entitlements.Companies.edit}
        phones={props.company.companyPhones}
        emails={props.company.companyEmails}
        adresses={props.company.companyAddresses}
        onAddEmail={() => props.openContactModal("email", "add")}
        onEditEmail={(email) => props.openContactModal("email", "edit", email)}
        onDeleteEmail={(email) =>
          props.openDeleteContactModal("email", email.id)
        }
        onMakePrimaryEmail={props.onMakePrimaryEmail}
        onReactivateEmail={props.onReactivateEmail}
        onAddPhone={() => props.openContactModal("phone", "add")}
        onEditPhone={(phone) => props.openContactModal("phone", "edit", phone)}
        onDeletePhone={(phone) =>
          props.openDeleteContactModal("phone", phone.id)
        }
        onMakePrimaryPhone={props.onMakePrimaryPhone}
        onReactivatePhone={props.onReactivatePhone}
        onAddAddress={() => props.openContactModal("address", "add")}
        onEditAddress={(address) =>
          props.openContactModal("address", "edit", address)
        }
        onDeleteAddress={(address) =>
          props.openDeleteContactModal("address", address.id)
        }
        onMakePrimaryAddress={props.onMakePrimaryAddress}
        onReactivateAddress={props.onReactivateAddress}
        formerEmployees={{
          data: props.company?.formerEmployees?.results ?? [],
          totalCount: props.company?.formerEmployees
            ? props.company?.formerEmployees?.count
            : 0,
        }}
        currentEmployees={{
          data: props.company?.currentEmployees?.results ?? [],
          totalCount: props.company?.currentEmployees
            ? props.company?.currentEmployees?.count
            : 0,
        }}
        paginatedResourceNextPage={props?.paginatedResourceNextPage}
        style={{ marginBottom: "30px", marginTop: "30px" }}
        companyContacts={props.company.companyContacts}
        companyPetraId={props.company.petraId}
        currentEmployeesPage={props.currentEmployeesPage}
        numberPerPage={props.numberPerPage}
        directors={props.company.directors}
        companyInfoFileUploads={props.company.companyInfoFileUploads}

        onAddCompanyDirector={props.onAddCompanyDirector}
        onDeleteCompanyDirector={props.onDeleteCompanyDirector}
        onAddDirectorContact={props.onAddDirectorContact}
        onDeleteDirectorContact={props.onDeleteDirectorContact}
        onAddCompanyContact={props.onAddCompanyContact}
        onEditCompanyContact={props.onEditCompanyContact}
        onDeleteCompanyContact={props.onDeleteCompanyContact}
        onUploadCompanyInfoFile={props.onUploadCompanyInfoFile}
        onDeleteCompanyInfoFile={props.onDeleteCompanyInfoFile}
        onSetEntityToBeDeleted={props.onSetEntityToBeDeleted}
      />

      <MergerSection
        mergeLogs={props.company.companyMergeLogs || []}
        mergedTo={props.company.mergedTo}
        onReverse={props.onReverse}
        onReverseAll={props.onReverseAll}
        onInitiate={props.toggleAccountMergerModal}
        isReversing={props.isReversingMerge}
        isBulkReversing={props.isBulkReversing}
        type="company"
        canManage={true}
      />
    </Fragment>
  );
};

export const AccountMergerUI = (props: {
  searchQuery: string;
  companies: Company[];
  isLoading: boolean;
  isMerging: boolean;
  handleSearchInput: (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => Promise<void>;
  handleCheckboxGroupChange: (values: CheckboxValueType[]) => void;
  selectedCompanies: string[];
}): JSX.Element => {
  return (
    <Fragment>
      <Spin spinning={props.isMerging}>
        <Row>
          <Col
            span={24}
            style={{
              marginBottom: "20px",
            }}
          >
            <div>Search</div>
            <Search
              placeholder="Search by PetraId"
              style={{ width: "100%", marginTop: "10px" }}
              onChange={props.handleSearchInput}
              value={props.searchQuery}
              data-testid="filter-input"
              allowClear
              id="search-input-company"
            />
            <div
              style={{
                marginTop: "10px",
              }}
            >
              <Spin spinning={props.isLoading}>
                Results ({props.companies.length})
                {props.companies.length === 0 && <Empty />}
                <div>
                  <Checkbox.Group
                    defaultValue={props.selectedCompanies}
                    onChange={props.handleCheckboxGroupChange}
                  >
                    <Row>
                      {props.companies.map((company, index): JSX.Element => {
                        return (
                          <Col
                            span={24}
                            key={index}
                            style={{ marginTop: "10px" }}
                          >
                            <Checkbox value={company.id}>
                              {company.name} / {company.petraId}
                            </Checkbox>
                          </Col>
                        );
                      })}
                    </Row>
                  </Checkbox.Group>
                </div>
              </Spin>
            </div>
          </Col>
        </Row>
      </Spin>
    </Fragment>
  );
};

const YEAR_FIELDS = ["year0","year1","year2","year3","year4","year5","year6","year7","year8","year9","year10"];

interface VestingRuleState {
  fieldsToHide: string[];
  isLoading: boolean;
}

interface interfaceVestRuleProps {
  vestingRule: VestingRule;
  toggleShowVestingRuleModal?: () => void;
  companySubscriptionId?: string;
  getCompanySubscriptions: () => Promise<void>;
}

export class VestingRuleUI extends React.Component<
  interfaceVestRuleProps,
  VestingRuleState
> {
  reference: RefObject<FormInstance>;
  constructor(props: interfaceVestRuleProps) {
    super(props);
    this.state = {
      fieldsToHide: [],
      isLoading: false,
    };
    this.reference = React.createRef<FormInstance>();
  }

  setRef = (ref: React.RefObject<FormInstance>): void => {
    this.reference = ref;
  };

  applyFieldVisibility = (vestingType: string) => {
    if (vestingType === "flat_percentage") {
      this.setState({ fieldsToHide: [...YEAR_FIELDS, "vestingDateType"] });
    } else {
      this.setState({ fieldsToHide: ["flatPercentage"] });
    }
  };

  handleVestingTypeChange = (value: string) => {
    this.applyFieldVisibility(value);
  };

  buildVariables = (data: Record<string, any>, extra: Record<string, any>) => {
    const isFlat = data.vestingType === "flat_percentage";
    return {
      vestingType: data.vestingType,
      vestingDateType: data.vestingDateType,
      flatPercentage: isFlat ? Number(data.flatPercentage) : undefined,
      year0: isFlat ? undefined : data.year0,
      year1: isFlat ? undefined : data.year1,
      year2: isFlat ? undefined : data.year2,
      year3: isFlat ? undefined : data.year3,
      year4: isFlat ? undefined : data.year4,
      year5: isFlat ? undefined : data.year5,
      year6: isFlat ? undefined : data.year6,
      year7: isFlat ? undefined : data.year7,
      year8: isFlat ? undefined : data.year8,
      year9: isFlat ? undefined : data.year9,
      year10: isFlat ? undefined : data.year10,
      ...extra,
    };
  };

  createVestingRule = async (): Promise<void> => {
    interface Response {
      vestingRule: VestingRule;
      errors: Error[];
    }

    if (!this.reference.current) return;

    let data;
    try {
      data = await this.reference.current.validateFields([
        "vestingType", "vestingDateType", "flatPercentage",
        ...YEAR_FIELDS,
      ]);
    } catch (error) {
      handleValidationErrors(error);
      return;
    }

    this.setState({ isLoading: true });
    try {
      const response: AxiosResponse<Response> = await request({
        query: CREATE_VESTING_RULE,
        variables: this.buildVariables(data, {
          companySubscriptionId: this.props.companySubscriptionId,
        }),
      });

      const { err } = responseHandler<Response>(response, "createVestingRule");
      if (err) {
        message.error(generateDisplayErrorMessage(err));
      } else {
        this.props.getCompanySubscriptions();
        message.success("Vesting rule created successfully");
        this.props.toggleShowVestingRuleModal?.();
      }
    } catch (error) {
      message.error("Something went wrong. Failed to create vesting rule");
      Sentry.captureException(error);
      this.props.toggleShowVestingRuleModal?.();
    } finally {
      this.setState({ isLoading: false });
    }
  };

  updateVestingRule = async (): Promise<void> => {
    interface Response {
      vestingRule: VestingRule;
      errors: Error[];
    }

    if (!this.reference.current) return;

    let data;
    try {
      data = await this.reference.current.validateFields([
        "vestingType", "vestingDateType", "flatPercentage",
        ...YEAR_FIELDS,
      ]);
    } catch (error) {
      handleValidationErrors(error);
      return;
    }

    this.setState({ isLoading: true });
    try {
      const response: AxiosResponse<Response> = await request({
        query: UPDATE_VESTING_RULE,
        variables: this.buildVariables(data, {
          id: this.props.vestingRule.id,
        }),
      });

      const { err } = responseHandler<Response>(response, "updateVestingRule");
      if (err) {
        message.error(generateDisplayErrorMessage(err));
      } else {
        message.success("Vesting rule updated successfully");
        this.props.toggleShowVestingRuleModal?.();
        this.props.getCompanySubscriptions();
      }
    } catch (error) {
      message.error(`Something went wrong. Vesting rule update failed - ${generateDisplayErrorMessage(error)}`);
      Sentry.captureException(error);
      this.props.toggleShowVestingRuleModal?.();
    } finally {
      this.setState({ isLoading: false });
    }
  };

  deleteVestingRule = async (): Promise<void> => {
    interface Response {
      result: boolean;
      errors: Error[];
    }

    this.setState({ isLoading: true });
    try {
      const response: AxiosResponse<Response> = await request({
        query: DELETE_VESTING_RULE,
        variables: { id: this.props.vestingRule.id },
      });

      const { err } = responseHandler<Response>(response, "deleteVestingRule");
      if (err) {
        message.error(generateDisplayErrorMessage(err));
      } else {
        message.success("Vesting rule deleted successfully");
        this.props.toggleShowVestingRuleModal?.();
        this.props.getCompanySubscriptions();
      }
    } catch (error) {
      message.error(`Something went wrong. Vesting rule deletion failed - ${generateDisplayErrorMessage(error)}`);
      Sentry.captureException(error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  componentDidMount() {
    const { vestingRule } = this.props;
    this.applyFieldVisibility(vestingRule?.vestingType ?? "year_schedule");
  }

  componentDidUpdate(prevProps: interfaceVestRuleProps) {
    if (prevProps.vestingRule !== this.props.vestingRule && this.reference.current) {
      const { vestingRule } = this.props;
      this.reference.current.setFieldsValue({
        vestingType: vestingRule?.vestingType,
        flatPercentage: vestingRule?.flatPercentage,
        vestingDateType: vestingRule?.vestingDateType,
        year0: vestingRule?.year0 ?? 0,
        year1: vestingRule?.year1 ?? 0,
        year2: vestingRule?.year2 ?? 0,
        year3: vestingRule?.year3 ?? 0,
        year4: vestingRule?.year4 ?? 0,
        year5: vestingRule?.year5 ?? 0,
        year6: vestingRule?.year6 ?? 0,
        year7: vestingRule?.year7 ?? 0,
        year8: vestingRule?.year8 ?? 0,
        year9: vestingRule?.year9 ?? 0,
        year10: vestingRule?.year10 ?? 0,
      });
      this.applyFieldVisibility(vestingRule?.vestingType ?? "year_schedule");
    }
  }

  render(): JSX.Element | null {
    const { fieldsToHide, isLoading } = this.state;
    const { vestingRule } = this.props;
    const fields: FormFieldConfig[] = [
      {
        id: "vestingType",
        name: "vestingType",
        inputType: "select",
        selectOptions: [
          { name: "Year Schedule", id: "year_schedule" },
          { name: "Flat Percentage", id: "flat_percentage" },
        ],
        changeHandler: this.handleVestingTypeChange,
        rule: "string",
        placeholder: "Vesting Type",
        label: "Vesting Type",
        initialValue: vestingRule?.vestingType ?? "year_schedule",
        required: true,
        colConfig: { span: 24 },
      },
      {
        name: "flatPercentage",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Flat Percentage (%)",
        initialValue: vestingRule?.flatPercentage,
        placeholder: "e.g. 60",
        elementStyle: { width: "100%" },
        colConfig: { span: 24 },
        min: 0,
        max: 100,
      },
      // {
      //   id: "vestingDateType",
      //   name: "vestingDateType",
      //   inputType: "select",
      //   selectOptions: [
      //     { name: "Date of Employment", id: "date_of_employment" },
      //     { name: "First Contribution Date", id: "first_contribution_date" },
      //   ],
      //   rule: "string",
      //   placeholder: "Vesting Date Type",
      //   label: "Vesting Date Type",
      //   initialValue: vestingRule?.vestingDateType,
      //   required: false,
      //   colConfig: {
      //     span: 24,
      //   },
      // },
      {
        id: "vestingDateType",
        name: "vestingDateType",
        inputType: "select",
        selectOptions: [
          { name: "Date of Employment", id: "date_of_employment" },
          { name: "First Contribution Date", id: "first_contribution_date" },
        ],
        rule: "string",
        placeholder: "Vesting Date Type",
        label: "Vesting Date Type",
        initialValue: vestingRule?.vestingDateType,
        required: false,
        colConfig: { span: 24 },
      },
      {
        name: "year0",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Year 0",
        initialValue: vestingRule?.year0 || 0,
        placeholder: "Amount",
        elementStyle: { width: "100%" },
        colConfig: { span: 12 },
      },
      {
        name: "year1",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Year 1",
        initialValue: vestingRule?.year1 || 0,
        placeholder: "Amount",
        elementStyle: { width: "100%" },
        colConfig: { offset: 1, span: 11 },
      },
      {
        name: "year2",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Year 2",
        initialValue: vestingRule?.year2 || 0,
        placeholder: "Amount",
        elementStyle: { width: "100%" },
        colConfig: { span: 12 },
      },
      {
        name: "year3",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Year 3",
        initialValue: vestingRule?.year3 || 0,
        placeholder: "Amount",
        elementStyle: { width: "100%" },
        colConfig: { offset: 1, span: 11 },
      },
      {
        name: "year4",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Year 4",
        initialValue: vestingRule?.year4 || 0,
        placeholder: "Amount",
        elementStyle: { width: "100%" },
        colConfig: { span: 12 },
      },
      {
        name: "year5",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Year 5",
        initialValue: vestingRule?.year5 || 0,
        placeholder: "Amount",
        elementStyle: { width: "100%" },
        colConfig: { offset: 1, span: 11 },
      },
      {
        name: "year6",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Year 6",
        initialValue: vestingRule?.year6 || 0,
        placeholder: "Amount",
        elementStyle: { width: "100%" },
        colConfig: { span: 12 },
      },
      {
        name: "year7",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Year 7",
        initialValue: vestingRule?.year7 || 0,
        placeholder: "Amount",
        elementStyle: { width: "100%" },
        colConfig: { offset: 1, span: 11 },
      },
      {
        name: "year8",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Year 8",
        initialValue: vestingRule?.year8 || 0,
        placeholder: "Amount",
        elementStyle: { width: "100%" },
        colConfig: { span: 12 },
      },
      {
        name: "year9",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Year 9",
        initialValue: vestingRule?.year9 || 0,
        placeholder: "Amount",
        elementStyle: { width: "100%" },
        colConfig: { offset: 1, span: 11 },
      },
      {
        name: "year10",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Year 10",
        initialValue: vestingRule?.year10 || 0,
        placeholder: "Amount",
        elementStyle: { width: "100%" },
        colConfig: { span: 12 },
      },
    ];

    return (
      <Row>
        <Spin spinning={isLoading}>
          <Col span={24}>
            <BaseForm
              layout="vertical"
              reference={this.reference}
              fieldsToHide={fieldsToHide}
              fields={fields}
            />
            <Divider />
            <Row justify="space-between">
              {this.props.vestingRule && (
                <Popconfirm
                  title="Are you sure you want to delete this vesting rule?"
                  onConfirm={this.deleteVestingRule}
                  okText="Delete"
                  okType="danger"
                  cancelText="Cancel"
                >
                  <Button danger>Delete rule</Button>
                </Popconfirm>
              )}
              <Button
                type="primary"
                onClick={
                  this.props.vestingRule
                    ? this.updateVestingRule
                    : this.createVestingRule
                }
              >
                {this.props.vestingRule ? "Update rule" : "Create rule"}
              </Button>
            </Row>
          </Col>
        </Spin>
      </Row>
    );
  }
}

interface CustomerVestingRuleState {
  fieldsToHide: string[];
  isLoading: boolean;
  employees: Customer[];
  employeeSearchTerm: string;
  isSearchingEmployees: boolean;
}

interface CustomerVestingRuleProps {
  companySubscriptionId: string;
  companyPetraId: string;
  employees: Customer[];
  existingRule?: CustomerVestingRule;
  toggleModal: () => void;
  onSuccess: () => void;
}

export class CustomerVestingRuleUI extends React.Component<
  CustomerVestingRuleProps,
  CustomerVestingRuleState
> {
  reference: RefObject<FormInstance>;
  constructor(props: CustomerVestingRuleProps) {
    super(props);
    this.state = {
      fieldsToHide: [],
      isLoading: false,
      employees: props.employees,
      employeeSearchTerm: "",
      isSearchingEmployees: false,
    };
    this.reference = React.createRef<FormInstance>();
  }

  searchEmployees = async (): Promise<void> => {
    interface Response {
      data: {
        findCompanyByPetraId: Company;
      };
    }

    const { employeeSearchTerm } = this.state;
    this.setState({ isSearchingEmployees: true });
    try {
      const response: AxiosResponse<Response> = await request({
        query: SEARCH_CURRENT_EMPLOYEE,
        variables: {
          petraId: this.props.companyPetraId,
          associationNameTwo: "current_employees",
          customerPageTwo: 1,
          q: employeeSearchTerm,
          numberPerPage: 25,
        },
      });
      // Ignore stale responses if the user kept typing
      if (employeeSearchTerm !== this.state.employeeSearchTerm) return;
      const results =
        response.data.data?.findCompanyByPetraId?.currentEmployees?.results;
      this.setState({ employees: (results as Customer[]) ?? [] });
    } catch (error) {
      message.error("Employee search failed");
      Sentry.captureException(error);
    } finally {
      this.setState({ isSearchingEmployees: false });
    }
  };

  triggerEmployeeDelayedSearch = debounce(async (): Promise<void> => {
    await this.searchEmployees();
  }, DEBOUNCE_TIME);

  handleEmployeeSearchInput = (employeeSearchTerm: string): void => {
    this.setState({ employeeSearchTerm }, () => {
      this.triggerEmployeeDelayedSearch();
    });
  };

  componentWillUnmount(): void {
    this.triggerEmployeeDelayedSearch.cancel();
  }

  applyFieldVisibility = (vestingType: string) => {
    if (vestingType === "flat_percentage") {
      this.setState({ fieldsToHide: [...YEAR_FIELDS, "vestingDateType"] });
    } else {
      this.setState({ fieldsToHide: ["flatPercentage"] });
    }
  };

  handleVestingTypeChange = (value: string) => {
    this.applyFieldVisibility(value);
  };

  buildVariables = (data: Record<string, any>) => {
    const isFlat = data.vestingType === "flat_percentage";
    return {
      customerId: data.customerId,
      companySubscriptionId: this.props.companySubscriptionId,
      source: "phoenix",
      vestingType: data.vestingType,
      vestingDateType: data.vestingDateType,
      flatPercentage: isFlat ? Number(data.flatPercentage) : undefined,
      year0: isFlat ? undefined : data.year0,
      year1: isFlat ? undefined : data.year1,
      year2: isFlat ? undefined : data.year2,
      year3: isFlat ? undefined : data.year3,
      year4: isFlat ? undefined : data.year4,
      year5: isFlat ? undefined : data.year5,
      year6: isFlat ? undefined : data.year6,
      year7: isFlat ? undefined : data.year7,
      year8: isFlat ? undefined : data.year8,
      year9: isFlat ? undefined : data.year9,
      year10: isFlat ? undefined : data.year10,
    };
  };

  submit = async (): Promise<void> => {
    interface Response {
      customerVestingRule: CustomerVestingRule;
      errors: Error[];
    }

    if (!this.reference.current) return;

    let data;
    try {
      data = await this.reference.current.validateFields([
        "customerId", "vestingType", "vestingDateType", "flatPercentage",
        ...YEAR_FIELDS,
      ]);
    } catch (error) {
      handleValidationErrors(error);
      return;
    }

    this.setState({ isLoading: true });
    try {
      const response: AxiosResponse<Response> = await request({
        query: CREATE_CUSTOMER_VESTING_RULE,
        variables: this.buildVariables(data),
      });

      const { err } = responseHandler<Response>(response, "createCustomerVestingRule");
      if (err) {
        message.error(generateDisplayErrorMessage(err));
      } else {
        message.success("Customer vesting rule created successfully");
        this.props.onSuccess();
        this.props.toggleModal();
      }
    } catch (error) {
      message.error("Something went wrong. Failed to create customer vesting rule");
      Sentry.captureException(error);
      this.props.toggleModal();
    } finally {
      this.setState({ isLoading: false });
    }
  };

  componentDidMount() {
    const { existingRule } = this.props;
    this.applyFieldVisibility(existingRule?.vestingType ?? "year_schedule");
  }

  render(): JSX.Element | null {
    const { fieldsToHide, isLoading, employees, isSearchingEmployees } = this.state;
    const { existingRule } = this.props;
    const employeeOptions: SelectOptionsInterface[] = employees.map((e) => ({
      id: e.id,
      name: `${e.firstName} ${e.lastName} (${e.petraId})`,
    }));
    const fields: FormFieldConfig[] = [
      {
        id: "customerId",
        name: "customerId",
        inputType: "search",
        rule: "string",
        placeholder: "Search by name or petraId",
        label: "Employee",
        selectOptions: employeeOptions,
        changeHandler: this.handleEmployeeSearchInput,
        isSearching: isSearchingEmployees,
        initialValue: existingRule?.customerId,
        required: true,
        colConfig: { span: 24 },
      },
      {
        id: "vestingType",
        name: "vestingType",
        inputType: "select",
        selectOptions: [
          { name: "Year Schedule", id: "year_schedule" },
          { name: "Flat Percentage", id: "flat_percentage" },
        ],
        changeHandler: this.handleVestingTypeChange,
        rule: "string",
        placeholder: "Vesting Type",
        label: "Vesting Type",
        initialValue: existingRule?.vestingType ?? "year_schedule",
        required: true,
        colConfig: { span: 24 },
      },
      {
        name: "flatPercentage",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Flat Percentage (%)",
        initialValue: existingRule?.flatPercentage,
        placeholder: "e.g. 40",
        elementStyle: { width: "100%" },
        colConfig: { span: 24 },
        min: 0,
        max: 100,
      },
      {
        id: "vestingDateType",
        name: "vestingDateType",
        inputType: "select",
        selectOptions: [
          { name: "Date of Employment", id: "date_of_employment" },
          { name: "First Contribution Date", id: "first_contribution_date" },
        ],
        rule: "string",
        placeholder: "Vesting Date Type",
        label: "Vesting Date Type",
        initialValue: existingRule?.vestingDateType ?? "date_of_employment",
        required: true,
        colConfig: { span: 24 },
      },
      {
        name: "year0",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Year 0",
        initialValue: existingRule?.year0 || 0,
        placeholder: "Amount",
        elementStyle: { width: "100%" },
        colConfig: { span: 12 },
      },
      {
        name: "year1",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Year 1",
        initialValue: existingRule?.year1 || 0,
        placeholder: "Amount",
        elementStyle: { width: "100%" },
        colConfig: { offset: 1, span: 11 },
      },
      {
        name: "year2",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Year 2",
        initialValue: existingRule?.year2 || 0,
        placeholder: "Amount",
        elementStyle: { width: "100%" },
        colConfig: { span: 12 },
      },
      {
        name: "year3",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Year 3",
        initialValue: existingRule?.year3 || 0,
        placeholder: "Amount",
        elementStyle: { width: "100%" },
        colConfig: { offset: 1, span: 11 },
      },
      {
        name: "year4",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Year 4",
        initialValue: existingRule?.year4 || 0,
        placeholder: "Amount",
        elementStyle: { width: "100%" },
        colConfig: { span: 12 },
      },
      {
        name: "year5",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Year 5",
        initialValue: existingRule?.year5 || 0,
        placeholder: "Amount",
        elementStyle: { width: "100%" },
        colConfig: { offset: 1, span: 11 },
      },
      {
        name: "year6",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Year 6",
        initialValue: existingRule?.year6 || 0,
        placeholder: "Amount",
        elementStyle: { width: "100%" },
        colConfig: { span: 12 },
      },
      {
        name: "year7",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Year 7",
        initialValue: existingRule?.year7 || 0,
        placeholder: "Amount",
        elementStyle: { width: "100%" },
        colConfig: { offset: 1, span: 11 },
      },
      {
        name: "year8",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Year 8",
        initialValue: existingRule?.year8 || 0,
        placeholder: "Amount",
        elementStyle: { width: "100%" },
        colConfig: { span: 12 },
      },
      {
        name: "year9",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Year 9",
        initialValue: existingRule?.year9 || 0,
        placeholder: "Amount",
        elementStyle: { width: "100%" },
        colConfig: { offset: 1, span: 11 },
      },
      {
        name: "year10",
        rule: "number",
        inputType: "number",
        required: true,
        label: "Year 10",
        initialValue: existingRule?.year10 || 0,
        placeholder: "Amount",
        elementStyle: { width: "100%" },
        colConfig: { span: 12 },
      },
    ];

    return (
      <Row>
        <Spin spinning={isLoading}>
          <Col span={24}>
            <BaseForm
              layout="vertical"
              reference={this.reference}
              fieldsToHide={fieldsToHide}
              fields={fields}
            />
            <Divider />
            <Row justify="end">
              <Button type="primary" onClick={this.submit}>
                Create override
              </Button>
            </Row>
          </Col>
        </Spin>
      </Row>
    );
  }
}

interface VestingRulesModalProps {
  subscription: Subscription;
  companyPetraId: string;
  employees: Customer[];
  onClose: () => void;
  onSuccess: () => Promise<void>;
}

interface VestingRulesModalState {
  showRuleForm: boolean;
  showAddOverride: boolean;
}

class VestingRulesModal extends React.Component<VestingRulesModalProps, VestingRulesModalState> {
  constructor(props: VestingRulesModalProps) {
    super(props);
    this.state = { showRuleForm: false, showAddOverride: false };
  }

  render(): JSX.Element {
    const { subscription, employees } = this.props;
    const { showRuleForm, showAddOverride } = this.state;
    const vestingRule = subscription.vestingRule;
    const overrides = subscription.customerVestingRules ?? [];
    const employeeMap = new Map(employees.map((e) => [e.id, e]));

    return (
      <div>
        {showRuleForm && ModalCreator({
          title: vestingRule ? "Edit Company Rule" : "Set Company Rule",
          showModal: showRuleForm,
          showFooter: false,
          onOkay: () => this.setState({ showRuleForm: false }),
          toggleModal: () => this.setState({ showRuleForm: false }),
          inscription: (
            <VestingRuleUI
              vestingRule={vestingRule as VestingRule}
              toggleShowVestingRuleModal={() => this.setState({ showRuleForm: false })}
              getCompanySubscriptions={this.props.onSuccess}
              companySubscriptionId={subscription.id}
            />
          ),
        })}

        {showAddOverride && ModalCreator({
          title: "Add Employee Override",
          showModal: showAddOverride,
          showFooter: false,
          onOkay: () => this.setState({ showAddOverride: false }),
          toggleModal: () => this.setState({ showAddOverride: false }),
          inscription: (
            <CustomerVestingRuleUI
              companySubscriptionId={subscription.id}
              companyPetraId={this.props.companyPetraId}
              employees={employees}
              toggleModal={() => this.setState({ showAddOverride: false })}
              onSuccess={async () => {
                this.setState({ showAddOverride: false });
                await this.props.onSuccess();
              }}
            />
          ),
        })}

        <div style={{ marginBottom: 24 }}>
          <Row justify="space-between" align="middle" style={{ marginBottom: 12 }}>
            <Typography.Title level={5} style={{ margin: 0 }}>Company Default Rule</Typography.Title>
            <Button className="base-button" onClick={() => this.setState({ showRuleForm: true })}>
              {vestingRule ? "Edit Rule" : "Set Rule"}
            </Button>
          </Row>
          {vestingRule ? (
            <div style={{ background: "#f5f5f5", borderRadius: 6, padding: "12px 16px" }}>
              <Row gutter={16}>
                <Col span={8}>
                  <span style={{ color: "#888", fontSize: 12 }}>TYPE</span>
                  <div>
                    <Tag color={vestingRule.vestingType === "flat_percentage" ? "blue" : "purple"}>
                      {vestingRule.vestingType === "flat_percentage" ? "Flat Percentage" : "Year Schedule"}
                    </Tag>
                  </div>
                </Col>
                {vestingRule.vestingType === "flat_percentage" && vestingRule.flatPercentage != null && (
                  <Col span={8}>
                    <span style={{ color: "#888", fontSize: 12 }}>PERCENTAGE</span>
                    <div style={{ fontWeight: 500 }}>{vestingRule.flatPercentage}%</div>
                  </Col>
                )}
                {vestingRule.vestingDateType && (
                  <Col span={8}>
                    <span style={{ color: "#888", fontSize: 12 }}>VESTING DATE</span>
                    <div style={{ fontWeight: 500 }}>{formatSnakeCase(vestingRule.vestingDateType)}</div>
                  </Col>
                )}
              </Row>
            </div>
          ) : (
            <p style={{ color: "#888", margin: 0 }}>No default vesting rule has been set for this subscription.</p>
          )}
        </div>

        <Divider />

        <div>
          <Row justify="space-between" align="middle" style={{ marginBottom: 12 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <Typography.Title level={5} style={{ margin: 0 }}>Employee Overrides</Typography.Title>
              {overrides.length > 0 && (
                <Tag color="purple">{overrides.length} override{overrides.length !== 1 ? "s" : ""}</Tag>
              )}
            </div>
            <EntitledSection entitlement={entitlements.RedemptionRequests.edit}>
              <Button className="base-button" onClick={() => this.setState({ showAddOverride: true })}>
                Add Override
              </Button>
            </EntitledSection>
          </Row>

          {overrides.length === 0 && !showAddOverride && (
            <p style={{ color: "#888", margin: 0 }}>No employee overrides for this subscription.</p>
          )}

          {overrides.length > 0 && (
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ borderBottom: "1px solid #f0f0f0" }}>
                  {["PETRA ID", "NAME", "VESTING TYPE", "AMOUNT"].map((h) => (
                    <th key={h} style={{ textAlign: "left", padding: "8px 0", color: "#888", fontWeight: 500, fontSize: 12 }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {overrides.map((override) => {
                  const customer = override.customer ?? employeeMap.get(override.customerId);
                  return (
                    <tr key={override.id} style={{ borderBottom: "1px solid #f9f9f9" }}>
                      <td style={{ padding: "10px 0", paddingRight: 16 }}>
                        {customer ? (
                          <NavLink to={`/customers/${override.customerId}`}>
                            {customer.petraId}
                          </NavLink>
                        ) : (
                          override.customerId
                        )}
                      </td>
                      <td style={{ padding: "10px 0", paddingRight: 16 }}>
                        {customer
                          ? `${customer.firstName} ${customer.lastName}`
                          : "—"}
                      </td>
                      <td style={{ padding: "10px 0", paddingRight: 16 }}>
                        <Tag color={override.vestingType === "flat_percentage" ? "blue" : "purple"}>
                          {override.vestingType === "flat_percentage" ? "Flat Percentage" : "Year Schedule"}
                        </Tag>
                      </td>
                      <td style={{ padding: "10px 0" }}>
                        {override.vestingType === "flat_percentage" ? `${override.flatPercentage}%` : "Schedule"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>
    );
  }
}

export default class ViewCompany extends React.Component<Props, State> {
  reference: RefObject<FormInstance>;
  noteReference: RefObject<FormInstance>;
  ticketReference: RefObject<FormInstance>;
  statementReference: RefObject<FormInstance>;
  portReference: RefObject<FormInstance>;
  subscriptionEditReference: RefObject<FormInstance>;
  newCompanyContactPersonFormReference: RefObject<FormInstance>;
  newCompanyDirectorFormReference: RefObject<FormInstance>;
  newCompanyDirectorContactFormReference: RefObject<FormInstance>;
  contactEmailReference: RefObject<FormInstance>;
  contactPhoneReference: RefObject<FormInstance>;
  contactAddressReference: RefObject<FormInstance>;
  docsReference: RefObject<FormInstance>;
  companyEditReference: RefObject<FormInstance>;
  companyPaymentModalRef: RefObject<CompanyOnboardingDetails>;
  addIntervalReference: RefObject<FormInstance>;

  constructor(props: Readonly<Props>) {
    super(props);
    this.state = {
      isEditingInteraction: false,
      interactionsChangeLogs: [],
      activeDrawerContent: "",
      showDrawer: false,
      isFiltering: false,
      filterBy: "",
      layoutConfig: {
        layout: "horizontal",
        mainContainer: { span: 24 },
        logContainer: { span: 11, offset: 1 },
      },
      filteredChangelogs: [],
      showChangeLog: false,
      changeLogs: [],
      payments: [],
      schedules: [],
      countries: [],
      company: undefined,
      isLoading: true,
      id: this.props.match.params.id,
      contributions: [],
      contributionsLoader: false,
      activities: [],
      currentSubscriptionId: "",
      showStatementModal: false,
      isStatementLoading: false,
      generatedStatementUrl: undefined,
      attachmentIds: [],
      attachments: [],
      tickets: [],
      canCreateTicket: false,
      isTicketLoading: false,
      ports: [],
      showAccountMergerModal: false,
      selectedCompanies: [],
      companySearchQuery: "",
      companies: [],
      isSearchingForCompany: false,
      isMerging: false,
      showInteractionModal: false,
      isCreateInteractionLoading: false,
      showAddDocumentModal: false,
      showDeleteConfirmationModal: false,
      modalTarget: null,
      hasLoadedContributions: [],
      loadedCountries: false,
      loadedAudits: false,
      notifierRecords: [],
      redemptionRequests: [],
      transferRequests: [],
      loadedNotifierRecords: false,
      activitiesCount: 0,
      activitiesPage: 1,
      areInteractionsLoading: false,
      contactPersons: [],
      currentRequestsToProcess: 0,
      currentEmployeesPage: 1,
      formerEmployeesPage: 1,
      phoenixTickets: [],
      contributionsPagination: [],
      showConfirmProductDelete: false,
      subscriptionIdToDelete: undefined,
      showSubscriptionEditModal: false,
      subscriptionToEdit: undefined,
      isSavingSubscriptionEdits: false,
      relationshipManagers: [],
      relationshipManagerSearchTerm: "",
      salesPersons: [],
      salesPersonSearchTerm: "",
      numberPerPage: 25,
      companyStatements: [],
      companySubscriptions: [],
      disableCreateInteractionButton: false,
      isReversingMerge: false,
      isBulkReversingMerge: false,
      showReverseMergeModal: false,
      companyInteractionAttachments: [],
      allCompanyTags: [],
      companyClosedIntervals: [],
      showAddIntervalModal: false,
      intervalFormSession: 0,
      isSubmittingInterval: false,
      isLoadingCompanyTags: false,
      productTags: [],
      showCompanyContactModal: false,
      showCompanyDirectorModal: false,
      showCompanyDirectorContactModal: false,
      showCompanyContactDeleteModal: false,
      currentCompanyContact: undefined,
      currentCompanyDirector: undefined,
      companyContactFieldsToHide: ["customerId"],
      contactLevels: [],
      customers: [],
      customerSearchTerm: "",
      isExistingCustomer: false,
      contactPersonRequired: false,
      documentUrl: "",
      showContactModal: false,
      showContactDeleteModal: false,
      contactModalType: null,
      contactModalMode: "add",
      contactModalLoading: false,
      deleteContactType: null,
      deleteContactId: null,
      selectedEmail: null,
      selectedPhone: null,
      selectedAddress: null,
      addressType: AssociatedEntityConstants.PhysicalAddressCode,
      financialInstitutions: [],
      branchMap: {},
      showCompanyEditModal: false,
      isCompanyEditSaving: false,
      industrySectors: [],
      trustees: [],
      showCompanyPaymentModal: false,
      showCompanyDirectorDeleteModal: false,
      directorToDelete: undefined,
      selectedReturnedChequePayment: null,
      returnedChequePreview: null,
      isReturnedChequePreviewLoading: false,
      isSendingReturnedCheque: false,
      paymentStatusFilter: "all",
    };

    this.noteReference = React.createRef<FormInstance>();
    this.ticketReference = React.createRef<FormInstance>();
    this.reference = React.createRef<FormInstance>();
    this.statementReference = React.createRef<FormInstance>();
    this.portReference = React.createRef<FormInstance>();
    this.subscriptionEditReference = React.createRef<FormInstance>();
    this.newCompanyContactPersonFormReference = React.createRef<FormInstance>();
    this.newCompanyDirectorFormReference = React.createRef<FormInstance>();
    this.newCompanyDirectorContactFormReference =
      React.createRef<FormInstance>();
    this.contactEmailReference = React.createRef<FormInstance>();
    this.contactPhoneReference = React.createRef<FormInstance>();
    this.contactAddressReference = React.createRef<FormInstance>();
    this.docsReference = React.createRef<FormInstance>();
    this.companyEditReference = React.createRef<FormInstance>();
    this.companyPaymentModalRef = React.createRef<CompanyOnboardingDetails>();
    this.addIntervalReference = React.createRef<FormInstance>();

    this.paginatedResourceNextPage = this.paginatedResourceNextPage.bind(this);
    this.contributionsNextPage = this.contributionsNextPage.bind(this);
  }

  setEntityToBeDeleted = (modalTarget: string): void => {
    this.setState({ modalTarget });
  };

  toggleDeleteConfirmationModal = (id?: string): void => {
    this.setState((prevState) => ({
      showDeleteConfirmationModal:
        id !== undefined ? true : !prevState.showDeleteConfirmationModal,
      idToBeDeleted:
        id !== undefined
          ? id
          : prevState.showDeleteConfirmationModal
            ? undefined
            : prevState.idToBeDeleted,
    }));
  };

  deleteFile = async (id: string): Promise<void> => {
    this.setState({ isLoading: true });
    try {
      const response = await request({
        query: DELETE_FILE,
        variables: { id },
      });
      const { mutation } = responseHandler<{ result: boolean; errors: APIError[] }>(response, "deleteFileUpload");
      if (mutation.result) {
        message.success("File deleted successfully");
        await this.getCompany();
      } else {
        message.error("Failed to delete file");
      }
    } catch (error) {
      message.error("Failed to delete a file");
      console.error(error);
    } finally {
      this.setState({ isLoading: false });
      this.toggleDeleteConfirmationModal();
    }
  };

  deleteSignedApplicationForm = async (): Promise<void> => {
    const { idToBeDeleted } = this.state;
    if (idToBeDeleted) {
      await this.deleteFile(idToBeDeleted);
    }
  };

  deleteVestingRuleDocument = async (): Promise<void> => {
    const { idToBeDeleted } = this.state;
    if (idToBeDeleted) {
      await this.deleteFile(idToBeDeleted);
    }
  };

  deleteEmployeeDatasheet = async (): Promise<void> => {
    const { idToBeDeleted } = this.state;
    if (idToBeDeleted) {
      await this.deleteFile(idToBeDeleted);
    }
  };

  deleteNPRAForm = async (): Promise<void> => {
    const { idToBeDeleted } = this.state;
    if (idToBeDeleted) {
      await this.deleteFile(idToBeDeleted);
    }
  };

  deleteCompanyDocument = async (): Promise<void> => {
    this.state.company?.companyInfoFileUploads && await this.deleteFile(this.state.idToBeDeleted ?? "");
  };

  async paginatedResourceNextPage(
    page: number,
    paginatedResponse: PaginatedResourcePageSelected,
    numberPerPage: number,
  ): Promise<void> {
    switch (paginatedResponse) {
      case PaginatedResourcePageSelected.currentEmployees:
        this.setState(
          { isLoading: true, currentEmployeesPage: page, numberPerPage },
          () => {
            this.getCompany();
          },
        );
        break;

      case PaginatedResourcePageSelected.formerEmployees:
        this.setState(
          { isLoading: true, formerEmployeesPage: page, numberPerPage },
          () => {
            this.getCompany();
          },
        );
        break;

      default:
        break;
    }
  }

  toggleInteractionEdit = (): void => {
    this.setState({ isEditingInteraction: !this.state.isEditingInteraction });
  };

  toggleTicketCreate = (): void => {
    this.setState({ canCreateTicket: !this.state.canCreateTicket });
  };

  toggleConfirmProductDelete = (
    subscriptionIdToDelete: string | undefined,
  ): void => {
    if (subscriptionIdToDelete !== undefined) {
      this.setState(
        {
          subscriptionIdToDelete,
        },
        () => {
          this.setState({
            showConfirmProductDelete: !this.state.showConfirmProductDelete,
          });
        },
      );
    } else {
      this.setState({
        showConfirmProductDelete: !this.state.showConfirmProductDelete,
      });
    }
  };

  setNoteRef = (ref: React.RefObject<FormInstance>): void => {
    this.noteReference = ref;
  };

  setTicketRef = (ref: React.RefObject<FormInstance>): void => {
    this.ticketReference = ref;
  };

  setStatementRef = (ref: React.RefObject<FormInstance>): void => {
    this.statementReference = ref;
  };

  setPortRef = (ref: React.RefObject<FormInstance>): void => {
    this.portReference = ref;
  };

  filterLogs = (e: React.ChangeEvent<HTMLInputElement>): void => {
    e.persist();
    const matches: Changelog[] = [];
    const alreadyMatched: { [x: string]: boolean } = {};
    const filterBy: string = e.target.value.toLowerCase();
    if (filterBy.length === 0) {
      return this.setState({
        filterBy,
        isFiltering: false,
        filteredChangelogs: [],
      });
    }

    const parts = filterBy.split(" ");
    for (const log of this.state.changeLogs) {
      for (const part of parts) {
        if (
          !alreadyMatched[log.auditItem] &&
          part !== "" &&
          `${log.auditItem.toLowerCase()} ${log.createdAt
            .substring(0, log.createdAt.length - 3)
            .toLowerCase()}`.includes(part)
        ) {
          matches.push(log);
          alreadyMatched[log.auditItem] = true;
        }
      }
    }

    this.setState({ filterBy, isFiltering: true, filteredChangelogs: matches });
  };

  getAllPorts = (): void => {
    request({
      query: ALL_PORTS_QUERY,
    }).then(({ data: { data } }: any): void => {
      this.setState({
        ports: data.ports,
        isLoading: false,
      });
    });
  };

  toggleChangeLogView = (): void => {
    this.setState({ showChangeLog: !this.state.showChangeLog }, (): void => {
      this.dynamicallyResize();
    });
  };

  createInteraction = async (): Promise<void> => {
    console.log("Just an empty function for now");
  };

  setRef = (ref: React.RefObject<FormInstance>): void => {
    this.reference = ref;
  };

  setPercentage = (_percentage: number): void => {
    console.log(_percentage);
  };

  emptyFunction = (): void => {
    console.log("emptyFunction");
  };

  anotherEmptyFunction = (): string => "";

  redirectToAllCompaniesPage = (): void => {
    this.props.history.push("/companies");
  };

  dynamicallyResize = (): void => {
    const defaultConfig: LayoutConfig = {
      layout: "horizontal",
      mainContainer: { span: 13 },
      logContainer: { span: 10, offset: 1 },
    };

    if (this.state.showChangeLog) {
      return this.setState({
        layoutConfig: {
          layout: "vertical",
          mainContainer: { span: 8 },
          logContainer: { span: 15, offset: 1 },
        },
      });
    }

    this.setState({ layoutConfig: defaultConfig });
  };

  interactionsNextPage = async (page: number): Promise<void> => {
    this.setState({
      areInteractionsLoading: true,
      activitiesPage: page,
    });
    return await this.getCompanyInteractions();
  };

  deleteCompanySubscription = async (subscriptionId: string): Promise<void> => {
    interface Response {
      result: boolean;
    }

    this.setState({ isLoading: true });

    try {
      const response: AxiosResponse = await request({
        query: DELETE_COMPANY_SUBSCRIPTION,
        variables: { id: subscriptionId },
      });

      const { err, mutation } = responseHandler<Response>(
        response,
        "deleteCompanySubscription",
      );

      if (err) {
        message.error(generateDisplayErrorMessage(err));
      }

      if (mutation.result) {
        message.success("Product deleted from customer");
        this.toggleConfirmProductDelete(undefined);
        this.getCompany();
      }
    } catch (error) {
      message.error(`failed to delete product - ${generateDisplayErrorMessage(error)}`);
      Sentry.captureException(error);
    }

    this.setState({ isLoading: false });
  };

  getCompanyInteractions = (): void => {
    const { id: companyId, activitiesPage } = this.state;
    this.setState({ areInteractionsLoading: true });

    request({
      query: GET_COMPANY_INTERACTIONS_QUERY,
      variables: { companyId, page: activitiesPage.toString() },
    })
      .then(
        ({
          data,
        }: AxiosResponse<{
          data: {
            interactionsForCompany: {
              count: number;
              results: Activity[];
            };
          };
        }>): void => {
          const interactions = data.data.interactionsForCompany.results;

          const allAttachments = interactions.flatMap(
            (interaction) => interaction.companyInteractionAttachments || [],
          );

          this.setState({
            activities: interactions,
            activitiesCount: data.data.interactionsForCompany.count,
            notes: interactions?.[0]?.notes,
            companyInteractionAttachments: allAttachments,
          });
        },
      )
      .finally((): void => {
        this.setState({ areInteractionsLoading: false });
      });
  };

  getChangeLog = (): void => {
    if (this.state.loadedAudits) return;
    interface Response {
      data: {
        companyChangeLogs: Changelog[];
      };
    }

    this.setState({
      isLoading: true,
    });
    request({
      query: GET_COMPANY_CHANGELOG,
      variables: {
        companyId: this.state.id,
      },
    }).then(({ data }: AxiosResponse<Response>): void => {
      this.setState({
        changeLogs: data.data.companyChangeLogs,
        loadedAudits: true,
        isLoading: false,
      });
    });
  };

  getInteractionChangeLog = (companyInteractionId: string): void => {
    interface Response {
      data: {
        companyInteractionChangeLogs: Changelog[];
      };
    }
    request({
      query: GET_COMPANY_INTERACTION_CHANGELOG,
      variables: {
        companyInteractionId,
      },
    }).then(({ data }: AxiosResponse<Response>): void => {
      this.setState({
        interactionsChangeLogs: data.data.companyInteractionChangeLogs,
      });
    });
  };

  getCountries = (): void => {
    if (this.state.loadedCountries) return;
    interface Response {
      data: {
        countries: Country[];
      };
    }
    request({
      query: GET_COUNTRIES,
    }).then(({ data }: AxiosResponse<Response>): void => {
      this.setState({ countries: data.data.countries, loadedCountries: true });
    });
  };

  getCompany = async (): Promise<void> => {
    const {
      id: companyId,
      currentEmployeesPage,
      formerEmployeesPage,
      numberPerPage,
    } = this.state;

    this.setState({ isLoading: true });

    try {
      const response = await request({
        query: GET_COMPANY_QUERY,
        variables: {
          companyId,
          associationNameOne: "current_employees",
          customerPageOne: currentEmployeesPage,
          associationNameTwo: "former_employees",
          customerPageTwo: formerEmployeesPage,
          numberPerPage,
        },
      });

      const {
        data,
      }: AxiosResponse<{
        data: {
          company: Company;
        };
      }> = response;

      if (data.data.company) {
        this.setState({
          company: data.data.company,
          contactPersons: data.data.company.companyContacts,
          companySubscriptions: data.data.company.companySubscriptions,
        });
      } else {
        message.error("Failed to fetch company");
        this.redirectToAllCompaniesPage();
      }
    } catch (error) {
      message.error(`An error occurred while fetching company - ${generateDisplayErrorMessage(error)}`);
      Sentry.captureException(error);
      this.redirectToAllCompaniesPage();
    } finally {
      this.setState({ isLoading: false });
    }
  };

  getCompanySubscriptions = async (): Promise<void> => {
    const { id: companyId } = this.state;

    this.setState({ isLoading: true });

    try {
      const response = await request({
        query: GET_COMPANY_SUBSCRIPTIONS,
        variables: {
          companyId,
        },
      });

      const {
        data,
      }: AxiosResponse<{
        data: {
          company: Company;
        };
      }> = response;

      if (data.data.company) {
        const newSubscriptions = data.data.company.companySubscriptions ?? [];
        const { currentSubscription } = this.state;
        this.setState({
          companySubscriptions: newSubscriptions,
          currentSubscription: currentSubscription
            ? newSubscriptions.find((s) => s.id === currentSubscription.id) ?? currentSubscription
            : currentSubscription,
        });
      } else {
        message.error("Failed to fetch company subscriptions");
      }
    } catch (error) {
      message.error(`An error occurred while fetching company subscriptions - ${generateDisplayErrorMessage(error)}`);
      Sentry.captureException(error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  getCompanyNotifications = (): void => {
    if (this.state.loadedNotifierRecords) return;
    const { id: companyId } = this.state;
    this.setState({ isLoading: true });
    request({
      query: GET_COMPANY_NOTIFICATIONS,
      variables: { companyId },
    }).then(
      ({
        data,
      }: AxiosResponse<{
        data: {
          company: Company;
        };
      }>): void => {
        if (data.data.company) {
          this.setState({
            notifierRecords: data.data.company.notifierRecords,
            isLoading: false,
            loadedNotifierRecords: true,
          });
        } else {
          this.redirectToAllCompaniesPage();
        }
      },
    );
  };

  getCompanyTransfers = (): void => {
    const { id: companyId } = this.state;
    this.setState({ isLoading: true });
    request({
      query: GET_COMPANY_TRANSFER_REQUESTS,
      variables: { companyId },
    })
      .then(
        ({
          data,
        }: AxiosResponse<{
          data: {
            company: Company;
          };
        }>): void => {
          if (data.data.company) {
            this.setState({
              transferRequests: data.data.company.transferRequests,
            });
          } else {
            this.redirectToAllCompaniesPage();
          }
        },
      )
      .catch((error): void => {
        Sentry.captureException(error);
        message.error("Failed to load transfer requests");
      })
      .finally((): void => {
        this.setState({ isLoading: false });
      });
  };

  getCompanyStatements = (): void => {
    const { id: companyId } = this.state;
    this.setState({ isLoading: true });
    request({
      query: GET_COMPANY_STATEMENTS,
      variables: { companyId },
    })
      .then(
        ({
          data,
        }: AxiosResponse<{
          data: {
            getCompanyStatements: CompanyStatement[];
          };
        }>): void => {
          this.setState({
            companyStatements: data.data?.getCompanyStatements,
          });
        },
      )
      .finally((): void => {
        this.setState({
          isLoading: false,
        });
      });
  };

  handleCompanyStatementsData = async (
    key: string | string[],
  ): Promise<void> => {
    if (key === "companyStatements") {
      this.getCompanyStatements();
    }
  };

  getCompanyRedemptions = (): void => {
    const { id: companyId } = this.state;
    this.setState({ isLoading: true });
    request({
      query: GET_COMPANY_REDEMPTION_REQUESTS,
      variables: { companyId },
    }).then(
      ({
        data,
      }: AxiosResponse<{
        data: {
          company: Company;
        };
      }>): void => {
        if (data.data.company) {
          this.setState({
            redemptionRequests: data.data.company.redemptionRequests,
            isLoading: false,
          });
        } else {
          this.redirectToAllCompaniesPage();
        }
      },
    );
  };

  getFundCodeInformation = (key: string) => {
    return this.state.contributionsPagination.find(
      (item) => item.fundCode === key,
    );
  };

  getContributionData = async (key: string | string[]): Promise<void> => {
    if (typeof key === "string") {
      await this.getCompanyContributions(key, 1);
    }
  };

  async contributionsNextPage(page: number, fundCode: string): Promise<void> {
    const { contributionsPagination: oldPaginationInfo } = this.state;
    const newPaginationInfo = oldPaginationInfo.map((item) => {
      if (item.fundCode === fundCode) {
        return { ...item, page };
      } else {
        return { ...item };
      }
    });
    this.setState(
      { isLoading: true, contributionsPagination: newPaginationInfo },
      () => {
        this.getCompanyContributions(
          fundCode,
          oldPaginationInfo.find((item) => item.fundCode === fundCode)?.page ??
            1,
        );
      },
    );
  }

  getSchedulesPaymentsRequestsData = async (
    key: string | string[],
  ): Promise<void> => {
    if (key === "payments") await this.getCompanyPayments();
    if (key === "schedules") await this.getSchedules();
    if (key === "redemptionRequests") await this.getCompanyRedemptions();
    if (key === "transferRequests") this.getCompanyTransfers();
    if (key === "phoenixTickets") await this.getPhoenixTickets();
  };

  getCompanyContributions = (fundCode: string, page: number): void => {
    const {
      company,
      hasLoadedContributions,
      contributions,
      contributionsPagination,
    } = this.state;

    const currentFundCodePaginationInfo = this.getFundCodeInformation(fundCode);

    if (
      hasLoadedContributions.includes(fundCode) &&
      currentFundCodePaginationInfo?.page === page
    )
      return;

    this.setState({ contributionsLoader: true });
    request({
      query: GET_COMPANY_CONTRIBUTIONS,
      variables: {
        petraId: company?.petraId,
        fundCode,
        page: currentFundCodePaginationInfo?.page ?? 1,
      },
    })
      .then(
        ({
          data,
        }: AxiosResponse<{
          data: {
            clientContributions: {
              count: number;
              results: Contribution[];
            };
          };
        }>): void => {
          if (data.data.clientContributions) {
            const newPagination = currentFundCodePaginationInfo
              ? contributionsPagination.map((item) => {
                  if (item.fundCode === fundCode) {
                    return {
                      ...item,
                      total: data.data.clientContributions.count,
                    };
                  } else {
                    return { ...item };
                  }
                })
              : [
                  {
                    fundCode,
                    page: 1,
                    total: data.data.clientContributions.count,
                  },
                ];

            this.setState({
              contributions: [
                ...contributions.filter((item) => item.shareClass !== fundCode),
                ...data.data.clientContributions.results,
              ],
              isLoading: false,
              contributionsPagination: newPagination,
            });
          } else {
            this.redirectToAllCompaniesPage();
          }
        },
      )
      .finally((): void => {
        const newHasLoadedContributions = hasLoadedContributions;
        newHasLoadedContributions.push(fundCode);

        this.setState({
          contributionsLoader: false,
          hasLoadedContributions: newHasLoadedContributions,
        });
      });
  };

  openCompanyEditModal = (): void => {
    this.getIndustrySectors();
    this.getTrusteesSummary();
    this.getAllRelationshipManagers();
    this.setState({ showCompanyEditModal: true });
  };

  closeCompanyEditModal = (): void => {
    this.setState({ showCompanyEditModal: false });
  };

  getIndustrySectors = async (): Promise<void> => {
    try {
      const response: AxiosResponse = await request({
        query: GET_INDUSTRY_SECTORS,
      });
      const {
        data: { industrySectors },
      } = response.data;
      this.setState({ industrySectors: industrySectors || [] });
    } catch (error) {
      message.error("Failed to load industry sectors");
      Sentry.captureException(error);
    }
  };

  getTrusteesSummary = async (): Promise<void> => {
    try {
      const response: AxiosResponse = await request({
        query: GET_TRUSTEES_SUMMARY,
      });
      const {
        data: { trustees },
      } = response.data;
      this.setState({ trustees: trustees || [] });
    } catch (error) {
      message.error("Failed to load trustees");
      Sentry.captureException(error);
    }
  };

  saveCompanyEdit = async (): Promise<void> => {
    const { company } = this.state;
    if (!company || !this.companyEditReference.current) {
      return;
    }

    const fieldsToBeValidated = [
      "name",
      "tinNumber",
      "industrySectorId",
      "numberOfEmployees",
      "trusteeId",
      "relationshipManagerId",
      "ssnitNumber",
      "rocNumber",
      "dateOfEstablishment",
      "companySegment",
    ];

    let data;
    try {
      data = await this.companyEditReference.current.validateFields(
        fieldsToBeValidated,
      );
    } catch (error) {
      handleValidationErrors(error);
      return;
    }

    this.setState({ isCompanyEditSaving: true });
    try {
      const response: AxiosResponse = await request({
        query: UPDATE_COMPANY_MUTATION,
        variables: {
          companyId: company.id,
          name: data.name,
          tinNumber: data.tinNumber || null,
          industrySectorId: data.industrySectorId || null,
          numberOfEmployees:
            data.numberOfEmployees !== undefined && data.numberOfEmployees !== null
              ? Number(data.numberOfEmployees)
              : null,
          trusteeId: data.trusteeId || null,
          relationshipManagerId: data.relationshipManagerId || null,
          ssnitNumber: data.ssnitNumber || null,
          rocNumber: data.rocNumber || null,
          dateOfEstablishment: data.dateOfEstablishment
            ? moment(data.dateOfEstablishment).format("YYYY-MM-DD")
            : null,
          companySegment: data.companySegment || null,
        },
      });

      const { err } = responseHandler(response, "updateCompany");
      if (err) {
        message.error("Failed to update company details");
      } else {
        message.success("Company details updated successfully");
        this.closeCompanyEditModal();
        this.getCompany();
      }
    } catch (error) {
      message.error("Failed to update company details");
      Sentry.captureException(error);
    } finally {
      this.setState({ isCompanyEditSaving: false });
    }
  };

  getFinancialInstitutions = async (): Promise<void> => {
    interface Response {
      data: {
        financialInstitutions: FinancialInstitution[];
      };
    }

    try {
      const {
        data: { data },
      }: AxiosResponse<Response> = await request({
        query: GET_FINANCIAL_INSTITUTIONS,
      });

      const financialInstitutions = data.financialInstitutions || [];
      const branchMap: BranchMap = {};
      financialInstitutions.forEach((institution) => {
        branchMap[institution.id] = institution.bankBranches;
      });

      this.setState({ financialInstitutions, branchMap });
    } catch (error) {
      message.error("Failed to get financial institutions");
      Sentry.captureException(error);
    }
  };

  openPaymentAccountsModal = async (
    account?: PaymentAccount,
  ): Promise<void> => {
    if (!this.state.financialInstitutions.length) {
      await this.getFinancialInstitutions();
    }

    this.setState({ showCompanyPaymentModal: true }, () => {
      this.companyPaymentModalRef.current?.resetState();
      this.companyPaymentModalRef.current?.setCurrentlyEditing(
        "payout",
        account,
      );
    });
  };

  closePaymentAccountsModal = (): void => {
    this.companyPaymentModalRef.current?.resetState();
    this.setState({ showCompanyPaymentModal: false });
  };

  openContactModal = (
    type: "email" | "phone" | "address",
    mode: "add" | "edit",
    record?: AssociatedEmail | AssociatedPhone | AssociatedAddress,
  ): void => {
    const nextState: Partial<State> = {
      showContactModal: true,
      contactModalType: type,
      contactModalMode: mode,
    };

    if (type === "email") {
      nextState.selectedEmail = (record as AssociatedEmail) || null;
    } else if (type === "phone") {
      nextState.selectedPhone = (record as AssociatedPhone) || null;
    } else {
      this.getCountries();
      nextState.selectedAddress = (record as AssociatedAddress) || null;
      if (record && (record as AssociatedAddress).address?.isPostalBox) {
        nextState.addressType = AssociatedEntityConstants.PostalAddressCode;
      } else {
        nextState.addressType = AssociatedEntityConstants.PhysicalAddressCode;
      }
    }

    this.resetContactForm(type);
    this.setState(nextState as State);
  };

  resetContactForm = (type: "email" | "phone" | "address"): void => {
    const reference =
      type === "email"
        ? this.contactEmailReference
        : type === "phone"
        ? this.contactPhoneReference
        : this.contactAddressReference;

    reference.current?.resetFields();
  };

  closeContactModal = (): void => {
    this.setState({ showContactModal: false });
  };

  openDeleteContactModal = (
    type: "email" | "phone" | "address",
    id: string,
  ): void => {
    this.setState({
      showContactDeleteModal: true,
      deleteContactType: type,
      deleteContactId: id,
    });
  };

  closeDeleteContactModal = (): void => {
    this.setState({
      showContactDeleteModal: false,
      deleteContactType: null,
      deleteContactId: null,
    });
  };

  handleAddressTypeChange = (value: string): void => {
    this.setState({ addressType: value });
  };

  saveContactEmail = async (): Promise<void> => {
    const { company, selectedEmail, contactModalMode } = this.state;
    if (!company || !this.contactEmailReference.current) return;

    const fieldsToBeValidated = ["email"];
    let data;
    try {
      data = await this.contactEmailReference.current.validateFields(
        fieldsToBeValidated,
      );
    } catch (error) {
      handleValidationErrors(error);
      return;
    }

    this.setState({ contactModalLoading: true });

    try {
      const response: AxiosResponse = await request({
        query: CREATE_EMAIL,
        variables: { address: data.email },
      });

      const { err, handled, mutation } = responseHandler<{
        email: EmailInterface;
        errors: APIError[];
      }>(response, "createEmail");

      if (handled) {
        message.error("An Error Occurred");
        return;
      } else if (err) {
        this.contactEmailReference.current.setFields(
          err.map(mapAPIErrorToFormError),
        );
        message.error(generateDisplayErrorMessage(err));
        return;
      }

      if (!mutation.email) {
        message.error("Email Creation Failed");
        return;
      }

      if (contactModalMode === "edit" && selectedEmail) {
        const updateResponse: AxiosResponse = await request({
          query: UPDATE_COMPANY_EMAIL,
          variables: {
            companyEmailId: selectedEmail.id,
            companyId: company.id,
            emailId: mutation.email.id,
          },
        });

        const { err: updateErr } = responseHandler(
          updateResponse,
          "updateCompanyEmail",
        );
        if (updateErr) {
          message.error(generateDisplayErrorMessage(updateErr));
          return;
        }
      } else {
        const assignResponse: AxiosResponse = await request({
          query: ASSIGN_EMAIL_TO_COMPANY,
          variables: { emailId: mutation.email.id, companyId: company.id },
        });

        const { err: assignErr } = responseHandler(
          assignResponse,
          "assignEmailToCompany",
        );
        if (assignErr) {
          message.error(generateDisplayErrorMessage(assignErr));
          return;
        }
      }

      message.success(
        contactModalMode === "edit"
          ? "Email updated successfully"
          : "Email added successfully",
      );
      this.closeContactModal();
      this.getCompany();
    } catch (error) {
      message.error("Email action failed");
      Sentry.captureException(error);
    } finally {
      this.setState({ contactModalLoading: false });
    }
  };

  saveContactPhone = async (): Promise<void> => {
    const { company, selectedPhone, contactModalMode } = this.state;
    if (!company || !this.contactPhoneReference.current) return;

    const fieldsToBeValidated = ["phone"];
    let data;
    try {
      data = await this.contactPhoneReference.current.validateFields(
        fieldsToBeValidated,
      );
    } catch (error) {
      handleValidationErrors(error);
      return;
    }

    this.setState({ contactModalLoading: true });

    try {
      const response: AxiosResponse = await request({
        query: CREATE_PHONE,
        variables: { number: data.phone },
      });

      const { err, handled, mutation } = responseHandler<{
        phone: PhoneInterface;
        errors: APIError[];
      }>(response, "createPhone");

      if (handled) {
        message.error("An Error Occurred");
        return;
      } else if (err) {
        this.contactPhoneReference.current.setFields(
          err.map(mapAPIErrorToFormError),
        );
        message.error(generateDisplayErrorMessage(err));
        return;
      }

      if (!mutation.phone) {
        message.error("Phone Creation Failed");
        return;
      }

      if (contactModalMode === "edit" && selectedPhone) {
        const updateResponse: AxiosResponse = await request({
          query: UPDATE_COMPANY_PHONE,
          variables: {
            companyPhoneId: selectedPhone.id,
            companyId: company.id,
            phoneId: mutation.phone.id,
          },
        });

        const { err: updateErr } = responseHandler(
          updateResponse,
          "updateCompanyPhone",
        );
        if (updateErr) {
          message.error(generateDisplayErrorMessage(updateErr));
          return;
        }
      } else {
        const assignResponse: AxiosResponse = await request({
          query: ASSIGN_PHONE_TO_COMPANY,
          variables: { phoneId: mutation.phone.id, companyId: company.id },
        });

        const { err: assignErr } = responseHandler(
          assignResponse,
          "assignPhoneToCompany",
        );
        if (assignErr) {
          message.error(generateDisplayErrorMessage(assignErr));
          return;
        }
      }

      message.success(
        contactModalMode === "edit"
          ? "Phone updated successfully"
          : "Phone added successfully",
      );
      this.closeContactModal();
      this.getCompany();
    } catch (error) {
      message.error("Phone action failed");
      Sentry.captureException(error);
    } finally {
      this.setState({ contactModalLoading: false });
    }
  };

  saveContactAddress = async (): Promise<void> => {
    const { company, selectedAddress, contactModalMode, addressType } =
      this.state;
    if (!company || !this.contactAddressReference.current) return;

    const fieldsToBeValidated = [
      "streetName",
      "poBox",
      "city",
      "addressCountry",
      "addressType",
      "ghPost",
      "region",
    ];

    let data;
    try {
      data = await this.contactAddressReference.current.validateFields(
        fieldsToBeValidated,
      );
    } catch (error) {
      handleValidationErrors(error);
      return;
    }

    this.setState({ contactModalLoading: true });

    try {
      const response: AxiosResponse = await request({
        query: CREATE_ADDRESS,
        variables: {
          streetName: data.streetName,
          poBox: data.poBox,
          city: data.city,
          region: data.region,
          addressCountry: data.addressCountry,
          isPostalBox:
            addressType === AssociatedEntityConstants.PostalAddressCode,
          ghPost: data.ghPost?.length > 0 ? data.ghPost : undefined,
        },
      });

      const { err, handled, mutation } = responseHandler<{
        address: AddressInterface;
        errors: APIError[];
      }>(response, "createAddress");

      if (handled) {
        message.error("An Error Occurred");
        return;
      } else if (err) {
        this.contactAddressReference.current.setFields(
          err.map(mapAPIErrorToFormError),
        );
        message.error(generateDisplayErrorMessage(err));
        return;
      }

      if (!mutation.address) {
        message.error("Address Creation Failed");
        return;
      }

      if (contactModalMode === "edit" && selectedAddress) {
        const updateResponse: AxiosResponse = await request({
          query: UPDATE_COMPANY_ADDRESS,
          variables: {
            companyAddressId: selectedAddress.id,
            companyId: company.id,
            addressId: mutation.address.id,
          },
        });

        const { err: updateErr } = responseHandler(
          updateResponse,
          "updateCompanyAddress",
        );
        if (updateErr) {
          message.error(generateDisplayErrorMessage(updateErr));
          return;
        }
      } else {
        const assignResponse: AxiosResponse = await request({
          query: ASSIGN_ADDRESS_TO_COMPANY,
          variables: { addressId: mutation.address.id, companyId: company.id },
        });

        const { err: assignErr } = responseHandler(
          assignResponse,
          "assignAddressToCompany",
        );
        if (assignErr) {
          message.error(generateDisplayErrorMessage(assignErr));
          return;
        }
      }

      message.success(
        contactModalMode === "edit"
          ? "Address updated successfully"
          : "Address added successfully",
      );
      this.closeContactModal();
      this.getCompany();
    } catch (error) {
      message.error("Address action failed");
      Sentry.captureException(error);
    } finally {
      this.setState({ contactModalLoading: false });
    }
  };

  confirmDeleteContact = async (): Promise<void> => {
    const { company, deleteContactType, deleteContactId } = this.state;
    if (!company || !deleteContactType || !deleteContactId) return;

    this.setState({ contactModalLoading: true });
    try {
      let query = "";
      let mutationName = "";
      let variables: Record<string, string> = {};

      if (deleteContactType === "email") {
        query = UNASSIGN_EMAIL_FROM_COMPANY;
        mutationName = "unassignEmailFromCompany";
        variables = { companyEmailId: deleteContactId };
      } else if (deleteContactType === "phone") {
        query = UNASSIGN_PHONE_FROM_COMPANY;
        mutationName = "unassignPhoneFromCompany";
        variables = { companyPhoneId: deleteContactId };
      } else {
        query = UNASSIGN_ADDRESS_FROM_COMPANY;
        mutationName = "unassignAddressFromCompany";
        variables = { companyAddressId: deleteContactId };
      }

      const response: AxiosResponse = await request({
        query,
        variables,
      });

      const { err } = responseHandler(response, mutationName);
      if (err) {
        message.error(generateDisplayErrorMessage(err));
        return;
      }

      message.success("Deleted successfully");
      this.closeDeleteContactModal();
      this.getCompany();
    } catch (error) {
      message.error("Delete failed");
      Sentry.captureException(error);
    } finally {
      this.setState({ contactModalLoading: false });
    }
  };

  reactivateEmail = async (email: AssociatedEmail): Promise<void> => {
    const { company } = this.state;
    if (!company) return;

    this.setState({ contactModalLoading: true });
    try {
      const response: AxiosResponse = await request({
        query: ASSIGN_EMAIL_TO_COMPANY,
        variables: { emailId: email.email.id, companyId: company.id },
      });

      const { err } = responseHandler(response, "assignEmailToCompany");
      if (err) {
        message.error(generateDisplayErrorMessage(err));
        return;
      }

      message.success("Email reactivated successfully");
      this.getCompany();
    } catch (error) {
      message.error("Email reactivation failed");
      Sentry.captureException(error);
    } finally {
      this.setState({ contactModalLoading: false });
    }
  };

  reactivatePhone = async (phone: AssociatedPhone): Promise<void> => {
    const { company } = this.state;
    if (!company) return;

    this.setState({ contactModalLoading: true });
    try {
      const response: AxiosResponse = await request({
        query: ASSIGN_PHONE_TO_COMPANY,
        variables: { phoneId: phone.phone.id, companyId: company.id },
      });

      const { err } = responseHandler(response, "assignPhoneToCompany");
      if (err) {
        message.error(generateDisplayErrorMessage(err));
        return;
      }

      message.success("Phone number reactivated successfully");
      this.getCompany();
    } catch (error) {
      message.error("Phone reactivation failed");
      Sentry.captureException(error);
    } finally {
      this.setState({ contactModalLoading: false });
    }
  };

  reactivateAddress = async (address: AssociatedAddress): Promise<void> => {
    const { company } = this.state;
    if (!company) return;

    this.setState({ contactModalLoading: true });
    try {
      const response: AxiosResponse = await request({
        query: ASSIGN_ADDRESS_TO_COMPANY,
        variables: { addressId: address.address.id, companyId: company.id },
      });

      const { err } = responseHandler(response, "assignAddressToCompany");
      if (err) {
        message.error(generateDisplayErrorMessage(err));
        return;
      }

      message.success("Address reactivated successfully");
      this.getCompany();
    } catch (error) {
      message.error("Address reactivation failed");
      Sentry.captureException(error);
    } finally {
      this.setState({ contactModalLoading: false });
    }
  };

  markEmailAsPrimary = async (email: AssociatedEmail): Promise<void> => {
    this.setState({ contactModalLoading: true });
    try {
      const response: AxiosResponse = await request({
        query: MARK_COMPANY_EMAIL_AS_PRIMARY,
        variables: { emailId: email.id },
      });
      const { err } = responseHandler(response, "markCompanyEmailAsPrimary");
      if (err) {
        message.error(generateDisplayErrorMessage(err));
        return;
      }
      this.getCompany();
    } catch (error) {
      message.error("Failed to set email as primary");
      Sentry.captureException(error);
    } finally {
      this.setState({ contactModalLoading: false });
    }
  };

  markPhoneAsPrimary = async (phone: AssociatedPhone): Promise<void> => {
    this.setState({ contactModalLoading: true });
    try {
      const response: AxiosResponse = await request({
        query: MARK_COMPANY_PHONE_AS_PRIMARY,
        variables: { phoneId: phone.id },
      });
      const { err } = responseHandler(response, "markCompanyPhoneAsPrimary");
      if (err) {
        message.error(generateDisplayErrorMessage(err));
        return;
      }
      this.getCompany();
    } catch (error) {
      message.error("Failed to set phone as primary");
      Sentry.captureException(error);
    } finally {
      this.setState({ contactModalLoading: false });
    }
  };

  markAddressAsPrimary = async (address: AssociatedAddress): Promise<void> => {
    this.setState({ contactModalLoading: true });
    try {
      const response: AxiosResponse = await request({
        query: MARK_COMPANY_ADDRESS_AS_PRIMARY,
        variables: { addressId: address.id },
      });
      const { err } = responseHandler(response, "markCompanyAddressAsPrimary");
      if (err) {
        message.error(generateDisplayErrorMessage(err));
        return;
      }
      this.getCompany();
    } catch (error) {
      message.error("Failed to set address as primary");
      Sentry.captureException(error);
    } finally {
      this.setState({ contactModalLoading: false });
    }
  };

  handleIsExistingCustomerchecked = (value: boolean): void => {
    if (!value) {
      this.setState({
        isExistingCustomer: value,
        companyContactFieldsToHide: [
          ...this.state.companyContactFieldsToHide,
          "customerId",
        ],
      });
    } else {
      this.setState({
        isExistingCustomer: value,
        companyContactFieldsToHide:
          this.state.companyContactFieldsToHide.filter(
            (item) => item !== "customerId",
          ),
      }, () => {
        if (!this.state.customers.length) {
          void this.triggerCustomerSearch();
        }
      });
    }
  };

  handleFileUploadChange = (field: string, combinedInfo: string): void => {
    const [url] = combinedInfo.split("@@@");
    this.newCompanyContactPersonFormReference?.current?.setFieldsValue({
      [field]: combinedInfo,
    });
    if (field === "documentUrl") {
      this.setState({ documentUrl: url });
    }
  };

  handleContactLevelsChange = (
    value: string | string[],
    options: any | any[],
  ): void => {
    if (window.location.pathname.split("/").includes("business-development")) {
      this.setState({
        contactPersonRequired: false,
      });
      return;
    }

    const optionsArray = Array.isArray(options) ? options : [options];
    const contactPersonRequired = !optionsArray.some(
      (option) => option.children === "RM" || option.children === "Client Services",
    );

    this.setState({
      contactPersonRequired,
    });
  };

  triggerCustomerSearch = async (): Promise<void> => {
    try {
      const { customerSearchTerm: q } = this.state;
      const searchQuery = q && q.trim().length > 0 ? q : " ";

      const r: AxiosResponse = await request({
        query: SEARCH_CUSTOMER,
        variables: { q: searchQuery, page: 1 },
      });

      if (r.data?.errors) {
        message.error("customer search failed");
      } else {
        this.setState({
          customers: r.data?.data?.customerSearch?.results || [],
        });
      }
    } catch (error) {
      message.error("customer search failed");
      Sentry.captureException(error);
    }
  };

  triggerCustomerDelayedSearch = debounce(async (): Promise<void> => {
    await this.triggerCustomerSearch();
  }, DEBOUNCE_TIME);

  handleCustomerSearchInput = async (
    customerSearchTerm: string,
  ): Promise<void> => {
    this.setState({ customerSearchTerm });
    await this.triggerCustomerDelayedSearch();
  };

  loadContactLevels = (): void => {
    interface Response {
      data: {
        contactLevels: ContactLevel[];
      };
    }

    request({
      query: GET_CONTACT_LEVELS,
    })
      .then((response: AxiosResponse<Response>): void => {
        const data = response.data.data;
        this.setState({
          contactLevels: data.contactLevels,
        });
      })
      .catch((): void => {
        message.error("Failed to load contact levels");
      });
  };

  createCompanyContact = async (): Promise<void> => {
    const { company } = this.state;
    if (!company || !this.newCompanyContactPersonFormReference.current) return;

    let data;
    try {
      data = await this.newCompanyContactPersonFormReference.current.validateFields([
        "contactName",
        "emailAddress",
        "mobileNumber",
        "contactLevelIds",
        "role",
        "documentUrl",
        "customerId",
      ]);
    } catch (error) {
      handleValidationErrors(error);
      return;
    }

    try {
      const response: AxiosResponse = await request({
        query: CREATE_CONTACT_PERSON_MUTATION,
        variables: {
          companyId: company.id,
          contactLevelIds: data.contactLevelIds,
          contactName: data.contactName,
          emailAddress: data.emailAddress,
          mobileNumber: data.mobileNumber,
          customerId: data.customerId,
          isExistingCustomer: this.state.isExistingCustomer,
          role: data.role,
          documentUrl: this.state.documentUrl,
        },
      });

      const { err, mutation } = responseHandler<{ companyContact?: { id: string } }>(response, "createCompanyContact");
      if (err) {
        this.newCompanyContactPersonFormReference.current.setFields(
          err.map(mapAPIErrorToFormError),
        );
        message.error(generateDisplayErrorMessage(err));
        return;
      }

      if (!mutation?.companyContact) {
        message.error("Company contact creation failed");
        return;
      }

      message.success("Contact person created successfully");
      this.toggleCompanyContactModal(false);
      this.getCompany();
    } catch (error) {
      message.error("Failed to create contact person");
      Sentry.captureException(error);
    }
  };

  updateCompanyContact = async (): Promise<void> => {
    const { company, currentCompanyContact } = this.state;
    if (!company || !currentCompanyContact || !this.newCompanyContactPersonFormReference.current) return;

    let data;
    try {
      data = await this.newCompanyContactPersonFormReference.current.validateFields([
        "contactName",
        "emailAddress",
        "mobileNumber",
        "contactLevelIds",
        "role",
        "customerId",
      ]);
    } catch (error) {
      handleValidationErrors(error);
      return;
    }

    try {
      const response: AxiosResponse = await request({
        query: UPDATE_COMPANY_CONTACT_PERSON_MUTATION,
        variables: {
          id: currentCompanyContact.id,
          companyId: company.id,
          contactLevelIds: data.contactLevelIds,
          contactName: data.contactName,
          emailAddress: data.emailAddress,
          mobileNumber: data.mobileNumber,
          customerId: data.customerId,
          role: data.role,
          documentUrl: this.state.documentUrl || currentCompanyContact.documentUrl,
        },
      });

      const { err } = responseHandler(response, "updateCompanyContact");
      if (err) {
        this.newCompanyContactPersonFormReference.current.setFields(
          err.map(mapAPIErrorToFormError),
        );
        message.error(generateDisplayErrorMessage(err));
        return;
      }

      message.success("Contact person updated successfully");
      this.toggleCompanyContactModal(false);
      this.getCompany();
    } catch (error) {
      message.error("Failed to update contact person");
      Sentry.captureException(error);
    }
  };

  openCompanyContactDeleteModal = (contact: CompanyContact): void => {
    this.setState({
      showCompanyContactDeleteModal: true,
      currentCompanyContact: contact,
    });
  };

  closeCompanyContactDeleteModal = (): void => {
    this.setState({
      showCompanyContactDeleteModal: false,
      currentCompanyContact: undefined,
    });
  };

  deleteCompanyContact = async (): Promise<void> => {
    const { currentCompanyContact } = this.state;
    if (!currentCompanyContact) return;

    try {
      const response: AxiosResponse = await request({
        query: DELETE_COMPANY_CONTACT_PERSON_MUTATION,
        variables: { id: currentCompanyContact.id },
      });

      const { err } = responseHandler(response, "deleteCompanyContact");
      if (err) {
        message.error(generateDisplayErrorMessage(err));
        return;
      }

      message.success("Contact person deleted successfully");
      this.closeCompanyContactDeleteModal();
      this.getCompany();
    } catch (error) {
      message.error("Failed to delete contact person");
      Sentry.captureException(error);
    }
  };

  editCompanyContact = async (contactData: CompanyContact): Promise<void> => {
    this.setState(
      {
        currentCompanyContact: contactData,
        customerSearchTerm: contactData?.customer?.petraId ?? "",
        isExistingCustomer: !!contactData?.customer,
        documentUrl: contactData?.documentUrl || "",
      },
      () => {
        this.handleIsExistingCustomerchecked(!!contactData?.customer);
        this.setState({ showCompanyContactModal: true }, () => {
          window.setTimeout(() => {
            this.newCompanyContactPersonFormReference?.current?.setFieldsValue({
              contactName: contactData?.contactName,
              emailAddress: contactData?.emailAddress,
              mobileNumber: contactData?.mobileNumber,
              role: contactData?.role,
              customerId: contactData?.customer?.id,
              contactLevelIds: contactData?.contactLevels?.map((level) => level.id),
              documentUrl: contactData?.documentUrl || "",
            });
          }, 0);
        });
      },
    );
  };

  toggleCompanyContactModal = (open?: boolean): void => {
    this.setState(
      (prevState) => ({
        showCompanyContactModal:
          open !== undefined ? open : !prevState.showCompanyContactModal,
      }),
      () => {
        if (!this.state.showCompanyContactModal) {
          this.newCompanyContactPersonFormReference?.current?.resetFields();
          this.setState({
            currentCompanyContact: undefined,
            customerSearchTerm: "",
            isExistingCustomer: false,
            documentUrl: "",
            companyContactFieldsToHide: ["customerId"],
            contactPersonRequired: false,
          });
        }
      },
    );
  };

  toggleCompanyDirectorModal = (open?: boolean): void => {
    this.setState((prevState) => ({
      showCompanyDirectorModal:
        open !== undefined ? open : !prevState.showCompanyDirectorModal,
    }));
  };

  openCompanyDirectorContactModal = (director: Director): void => {
    this.setState(
      {
        showCompanyDirectorContactModal: true,
        currentCompanyDirector: director,
      },
      () => {
        this.newCompanyDirectorContactFormReference?.current?.resetFields();
      },
    );
  };

  closeCompanyDirectorContactModal = (): void => {
    this.setState({
      showCompanyDirectorContactModal: false,
      currentCompanyDirector: undefined,
    });
    this.newCompanyDirectorContactFormReference?.current?.resetFields();
  };

  openCompanyDirectorDeleteModal = (director: Director): void => {
    this.setState({
      showCompanyDirectorDeleteModal: true,
      directorToDelete: director,
    });
  };

  closeCompanyDirectorDeleteModal = (): void => {
    this.setState({
      showCompanyDirectorDeleteModal: false,
      directorToDelete: undefined,
    });
  };

  deleteCompanyDirector = async (): Promise<void> => {
    const { company, directorToDelete } = this.state;
    if (!company || !directorToDelete) {
      return;
    }

    this.setState({ isLoading: true });

    try {
      const response = await request({
        query: REMOVE_DIRECTOR,
        variables: {
          companyId: company.id,
          directorId: directorToDelete.id,
        },
      });

      const { data: responseData } = response as AxiosResponse<any>;
      const errors =
        responseData?.data?.removeCompanyDirector?.errors as APIError[];

      if (errors && errors.length > 0) {
        message.error(`${errors[0].property}: ${errors[0].description}`);
      } else {
        message.success("Director removed successfully");
        await this.getCompany();
      }
    } catch (error) {
      message.error("Failed to remove director");
      console.error(error);
    } finally {
      this.setState({ isLoading: false });
      this.closeCompanyDirectorDeleteModal();
    }
  };

  deleteDirectorContact = async (
    contact: string,
    directorId: string,
  ): Promise<void> => {
    interface Response {
      director: Director;
      errors: APIError[];
    }

    this.setState({ isLoading: true });

    const isEmail = contact.includes("@");

    try {
      const response: AxiosResponse<Response> = await request({
        query: DELETE_DIRECTOR_CONTACT,
        variables: {
          directorId,
          emailAddress: isEmail ? contact : undefined,
          phoneNumber: isEmail ? undefined : contact,
        },
      });

      const { mutation } = responseHandler<Response>(
        response,
        "removeDirectorContact",
      );
      if (mutation?.director) {
        message.success("Contact removed successfully");
        await this.getCompany();
      } else {
        message.error("Failed to delete director contact");
      }
    } catch (error) {
      message.error("Failed to delete director contact");
      Sentry.captureException(error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  createCompanyDirectorContact = async (): Promise<void> => {
    interface Response {
      data: {
        addDirectorContact: {
          director: Director;
          errors: APIError[];
        };
      };
    }

    const { currentCompanyDirector } = this.state;
    if (!currentCompanyDirector) return;

    let data;

    try {
      data =
        await this.newCompanyDirectorContactFormReference?.current?.validateFields(
          directorContactFieldsToValidate,
        );
    } catch (error) {
      handleValidationErrors(error);
      return;
    }

    this.setState({ isLoading: true });

    request({
      query: CREATE_DIRECTOR_CONTACT,
      variables: {
        ...data,
        directorId: currentCompanyDirector.id,
      },
    })
      .then(({ data: { data } }: AxiosResponse<Response>): void => {
        if (data?.addDirectorContact?.director) {
          const { errors } = data.addDirectorContact;
          if (errors && errors.length > 0) {
            message.error(`${errors[0].property}: ${errors[0].description}`);
          } else {
            message.success("Contact added successfully!");
          }
          this.getCompany();
          this.closeCompanyDirectorContactModal();
        } else {
          message.error("Request Failed");
        }
      })
      .catch((error) => {
        message.error("Error Performing Request");
        Sentry.captureException(JSON.stringify(error, null, 4));
      })
      .finally(() => this.setState({ isLoading: false }));
  };

  createCompanyDirector = async (): Promise<void> => {
    if (!this.state.company) {
      return;
    }

    let data;
    try {
      data = await this.newCompanyDirectorFormReference?.current?.validateFields([
        "firstName",
        "lastName",
      ]);
    } catch (error) {
      handleValidationErrors(error);
      return;
    }

    this.setState({ isLoading: true });

    try {
      const response = await request({
        query: CREATE_COMPANY_DIRECTOR,
        variables: {
          ...data,
          companyId: this.state.company.id,
        },
      });

      const { data: responseData } = response as AxiosResponse<any>;
      const errors =
        responseData?.data?.createCompanyDirector?.errors as APIError[];

      if (errors && errors.length > 0) {
        message.error(`${errors[0].property}: ${errors[0].description}`);
      } else {
        message.success("Director added successfully!");
        await this.getCompany();
        this.newCompanyDirectorFormReference?.current?.resetFields();
        this.toggleCompanyDirectorModal(false);
      }
    } catch (error) {
      message.error("Error performing request");
      console.error(error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  toggleFileModal = (open?: boolean): void => {
    this.setState((prevState) => ({
      showAddDocumentModal:
        open !== undefined ? open : !prevState.showAddDocumentModal,
    }));
  };

  handleDocumentUploadSuccess = (): void => {
    this.getCompany();
  };

  async componentDidMount(): Promise<void> {
    this.setState(
      {
        id: this.props.match.params.id,
        currentRequestsToProcess:
          this.props?.location?.state?.requests?.findIndex(
            (item) =>
              item?.id.toString() === this.props.match.params.id.toString(),
          ) ?? 0,
      },
      () => {
      this.getCompany();
      this.fetchCompanyTags();
      this.fetchProductTags();
      //this.getAllPorts();
        this.getCompanyInteractions();
        this.loadContactLevels();
      },
    );
  }

  toggleDrawer = (activeDrawerContent: ActiveDrawerContent): (() => void) => {
    return (): void => {
      this.setState({
        activeDrawerContent,
        showDrawer: !this.state.showDrawer,
      });
    };
  };

  toggleDrawerWithDataLoad = (
    activeDrawerContent: ActiveDrawerContent,
  ): void => {
    if (activeDrawerContent === "audits") this.getChangeLog();
    if (activeDrawerContent === "notifierRecords")
      this.getCompanyNotifications();
    return this.setState({
      activeDrawerContent,
      showDrawer: !this.state.showDrawer,
    });
  };

  toggleViewInteractionSection = (currentInteractionId: string): void => {
    const interaction = this.findInteractionById(currentInteractionId);

    this.setState({
      currentInteractionId,
      activeDrawerContent: "companyInteraction",
      showDrawer: !this.state.showDrawer,
      notes: interaction?.notes,
    });

    this.getInteractionChangeLog(interaction?.id as string);
  };

  toggleViewRedemptionRequestsSection = (
    currentInteractionId: string,
  ): void => {
    this.setState(
      {
        showDrawer: !this.state.showDrawer,
      },
      () => {
        this.setState({
          currentInteractionId,
          activeDrawerContent: "redemptionRequests",
          showDrawer: !this.state.showDrawer,
        });
      },
    );

    const interaction = this.findInteractionById(currentInteractionId);
    this.getInteractionChangeLog(interaction?.id as string);
  };

  toggleViewRequestsSection = (currentInteractionId: string): void => {
    this.setState({
      currentInteractionId,
      activeDrawerContent: "requests",
      showDrawer: !this.state.showDrawer,
    });
  };

  getTitleBasedOnDrawerContent = (): React.ReactNode => {
    const { activeDrawerContent } = this.state;
    switch (activeDrawerContent) {
      case "audits":
        return "Audit Logs";
      case "notifierRecords":
        return "Notification Records";
      case "companyInteraction":
        return "Company Interaction";
      case "redemptionRequests":
        return "Redemption Requests";
      case "productSubscription":
        return "Add Product to Company";
      case "requests":
        return "Transfer Request";
      case "mergers":
        return "Account Mergers";
      case "vestingRules":
        return `Vesting Rules${this.state.currentSubscription?.product?.name ? ` — ${this.state.currentSubscription.product.name}` : ""}`;
      default:
        return "Entity Specific Details";
    }
  };

  findInteractionById = (id: string): Activity | undefined => {
    return this.state.activities.find(
      (interaction: Activity): boolean => interaction.id === id,
    );
  };

  getDrawerContent = (): JSX.Element => {
    const { activeDrawerContent, currentInteractionId, company, notes, currentSubscription } =
      this.state;

    switch (activeDrawerContent) {
      case "vestingRules":
        if (!currentSubscription) return <div />;
        return (
          <VestingRulesModal
            subscription={currentSubscription}
            companyPetraId={company?.petraId ?? ""}
            employees={company?.currentEmployees?.results ?? []}
            onClose={() => this.setState({ showDrawer: false, activeDrawerContent: "" })}
            onSuccess={this.getCompanySubscriptions}
          />
        );
      case "mergers":
        return (
          <MergerSection
            mergeLogs={company?.companyMergeLogs || []}
            onReverse={(duplicateId) => this.reverseMerge(duplicateId)}
            onReverseAll={this.reverseAllMerges}
            onInitiate={this.toggleAccountMergerModal}
            isReversing={this.state.isReversingMerge}
            isBulkReversing={this.state.isBulkReversingMerge}
            type="company"
            canManage={true}
          />
        );
      case "audits":
        return (
          <Fragment>
            <div
              style={{
                marginBottom: "20px",
              }}
            >
              <Input.Search
                size="middle"
                type="text"
                placeholder="Filter by ..."
                onChange={this.filterLogs}
              />
            </div>

            {this.state.isFiltering
              ? ChangelogTableFactory(this.state.filteredChangelogs)
              : ChangelogTableFactory(this.state.changeLogs)}
          </Fragment>
        );
      case "requests":
        const companyInteraction = this.state.company?.companyInteractions.find(
          (activity) => activity.id === this.state.currentInteractionId,
        );
        return (
          <Fragment>
            <NewTransferRequest
              {...this.props}
              handleSuccess={this.toggleDrawer("")}
              companyInteractionId={this.state.currentInteractionId}
              company={this.state.company}
              companyInteraction={companyInteraction}
            />
          </Fragment>
        );
      case "redemptionRequests":
        const currentInteraction =
          this.state.company?.companyInteractions?.find(
            (activity) => activity.id === this.state.currentInteractionId,
          );
        return (
          <Fragment>
            <NewRedemptionRequest
              {...this.props}
              handleSuccess={this.toggleDrawer("")}
              companyInteractionId={this.state.currentInteractionId}
              company={this.state.company}
              companyInteraction={currentInteraction}
            />
          </Fragment>
        );
      case "productSubscription":
        return (
          <Fragment>
            <CreateCustomerSubscription
              {...this.props}
              handleSuccess={() => {
                this.toggleDrawer("")();
                this.getCompanySubscriptions();
              }}
              company={this.state.company}
            />
          </Fragment>
        );
      case "notifierRecords":
        return (
          <Fragment>
            {NotificationRecordTableFactory(
              this.state.notifierRecords,
              notificationColumns,
            )}
          </Fragment>
        );
      case "companyInteraction":
        const interaction = this.findInteractionById(
          currentInteractionId as string,
        );
        const transfers = this.state.company
          ? this.state.company.transferRequests
          : [];
        return (
          <CompanyInteractionSection
            forCompany={true}
            showRequests={true}
            forCustomer={false}
            isInteractionLoading={this.state.isCreateInteractionLoading}
            showInteraction={this.state.showInteractionModal}
            toggleCreateInteractionModal={this.toggleShowInteractionModal}
            isEditingInteraction={this.state.isEditingInteraction}
            updateInteraction={this.updateCompanyInteraction}
            toggleInteractionEdit={this.toggleInteractionEdit}
            audits={ChangelogTableFactory(this.state.interactionsChangeLogs)}
            auditCount={this.state.interactionsChangeLogs.length}
            notes={notes || []}
            interaction={interaction}
            tickets={this.state.tickets}
            isCreateTicketLoading={this.state.isTicketLoading}
            createNote={this.createNote}
            createTicket={this.createTicket}
            activityReference={this.reference}
            noteReference={this.noteReference}
            ticketReference={this.ticketReference}
            toggleTicketCreate={this.toggleTicketCreate}
            showTicketForm={this.state.canCreateTicket}
            createInteraction={this.createCompanyInteraction}
            toggleViewRequestsSection={this.toggleViewRequestsSection}
            toggleViewInteractionSection={this.toggleViewInteractionSection}
            toggleViewRedemptionRequestsSection={
              this.toggleViewRedemptionRequestsSection
            }
            updateAttachments={this.updateAttachments}
            assignAttachmentsToCompanyInteraction={
              this.assignAttachmentsToCompanyInteraction
            }
            removeAttachment={this.unassignAttachmentFromCompanyInteraction}
            holdInteraction={this.holdInteraction}
            closeInteraction={this.closeInteraction}
            openInteraction={this.openInteraction}
            transferRequests={transfers}
            customer={undefined}
            company={company}
            entity="CompanyInteraction"
            handleNoteUpdate={this.handleNoteUpdate}
            currentInteractionId={currentInteractionId}
          />
        );
      default:
        return <Fragment />;
    }
  };

  createTicket = async (): Promise<void> => {
    const { currentInteractionId, company, activities, contactPersons } =
      this.state;
    const fieldsToBeValidated = [
      "firstName",
      "lastName",
      "phoneNumber",
      "description",
      "subject",
      "source",
      "type",
      "mentions",
      "assigneeId",
      "ticketSubCategoryId",
    ];
    interface Response {
      ticket: Ticket;
    }

    if (!this.ticketReference.current) return;

    let data;

    try {
      data = await this.ticketReference.current.validateFields(
        fieldsToBeValidated,
      );
    } catch (error) {
      handleValidationErrors(error);
      return;
    }

    this.setState({ isTicketLoading: true });

    const selectedInteraction = activities.find((interaction: Activity) => {
      return interaction.id === currentInteractionId;
    });

    try {
      const response: AxiosResponse = await request({
        query: CREATE_COMPANY_TICKET,
        variables: {
          companyInteractionId: currentInteractionId,
          properties: {
            ...data,
            first_name: contactPersons?.[0]?.customer?.firstName,
            last_name: contactPersons?.[0]?.customer?.lastName,
            system_user: this.props.user.email,
            title: `${selectedInteraction?.subCategory.name} - ${company?.name}`,
            group: "Users",
            priority: "2 normal",
            state: "open",
            petra_id: company?.petraId,
          },
          assigneeId: data.assigneeId,
          source: data.source,
          ticketSubCategoryId: data.ticketSubCategoryId,
        },
      });

      const { err, mutation } = responseHandler<Response>(
        response,
        "createCompanyInteractionTicket",
      );
      if (err) {
        message.error(generateDisplayErrorMessage(err));
      } else {
        this.setState((oldState) => ({
          tickets: [...oldState.tickets, mutation.ticket],
          canCreateTicket: !this.state.canCreateTicket,
        }));
        this.ticketReference.current.resetFields(fieldsToBeValidated);
      }
    } catch (error) {
      Sentry.captureException(error);
    } finally {
      this.setState({ isTicketLoading: false });
    }
  };

  createNote = async (): Promise<void> => {
    const { user } = this.props;

    interface Response {
      note: Note;
    }

    const fieldsToBeValidated: string[] = ["description"];

    if (!this.noteReference.current) return;

    let data;

    try {
      data = await this.noteReference.current.validateFields(
        fieldsToBeValidated,
      );
    } catch (error) {
      handleValidationErrors(error);
      return;
    }

    this.setState({ isLoading: true });

    try {
      const response: AxiosResponse = await request({
        query: CREATE_NOTE,
        variables: {
          description: data.description,
          userId: user.id,
        },
      });

      const { mutation } = responseHandler<Response>(response, "createNote");
      if (mutation.note) {
        await this.assignNoteToInteraction({
          noteId: mutation.note.id,
          companyInteractionId: this.state?.currentInteractionId as string,
        });
        message.success("Note added successfullt");
        this.noteReference.current.resetFields(fieldsToBeValidated);
      } else {
        message.error("Failed to add note");
      }
    } catch (error) {
      Sentry.captureException(error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  assignNoteToInteraction = async (props: {
    companyInteractionId: string;
    noteId: string;
  }): Promise<void> => {
    interface Response {
      data: {
        assignNoteToCustomerInteraction: {
          customerInteractionNote: {
            note: Note;
          };
        };
      };
    }

    this.setState({ isLoading: true });

    try {
      const response: AxiosResponse = await request({
        query: ASSIGN_NOTE_TO_COMPANY_INTERACTION,
        variables: {
          noteId: props.noteId,
          companyInteractionId: props.companyInteractionId,
        },
      });

      const { err } = responseHandler<Response>(
        response,
        "assignNoteToCompanyInteraction",
      );

      if (err) {
        message.error(`failed to assign note to activity - ${generateDisplayErrorMessage(err)}`);
      } else {
        this.getCompanyInteractions();
      }
    } catch (error) {
      Sentry.captureException(error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  assignAttachmentsToCompanyInteraction = async (
    attachmentIds: string[],
    companyInteractionId: string,
  ): Promise<void> => {
    this.setState({ isLoading: true });

    interface Response {
      data: {
        assignAttachmentsToCompanyInteraction: {
          companyInteraction: Activity;
        };
      };
    }

    return request({
      query: ASSIGN_ATTACHMENT_TO_COMPANY_INTERACTION,
      variables: {
        attachmentIds,
        companyInteractionId,
      },
    })
      .then(({ data }: AxiosResponse<Response>): void => {
        const companyInteraction =
          data.data.assignAttachmentsToCompanyInteraction.companyInteraction;
        this.setState((oldState) => ({
          isLoading: false,
          attachments: [],
          company: {
            ...(oldState.company as Company),
            companyInteractions: (
              oldState.company as Company
            ).companyInteractions.map((interaction) =>
              interaction.id === companyInteraction.id
                ? companyInteraction
                : interaction,
            ),
          },
          companyInteractionAttachments:
            companyInteraction.companyInteractionAttachments || [],
        }));
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        message.error("Failed to attach files");
        Sentry.captureException(error);
      });
  };

  mutateCompanynteractions = (interaction: Activity): void => {
    if (!this.state.company) return;
    const oldInteractions = this.state.activities.filter(
      (i: Activity): boolean => {
        return i.id !== interaction.id;
      },
    );
    this.setState({
      activities: [...oldInteractions, interaction],
    });
  };

  updateCompanyInteraction = async (): Promise<void> => {
    const fieldsToBeValidated: string[] = [
      "description",
      "revertDate",
      "comment",
      "complaintType",
      "customerId",
    ];

    interface Response {
      companyInteraction: Activity;
    }

    if (!this.reference.current) return;

    let data;
    try {
      data = await this.reference.current.validateFields(fieldsToBeValidated);
    } catch (error) {
      handleValidationErrors(error);
      return;
    }

    const interaction = this.findInteractionById(
      this.state.currentInteractionId as string,
    );

    this.setState({ isLoading: true });

    const { customerId, ...interactionData } = data;

    try {
      const response: AxiosResponse = await request({
        query: UPDATE_COMPANY_INTERACTION,
        variables: {
          ...interaction,
          interactionSourceId: interaction?.interactionSource.id,
          subCategoryId: interaction?.subCategory.id,
          userId: interaction?.user?.id,
          companyId: this.state.id,
          ...interactionData,
          customerId:
            customerId && customerId !== "noId" ? customerId : undefined,
        },
      });

      const { mutation, err } = responseHandler<Response>(
        response,
        "updateCompanyInteraction",
      );

      if (err || !mutation.companyInteraction) {
        message.error(
          `Interaction failed to update! - ${generateDisplayErrorMessage(err)}`,
        );
        return;
      }

      this.mutateCompanynteractions(mutation.companyInteraction);
      this.reference.current?.resetFields(fieldsToBeValidated);
      message.success("Interaction successfully updated!");
      this.toggleInteractionEdit();
      this.getInteractionChangeLog(mutation.companyInteraction.id);
    } catch (error) {
      message.error(`Interaction failed to update! - ${generateDisplayErrorMessage(error)}`);
      Sentry.captureException(error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  createCompanyInteraction = async (): Promise<void> => {
    const { id, company, activities } = this.state;
    const { user } = this.props;

    interface Validated {
      description: string;
      subCategoryId: string;
      activityDate: Moment;
      interactionSourceId: string;
    }

    interface Response {
      companyInteraction: Activity;
    }

    const fieldsToBeValidated: string[] = [
      "description",
      "subCategoryId",
      "interactionCategory",
      "activityDate",
      "interactionResolved",
      "interactionSourceId",
      "customerId",
      "sourceName",
      "sourceContactInformation",
      "createTicket",
      "assigneeId",
      "mentions",
      "ticketSubCategoryId",
      "ticketDescription",
      "complaintType",
    ];

    if (!this.reference.current) return;

    let data;

    try {
      data = await this.reference.current.validateFields(fieldsToBeValidated);
    } catch (error) {
      handleValidationErrors(error);
      return;
    }

    this.setState({
      isCreateInteractionLoading: true,
      disableCreateInteractionButton: true,
    });

    const variables = {
      ...data,
      subscriberIds: data.mentions,
      interactionResolved: data.interactionResolved === "yes",
      createTicket: data.createTicket === "yes",
      activityDate: data.activityDate,
      companyId: id,
      userId: user.id,
    };

    if (this.state.attachmentIds.length > 0) {
      variables["attachmentIds"] = this.state.attachmentIds;
    }

    try {
      const response: AxiosResponse = await request({
        query: CREATE_COMAPANY_INTERACTION,
        variables,
      });

      const { mutation, err } = responseHandler<Response>(
        response,
        "createCompanyInteraction",
      );

      if (err) {
        message.error(generateDisplayErrorMessage(err));
      } else {
        if (mutation.companyInteraction) {
          company &&
            this.setState({
              activities: [...[mutation.companyInteraction], ...activities],
              attachmentIds: [],
              attachments: [],
            });
        }

        this.reference.current?.resetFields(fieldsToBeValidated);
        message.success("Interaction created successfully");
        this.toggleShowInteractionModal();
        this.toggleViewInteractionSection(mutation.companyInteraction.id);
      }
    } catch (error) {
      message.error(`Error encountered during interaction creation - ${generateDisplayErrorMessage(error)}`);
      Sentry.captureException(error);
    } finally {
      this.setState({
        isCreateInteractionLoading: false,
        disableCreateInteractionButton: false,
      });
    }
  };

  holdInteraction = async (): Promise<void> => {
    await this.changeInteractionStatus(
      HOLD_COMPANY_INTERACTION,
      "holdCompanyInteraction",
    );
  };

  openInteraction = async (): Promise<void> => {
    await this.changeInteractionStatus(
      OPEN_COMPANY_INTERACTION,
      "openCompanyInteraction",
    );
  };

  closeInteraction = async (
    closePayload?: CloseInteractionPayload,
  ): Promise<boolean> => {
    return await this.changeInteractionStatus(
      CLOSE_COMPANY_INTERACTION,
      "closeCompanyInteraction",
      closePayload,
    );
  };

  changeInteractionStatus = async (
    query: string,
    mutationName: string,
    closePayload?: CloseInteractionPayload,
  ): Promise<boolean> => {
    const companyInteractionId = this.state.currentInteractionId;
    try {
      const response: AxiosResponse = await request({
        query,
        variables: {
          companyInteractionId,
          closureType: closePayload?.closureType,
          templateId: closePayload?.templateId,
          sendSurvey: closePayload?.sendSurvey,
          customComment: closePayload?.customComment,
        },
      });

      const { err } = responseHandler<Response>(response, mutationName);
      if (err) {
        message.error(generateDisplayErrorMessage(err));
        return false;
      }
      this.getCompanyInteractions();
      if (companyInteractionId) {
        this.getInteractionChangeLog(companyInteractionId);
      }
      return true;
    } catch (error) {
      Sentry.captureException(error);
      return false;
    }
  };

  updateCompanyPaymentInformation = (
    paymentInfo: UpdatePaymentInformationFnProps,
  ): void => {
    const { company } = this.state;
    if (!company) return;
    this.setState({ company: { ...company, ...paymentInfo } });
  };

  toggleShowInteractionModal = (): void => {
    this.setState((previousState: Readonly<State>) => ({
      showInteractionModal: !previousState.showInteractionModal,
    }));
  };

  toggleShowStatementModal = (): void => {
    this.setState((previousState: Readonly<State>) => ({
      showStatementModal: !previousState.showStatementModal,
    }));
  };

  toggleVestingRule = (subscription: Subscription): void => {
    this.setState({
      currentSubscription: subscription,
      activeDrawerContent: "vestingRules",
      showDrawer: true,
    });
  };

  onVestingUpdateSuccess = () => {
    this.setState({ showDrawer: false, activeDrawerContent: "" });
    this.getCompany();
  };

  setCurrentSubscription = (subscriptionId: string) => {
    this.toggleShowStatementModal();
    this.setState({
      currentSubscriptionId: subscriptionId,
    });
  };

  handleNoteUpdate = (updatedNotes: Note[]) => {
    this.setState({ notes: updatedNotes });
  };

  generateCompanyStatement = async () => {
    if (!this.statementReference.current) return;
    interface Response {
      data: {
        generateCompanyStatement: {
          url: string;
          error: string;
        };
      };
    }

    const fieldsToBeValidated: string[] = ["startDate", "endDate"];
    let data;
    try {
      data = await this.statementReference.current.validateFields(
        fieldsToBeValidated,
      );
    } catch (error) {
      handleValidationErrors(error);
      return;
    }
    this.setState({ isStatementLoading: true });
    try {
      const response: AxiosResponse<Response> = await request({
        query: GENERATE_COMPANY_STATEMENT,
        variables: {
          ...data,
          companySubscriptionId: this.state.currentSubscriptionId,
        },
      });
      if (response.data.data.generateCompanyStatement.error) {
        message.error(response.data.data.generateCompanyStatement.error);
        return;
      }
      this.setState({
        generatedStatementUrl: response.data.data.generateCompanyStatement.url,
      });
    } catch (error) {
      message.error(`Failed to generate company statement - ${generateDisplayErrorMessage(error)}`);
      Sentry.captureException(error);
    } finally {
      this.setState({ isStatementLoading: false });
    }
  };

  unassignAttachmentFromCompanyInteraction = async (
    id: string,
  ): Promise<void> => {
    const { companyInteractionAttachments } = this.state;

    const attachmentToDelete = companyInteractionAttachments.find(
      (att) => att.attachment.id === id,
    );

    interface Response {
      result: boolean;
      errors: APIError[];
    }

    try {
      const response: AxiosResponse = await request({
        query: UNASSIGN_ATTACHMENT_FROM_COMPANY_INTERACTION,
        variables: { id: attachmentToDelete?.id },
      });

      const { mutation } = responseHandler<Response>(
        response,
        "unassignAttachmentFromCompanyInteraction",
      );

      if (!mutation.result) {
        message.error("Failed to delete attachment from company interaction");
      } else {
        message.success("Deleted Attachment Successfully");
        this.getCompanyInteractions();
      }
    } catch (error) {
      message.error(`An error occurred, please refresh and try again later - ${generateDisplayErrorMessage(error)}`);
    }
  };

  updateAttachments = (attachment: Attachment) => {
    this.setState((state) => ({
      attachments: [...state.attachments, attachment],
      attachmentIds: [...state.attachmentIds, attachment.id],
    }));
  };

  fetchCompanyTags = async (): Promise<void> => {
    const { id } = this.state;
    if (!id) return;
    this.setState({ isLoadingCompanyTags: true });
    try {
      interface Response {
        data: {
          company: {
            allCompanyTags: import("../helpers/shared-interfaces").TagRecord[];
            companyClosedIntervals: import("../helpers/shared-interfaces").CompanyClosedInterval[];
          };
        };
      }
      const {
        data: { data },
      }: AxiosResponse<Response> = await request({
        query: GET_COMPANY_TAGS,
        variables: { companyId: id },
      });
      this.setState({
        allCompanyTags: data.company.allCompanyTags ?? [],
        companyClosedIntervals: data.company.companyClosedIntervals ?? [],
      });
    } catch (error) {
      Sentry.captureException(error);
    } finally {
      this.setState({ isLoadingCompanyTags: false });
    }
  };

  fetchProductTags = async (): Promise<void> => {
    interface Response {
      data: {
        tags: SelectOptionsInterface[];
      };
    }

    try {
      const {
        data: { data },
      }: AxiosResponse<Response> = await request({
        query: GET_TAGS,
        variables: { forProduct: true },
      });

      this.setState({
        productTags: (data.tags || []).filter(
          (tag) => !isAutomaticTag(tag.name),
        ),
      });
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  assignCompanyTags = async (
    tagIds: string[],
    options: AssignTagsOptions = {},
  ): Promise<void> => {
    interface Response {
      assignTagsToCompany: {
        company: { tags: SelectOptionsInterface[] };
        errors: { property: string; description: string }[];
      };
    }
    const { company } = this.state;
    if (!company) throw new Error("Failed to update tags");

    let response;
    try {
      response = await request({
        query: ASSIGN_TAGS_TO_COMPANY,
        variables: {
          companyId: company.id,
          tagIds,
          effectiveDate: options.effectiveDate,
          notes: options.notes,
          proofOfClosureDocumentUrls: options.proofOfClosureDocumentUrls,
          proofOfReopeningDocumentUrls: options.proofOfReopeningDocumentUrls,
        },
      });
    } catch (error) {
      message.error(
        this.extractThrownErrorMessage(error) || "Failed to update tags",
      );
      Sentry.captureException(error);
      throw error;
    }

    const { err } = responseHandler<Response>(response, "assignTagsToCompany");
    if (this.surfaceMutationError(response, err, "Failed to update tags")) {
      throw new Error("Failed to update tags");
    }
    await this.fetchCompanyTags();
  };

  // Pulls a human-readable message out of a thrown request error (non-200 /
  // network), preferring any GraphQL error messages carried in the response body.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  extractThrownErrorMessage = (error: any): string => {
    const topLevel = error?.response?.data?.errors;
    if (Array.isArray(topLevel) && topLevel.length > 0) {
      return topLevel
        .map((graphqlError: { message?: string }) => graphqlError?.message)
        .filter(Boolean)
        .join("; ");
    }
    return error?.message || "";
  };

  // Surfaces backend failures on the UI: both top-level GraphQL errors (raised
  // exceptions / permission errors, which responseHandler swallows) and the
  // mutation payload's validation `errors` array. Returns true if it showed one.
  surfaceMutationError = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response: AxiosResponse<any>,
    err: { property: string; description: string }[] | null,
    fallback: string,
  ): boolean => {
    const topLevelErrors = response?.data?.errors;
    if (Array.isArray(topLevelErrors) && topLevelErrors.length > 0) {
      const text = topLevelErrors
        .map((graphqlError: { message?: string }) => graphqlError?.message)
        .filter(Boolean)
        .join("; ");
      message.error(text || fallback);
      return true;
    }
    if (err && err.length > 0) {
      message.error(generateDisplayErrorMessage(err) || fallback);
      return true;
    }
    return false;
  };

  toggleAddIntervalModal = (show: boolean): void => {
    if (show) {
      this.setState((previous) => ({
        showAddIntervalModal: true,
        intervalFormSession: previous.intervalFormSession + 1,
      }));
      return;
    }
    this.addIntervalReference.current?.resetFields();
    this.setState({ showAddIntervalModal: false });
  };

  handleAddInterval = async (): Promise<void> => {
    interface Response {
      addCompanyClosedInterval: {
        companyClosedInterval: import("../helpers/shared-interfaces").CompanyClosedInterval | null;
        errors: { property: string; description: string }[];
      };
    }
    const { company } = this.state;

    if (!company || !this.addIntervalReference.current) return;

    let data: {
      closedAt: Moment;
      reopenedAt: Moment;
      notes?: string;
      proofOfClosure: string[];
      proofOfReopening: string[];
    };
    try {
      data = await this.addIntervalReference.current.validateFields([
        "closedAt",
        "reopenedAt",
        "proofOfClosure",
        "proofOfReopening",
        "notes",
      ]);
    } catch (error) {
      handleValidationErrors(error);
      return;
    }

    if (!data.reopenedAt.isAfter(data.closedAt)) {
      message.error("The reopening date must be after the closure date");
      return;
    }

    try {
      this.setState({ isSubmittingInterval: true });
      const response = await request({
        query: ADD_COMPANY_CLOSED_INTERVAL,
        variables: {
          companyId: company.id,
          closedAt: data.closedAt.toISOString(),
          reopenedAt: data.reopenedAt.toISOString(),
          notes: data.notes || undefined,
          proofOfClosureDocumentUrls: data.proofOfClosure,
          proofOfReopeningDocumentUrls: data.proofOfReopening,
        },
      });
      const { err } = responseHandler<Response>(
        response,
        "addCompanyClosedInterval",
      );
      if (
        this.surfaceMutationError(response, err, "Failed to add closure period")
      ) {
        return;
      }
      message.success("Closure period added");
      this.toggleAddIntervalModal(false);
      await this.fetchCompanyTags();
    } catch (error) {
      message.error(
        this.extractThrownErrorMessage(error) || "Failed to add closure period",
      );
      Sentry.captureException(error);
    } finally {
      this.setState({ isSubmittingInterval: false });
    }
  };

  setIntervalProofUrls = (
    field: "proofOfClosure" | "proofOfReopening",
    files: import("../components/FileUpload").UploadedDocument[],
  ): void => {
    const form = this.addIntervalReference.current;
    if (!form) return;
    form.setFieldsValue({ [field]: files.map((file) => file.url) });
    // Clears the required error as soon as a document lands, rather than
    // leaving it up until the next submit.
    if (files.length > 0) form.validateFields([field]).catch(() => undefined);
  };

  addIntervalFormFields = (): FormFieldConfig[] => {
    const { company } = this.state;
    const notFutureDate = (current: Moment | undefined): boolean =>
      !!current && current > moment().endOf("day");

    return [
      {
        name: "closedAt",
        label: "Closed At",
        inputType: "defaultDate",
        rule: "object",
        required: true,
        errorMessage: "Closed at is required",
        disabledDate: notFutureDate,
        elementStyle: { width: "100%" },
        colConfig: { span: 12 },
      },
      {
        name: "reopenedAt",
        label: "Reopened At",
        inputType: "defaultDate",
        rule: "object",
        required: true,
        errorMessage: "Reopened at is required",
        disabledDate: notFutureDate,
        elementStyle: { width: "100%" },
        colConfig: { span: 12 },
      },
      {
        name: "proofOfClosure",
        label: "Proof of Closure Document(s)",
        inputType: "fileUpload",
        required: true,
        isArrayField: true,
        errorMessage: "At least one proof of closure document is required",
        colConfig: { span: 24 },
        fileUploadProps: {
          companyId: company?.id,
          accept: ".pdf,.doc,.docx,.png,.jpg,.jpeg",
          multiple: true,
          // FileUpload's own onChange only fires on upload, so removing the last
          // file would leave a stale value behind. onFilesChange fires on both,
          // so the form field is fed from there instead.
          onFilesChange: (files) =>
            this.setIntervalProofUrls("proofOfClosure", files),
        },
      },
      {
        name: "proofOfReopening",
        label: "Proof of Reopening Document(s)",
        inputType: "fileUpload",
        required: true,
        isArrayField: true,
        errorMessage: "At least one proof of reopening document is required",
        colConfig: { span: 24 },
        fileUploadProps: {
          companyId: company?.id,
          accept: ".pdf,.doc,.docx,.png,.jpg,.jpeg",
          multiple: true,
          onFilesChange: (files) =>
            this.setIntervalProofUrls("proofOfReopening", files),
        },
      },
      {
        name: "notes",
        label: "Notes (Optional)",
        inputType: "textArea",
        required: false,
        placeholder: "Add optional notes",
        colConfig: { span: 24 },
        autoSize: { minRows: 3, maxRows: 6 },
      },
    ];
  };

  renderProofDocuments = (urls?: string[]): JSX.Element | string => {
    const documents = urls ?? [];
    if (documents.length === 0) return "—";

    return (
      <>
        {documents.map((url, index) => (
          <div key={url}>
            <a href={url} target="_blank" rel="noopener noreferrer">
              {documents.length > 1 ? `View Document ${index + 1}` : "View Document"}
            </a>
          </div>
        ))}
      </>
    );
  };

  handleDeleteInterval = async (id: string): Promise<void> => {
    interface Response {
      deleteCompanyClosedInterval: {
        success: boolean | null;
        errors: { property: string; description: string }[];
      };
    }
    try {
      const response = await request({
        query: DELETE_COMPANY_CLOSED_INTERVAL,
        variables: { id },
      });
      const { err } = responseHandler<Response>(
        response,
        "deleteCompanyClosedInterval",
      );
      if (
        this.surfaceMutationError(
          response,
          err,
          "Failed to delete closure period",
        )
      ) {
        return;
      }
      message.success("Closure period deleted");
      await this.fetchCompanyTags();
    } catch (error) {
      message.error(
        this.extractThrownErrorMessage(error) ||
          "Failed to delete closure period",
      );
      Sentry.captureException(error);
    }
  };

  assignPortToCompany = async (): Promise<void> => {
    interface Response {
      company: Company;
    }

    if (!this.portReference.current) return;

    const { id } = this.state;
    let data;
    try {
      data = await this.portReference.current.validateFields(["portId"]);
    } catch (error) {
      handleValidationErrors(error);
      return;
    }

    try {
      this.setState({ isLoading: true });
      const response: AxiosResponse = await request({
        query: ASSIGN_PORT_TO_COMPANY,
        variables: {
          portId: data.portId,
          companyId: id,
        },
      });

      const { err, mutation } = responseHandler<Response>(
        response,
        "assignPortToCompany",
      );
      if (err) {
        message.error(generateDisplayErrorMessage(err));
        return;
      } else {
        this.setState({
          company: {
            ...this.state.company,
            port: mutation.company.port,
          } as Company,
        });

        message.success("Port assigned successfully");
      }
    } catch (error) {
      message.error(`An error occurred, please try again later - ${generateDisplayErrorMessage(error)}`);
      Sentry.captureException(error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  toggleReverseMergeModal = (): void => {
    this.setState((prevState) => ({
      showReverseMergeModal: !prevState.showReverseMergeModal,
    }));
  };

  toggleAccountMergerModal = (): void => {
    this.setState((prevState) => ({
      showAccountMergerModal: !prevState.showAccountMergerModal,
      companySearchQuery: "",
    }));
  };

  loadResultantCompanyPage =
    (id: string): (() => void) =>
    () => {
      window.location.assign(`/companies/${id}`);
    };

  mergeAccounts = async (): Promise<void> => {
    interface Response {
      company: Company;
    }

    this.setState({ isMerging: true });

    try {
      const response: AxiosResponse<Response> = await request({
        query: MERGE_COMPANIES,
        variables: {
          mainId: this.state.company?.id,
          duplicateId: this.state.selectedCompanies[0],
        },
      });

      const { err, mutation } = responseHandler<Response>(
        response,
        "mergeCompanies",
      );

      if (err) {
        message.error(generateDisplayErrorMessage(err));
      } else {
        this.toggleAccountMergerModal();
        message.success(
          "Merge Successful",
          1,
          this.loadResultantCompanyPage(mutation.company.id),
        );
      }
    } catch (error) {
      Sentry.captureException(error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  reverseMerge = async (duplicateId?: string): Promise<void> => {
    interface Response {
      company: Company;
    }

    const { id } = this.state;
    this.setState({ isReversingMerge: true });

    try {
      const response: AxiosResponse<Response> = await request({
        query: REVERSE_MERGE_COMPANIES,
        variables: { mainId: id, duplicateId },
      });

      const { err } = responseHandler<Response>(
        response,
        "reverseMergeCompanies",
      );

      if (err) {
        message.error(generateDisplayErrorMessage(err));
      } else {
        message.success("Merge Reverse Successful", 1, () =>
          window.location.reload(),
        );
      }
    } catch (error) {
      Sentry.captureException(error);
    } finally {
      this.setState({ isReversingMerge: false });
    }
  };

  reverseAllMerges = async (duplicateIds?: string[]): Promise<void> => {
    interface Response {
      company: Company;
    }

    const { id } = this.state;
    this.setState({ isBulkReversingMerge: true });

    try {
      const response: AxiosResponse<Response> = await request({
        query: BULK_REVERSE_MERGE_COMPANIES,
        variables: { mainId: id, duplicateIds },
      });

      const { err } = responseHandler<Response>(
        response,
        "bulkReverseMergeCompanies",
      );

      if (err) {
        message.error(generateDisplayErrorMessage(err));
      } else {
        message.success("All Merges Reversed Successfully", 1, () =>
          window.location.reload(),
        );
      }
    } catch (error) {
      Sentry.captureException(error);
    } finally {
      this.setState({ isBulkReversingMerge: false });
    }
  };

  getAllRelationshipManagers(): void {
    request({
      query: GET_ROLE_SUMMARY,
      variables: {
        id: relationshipManagerRoleId,
      },
    }).then(({ data: { data } }: any): void => {
      this.setState({
        relationshipManagers: data.role?.users || [],
        isLoading: false,
      });
    });
  }

  triggerRelationshipManagerDelayedSearch = debounce(async (): Promise<void> => {
    this.getAllRelationshipManagers();
  }, DEBOUNCE_TIME);

  handleRelationshipManagerSearchInput = async (
    relationshipManagerSearchTerm: string,
  ): Promise<void> => {
    this.setState({ relationshipManagerSearchTerm }, () => {
      this.triggerRelationshipManagerDelayedSearch();
    });
  };

  getAllSalesPerson(): void {
    const { salesPersonSearchTerm } = this.state;
    request({
      query: GET_SALES_PEOPLE,
      variables: {
        page: 1,
        q: salesPersonSearchTerm,
      },
    }).then(({ data: { data } }: any): void => {
      this.setState({
        salesPersons: data.salesPeople.results,
        isLoading: false,
      });
    });
  }

  triggerSalesPersonDelayedSearch = debounce(async (): Promise<void> => {
    this.getAllSalesPerson();
  }, DEBOUNCE_TIME);

  handleSalesPersonSearchInput = async (
    salesPersonSearchTerm: string,
  ): Promise<void> => {
    this.setState({ salesPersonSearchTerm }, () => {
      this.triggerSalesPersonDelayedSearch();
    });
  };

  openSubscriptionEditModal = (subscription: Subscription): void => {
    if (!this.state.allCompanyTags.length) {
      this.fetchCompanyTags();
    }
    if (!this.state.productTags.length) {
      this.fetchProductTags();
    }
    if (!this.state.salesPersons.length) {
      this.getAllSalesPerson();
    }
    this.subscriptionEditReference.current?.resetFields();
    this.setState({
      showSubscriptionEditModal: true,
      subscriptionToEdit: subscription,
    });
  };

  closeSubscriptionEditModal = (): void => {
    this.subscriptionEditReference.current?.resetFields();
    this.setState({
      showSubscriptionEditModal: false,
      subscriptionToEdit: undefined,
    });
  };

  assignCompanySubscriptionTags = async (
    subscriptionId: string,
    tagIds: string[],
  ): Promise<void> => {
    interface Response {
      assignTagsToCompanySubscription: {
        errors: APIError[];
      };
    }

    const response: AxiosResponse = await request({
      query: ASSIGN_TAGS_TO_COMPANY_SUBSCRIPTION,
      variables: { companySubscriptionId: subscriptionId, tagIds },
    });

    const { err } = responseHandler<Response>(
      response,
      "assignTagsToCompanySubscription",
    );

    if (err) {
      throw new Error(generateDisplayErrorMessage(err));
    }
  };

  updateCompanySubscription = async (
    subscriptionId: string,
    salesPersonId?: string,
    contributionAllocationTypes?: string[],
  ): Promise<void> => {
    interface Response {
      companySubscription: Subscription;
    }

    const variables: Record<string, unknown> = {
      companySubscriptionId: subscriptionId,
    };
    if (salesPersonId !== undefined) {
      variables.salesPersonId = salesPersonId;
    }
    if (contributionAllocationTypes !== undefined) {
      variables.contributionAllocationTypes = contributionAllocationTypes;
    }

    const response: AxiosResponse = await request({
      query: UPDATE_COMPANY_SUBSCRIPTION,
      variables,
    });

    const { err } = responseHandler<Response>(
      response,
      "updateCompanySubscription",
    );

    if (err) {
      throw new Error(generateDisplayErrorMessage(err));
    }
  };

  phasedOutProductNameFor = (subscriptionId: string): string | undefined => {
    const subscription = this.state.companySubscriptions?.find(
      (candidate) => candidate.id === subscriptionId,
    );

    return subscription?.product?.isActive === false
      ? subscription?.product?.name
      : undefined;
  };

  saveSubscriptionEdits = async (): Promise<void> => {
    const subscription = this.state.subscriptionToEdit;
    if (!subscription || !this.subscriptionEditReference.current) return;

    const phasedOutProduct = this.phasedOutProductNameFor(subscription.id);
    if (phasedOutProduct) {
      message.error(`${phasedOutProduct} has been phased out`);
      return;
    }

    const fieldsToBeValidated = [
      "salesPersonId",
      "subscriptionTagIds",
      "contributionAllocationTypes",
    ];
    let data: {
      salesPersonId?: string;
      subscriptionTagIds?: string[];
      contributionAllocationTypes?: string[];
    };
    try {
      data = await this.subscriptionEditReference.current.validateFields(
        fieldsToBeValidated,
      );
    } catch (error) {
      handleValidationErrors(error);
      return;
    }

    this.setState({ isSavingSubscriptionEdits: true });

    try {
      if (
        data.salesPersonId !== undefined ||
        data.contributionAllocationTypes !== undefined
      ) {
        await this.updateCompanySubscription(
          subscription.id,
          data.salesPersonId,
          data.contributionAllocationTypes,
        );
      }

      if (data.subscriptionTagIds !== undefined) {
        await this.assignCompanySubscriptionTags(
          subscription.id,
          data.subscriptionTagIds,
        );
      }

      message.success("Subscription updated");
      this.closeSubscriptionEditModal();
      this.getCompany();
    } catch (error) {
      message.error("Failed to update subscription");
      Sentry.captureException(error);
    } finally {
      this.setState({ isSavingSubscriptionEdits: false });
    }
  };

  handleSearchInput = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ): Promise<void> => {
    if (event.target.value.length > 0) {
      this.setState({
        companySearchQuery: event.target.value,
      });
      await this.triggerDelayedSearch();
    } else {
      this.setState({
        companySearchQuery: event.target.value,
        companies: [],
      });
    }
  };

  triggerDelayedSearch = debounce(async (): Promise<void> => {
    return await this.triggerImmediateSearch();
  }, DEBOUNCE_TIME);

  triggerImmediateSearch = async (): Promise<void> => {
    const { companySearchQuery } = this.state;

    interface Response {
      data: {
        findCompanyByPetraId: Company;
      };
    }

    this.setState({ isSearchingForCompany: true });

    try {
      const response: AxiosResponse<Response> = await request({
        query: SEARCH_COMPANY_BY_PETRAID,
        variables: { q: companySearchQuery },
      });
      const companies = response.data.data.findCompanyByPetraId
        ? [response.data.data.findCompanyByPetraId]
        : [];

      this.setState({
        companies,
        selectedCompanies: [],
      });
      this.setState({ isSearchingForCompany: false });
    } catch (error) {
      this.setState({ isSearchingForCompany: false });
      Sentry.captureException(error);
    }
  };

  handleCheckboxGroupChange = (
    selectedCompanies: CheckboxValueType[],
  ): void => {
    this.setState({ selectedCompanies: selectedCompanies.map(String) });
  };

  getCompanyPayments = (): void => {
    interface Response {
      data: {
        companyPayments: Payment[];
      };
    }

    this.setState({ isLoading: true });
    const petraId = this.state.company?.petraId;

    request({
      query: COMPANY_PAYMENTS,
      variables: { petraId: petraId || "" },
    })
      .then((response: AxiosResponse<Response>): void => {
        this.setState({
          payments: response.data.data.companyPayments,
        });
      })
      .finally((): void => {
        this.setState({ isLoading: false });
      });
  };

  getSchedules = (): void => {
    interface Response {
      data: {
        companySchedules: Schedule[];
      };
    }

    this.setState({ isLoading: true });
    const petraId = this.state.company?.petraId;

    request({
      query: COMPANY_SCHEDULES,
      variables: { petraId: petraId || "" },
    })
      .then((response: AxiosResponse<Response>): void => {
        this.setState({
          schedules: response.data.data.companySchedules,
        });
      })
      .finally((): void => {
        this.setState({ isLoading: false });
      });
  };

  getPhoenixTickets = (): void => {
    const { id: companyId } = this.state;
    this.setState({ isLoading: true });
    request({
      query: GET_COMPANY_TICKETS,
      variables: { companyId },
    }).then(
      ({
        data,
      }: AxiosResponse<{
        data: {
          company: Company;
        };
      }>): void => {
        if (data.data.company) {
          this.setState({
            phoenixTickets: data.data?.company?.tickets ?? [],
            isLoading: false,
          });
        }
      },
    );
  };

  openNotifyPaymentModal = (payment: Payment): void => {
    this.setState({ selectedReturnedChequePayment: payment, returnedChequePreview: null });
    this.loadReturnedChequePreview(payment.id);
  };

  closeNotifyPaymentModal = (): void => {
    this.setState({
      selectedReturnedChequePayment: null,
      returnedChequePreview: null,
    });
  };

  handlePaymentStatusFilterChange = (
    filter: "all" | "identified" | "returned",
  ): void => {
    this.setState({ paymentStatusFilter: filter });
  };

  loadReturnedChequePreview = async (paymentId: number): Promise<void> => {
    this.setState({ isReturnedChequePreviewLoading: true });

    try {
      const response: AxiosResponse<{
        data: {
          returnedChequeNotificationPreview: {
            preview: InteractionNotificationPreview | null;
            errors: APIError[];
          };
        };
      }> = await request({
        query: GET_RETURNED_CHEQUE_NOTIFICATION_PREVIEW,
        variables: { paymentId },
      });

      const previewResponse =
        response.data.data.returnedChequeNotificationPreview;

      if (previewResponse.errors?.length) {
        message.error(generateDisplayErrorMessage(previewResponse.errors));
        this.setState({ returnedChequePreview: null });
        return;
      }

      this.setState({
        returnedChequePreview: previewResponse.preview,
      });
    } catch (error) {
      message.error(
        `Failed to load returned cheque preview - ${generateDisplayErrorMessage(
          error,
        )}`,
      );
      Sentry.captureException(error);
    } finally {
      this.setState({ isReturnedChequePreviewLoading: false });
    }
  };

  sendReturnedChequeNotification = async (): Promise<void> => {
    const { selectedReturnedChequePayment } = this.state;
    if (!selectedReturnedChequePayment) return;

    interface Response {
      queued: boolean;
      errors: APIError[];
    }

    this.setState({ isSendingReturnedCheque: true });

    try {
      const response: AxiosResponse = await request({
        query: NOTIFY_RETURNED_CHEQUE,
        variables: { paymentId: selectedReturnedChequePayment.id },
      });

      const { err } = responseHandler<Response>(
        response,
        "notifyReturnedCheque",
      );

      if (err) {
        message.error(generateDisplayErrorMessage(err));
        return;
      }

      message.success("Returned cheque notification queued successfully");
      this.closeNotifyPaymentModal();
      this.getCompanyPayments();
    } catch (error) {
      message.error(
        `Failed to send returned cheque notification - ${generateDisplayErrorMessage(
          error,
        )}`,
      );
      Sentry.captureException(error);
    } finally {
      this.setState({ isSendingReturnedCheque: false });
    }
  };

  render(): JSX.Element | null {
    const {
      isLoading,
      company,
      countries,
      contributions,
      contributionsLoader,
      ports,
      payments,
      schedules,
      showInteractionModal,
      isCreateInteractionLoading,
      currentSubscription,
      redemptionRequests,
      transferRequests,
      contactPersons,
      currentRequestsToProcess,
      phoenixTickets,
      showConfirmProductDelete,
      subscriptionIdToDelete,
      numberPerPage,
      companyStatements,
      companySubscriptions,
      disableCreateInteractionButton,
      showContactModal,
      contactModalType,
      contactModalMode,
      contactModalLoading,
      showContactDeleteModal,
      deleteContactType,
      selectedEmail,
      selectedPhone,
      selectedAddress,
      addressType,
      showCompanyContactModal,
      showCompanyContactDeleteModal,
      currentCompanyContact,
      contactLevels,
      customers,
    
      isExistingCustomer,
     
      financialInstitutions,
      branchMap,
      showCompanyEditModal,
      isCompanyEditSaving,
      industrySectors,
      trustees,
      relationshipManagers,
      showCompanyPaymentModal,
      showSubscriptionEditModal,
      subscriptionToEdit,
      isSavingSubscriptionEdits,
    
      productTags,
    } = this.state;
    let userInterface: JSX.Element;
    const hasSubscription =
      company && companySubscriptions && companySubscriptions.length > 0;

    const subscriptionsWithContributions = mapSubscriptionToContribution(
      contributions,
      companySubscriptions,
    );
   
    const contactModalFields =
      contactModalType === "email"
        ? createEmailFields({
            createEmail: this.saveContactEmail,
            initialValue:
              contactModalMode === "edit" ? selectedEmail || undefined : undefined,
          }).filter(
            (field) =>
              field.inputType !== "button" && field.inputType !== "buttonGroup",
          )
        : contactModalType === "phone"
          ? createPhoneFields({
              createPhone: this.saveContactPhone,
              initialValue:
                contactModalMode === "edit" ? selectedPhone || undefined : undefined,
            }).filter(
              (field) =>
                field.inputType !== "button" && field.inputType !== "buttonGroup",
            )
          : contactModalType === "address"
            ? createAddressFields({
                countries,
                createAddress: this.saveContactAddress,
                initialValue:
                  contactModalMode === "edit" ? selectedAddress || undefined : undefined,
                changeHandler: this.handleAddressTypeChange,
                addressType,
              }).filter(
                (field) =>
                  field.inputType !== "button" && field.inputType !== "buttonGroup",
              )
            : [];

    const contactAddressFieldsToHide =
      addressType === AssociatedEntityConstants.PostalAddressCode
        ? ["ghPost"]
        : ["poBox"];

    const companySubscriptionTagOptions = productTags;

    const companyEditFields: FormFieldConfig[] = company
      ? [
          {
            id: "name",
            name: "name",
            inputType: "string",
            rule: "string",
            required: true,
            placeholder: "Company Name",
            label: "Company Name",
            initialValue: company.name,
            colConfig: { span: 7 },
          },
          {
            id: "tinNumber",
            name: "tinNumber",
            inputType: "string",
            rule: "string",
            required: false,
            placeholder: "TIN",
            label: "TIN",
            initialValue: company.tinNumber || undefined,
            colConfig: { offset: 1, span: 7 },
          },
          {
            id: "industrySectorId",
            name: "industrySectorId",
            inputType: "select",
            rule: "string",
            required: false,
            placeholder: "Industry Sector",
            label: "Industry Sector",
            selectOptions: industrySectors,
            initialValue: company.industrySector?.id,
            colConfig: { offset: 1, span: 7 },
          },
          {
            id: "numberOfEmployees",
            name: "numberOfEmployees",
            inputType: "number",
            rule: "number",
            required: false,
            placeholder: "Number of Employees",
            label: "No. of Employees",
            initialValue: company.numberOfEmployees ?? undefined,
            elementStyle: { width: "100%" },
            colConfig: { span: 7 },
          },
          {
            id: "trusteeId",
            name: "trusteeId",
            inputType: "select",
            rule: "string",
            required: false,
            placeholder: "Trustee",
            label: "Trustee",
            selectOptions: trustees,
            initialValue: company.trustee?.id,
            colConfig: { offset: 1, span: 7 },
          },
          {
            id: "relationshipManagerId",
            name: "relationshipManagerId",
            inputType: "select",
            rule: "string",
            required: false,
            placeholder: "Relationship Manager",
            label: "Relationship Manager",
            selectOptions: relationshipManagers,
            initialValue: company.relationshipManager?.id,
            colConfig: { offset: 1, span: 7 },
          },
          {
            id: "ssnitNumber",
            name: "ssnitNumber",
            inputType: "string",
            rule: "string",
            required: false,
            placeholder: "SSNIT Number",
            label: "SSNIT Number",
            initialValue: company.ssnitNumber || undefined,
            colConfig: { span: 7 },
          },
          {
            id: "rocNumber",
            name: "rocNumber",
            inputType: "string",
            rule: "string",
            required: false,
            placeholder: "RDG/ROC Number",
            label: "RDG/ROC Number",
            initialValue: company.rocNumber || undefined,
            colConfig: { offset: 1, span: 7 },
          },
          {
            id: "dateOfEstablishment",
            name: "dateOfEstablishment",
            inputType: "date",
            rule: "string",
            required: false,
            placeholder: "Select date",
            label: "Date Of Establishment",
            initialValue: company.dateOfEstablishment
              ? moment(company.dateOfEstablishment)
              : undefined,
            colConfig: { offset: 1, span: 7 },
          },
          {
            id: "companySegment",
            name: "companySegment",
            inputType: "select",
            rule: "string",
            required: false,
            placeholder: "Company Segment",
            label: "Company Segment",
            selectOptions: generateCompanySegments(),
            initialValue: company.companySegment || undefined,
            colConfig: { span: 7 },
          },
        ]
      : [];

    let contactLevelsIds: string[] = [];
    if (currentCompanyContact && currentCompanyContact.contactLevels.length > 0) {
      contactLevelsIds = currentCompanyContact.contactLevels.map(
        (level) => level.id,
      );
    }

    const isExistingCustomerValue =
      currentCompanyContact?.customer ? true : isExistingCustomer;
    const documentColSpan = isExistingCustomerValue ? 11 : 24;
    const documentDefaultFileList = currentCompanyContact?.documentUrl
      ? [
          {
            uid: `${currentCompanyContact.id}-document`,
            name: extractFileName(currentCompanyContact.documentUrl),
            url: currentCompanyContact.documentUrl,
          },
        ]
      : [];
    const customerOptionsSource = currentCompanyContact?.customer
      ? [
          currentCompanyContact.customer,
          ...customers.filter(
            (customer) => customer.id !== currentCompanyContact.customer?.id,
          ),
        ]
      : customers;

    const companyContactPersonFormFields: FormFieldConfig[] = [
      {
        id: "contactName",
        name: "contactName",
        inputType: "string",
        rule: "string",
        placeholder: "Contact Name",
        label: "Contact Name",
        required: true,
        initialValue: currentCompanyContact?.contactName,
        colConfig: {
          span: 11,
        },
      },
      {
        id: "emailAddress",
        name: "emailAddress",
        inputType: "string",
        rule: "string",
        placeholder: "Email Address",
        label: "Email Address",
        required: true,
        initialValue: currentCompanyContact?.emailAddress,
        colConfig: {
          span: 11,
          offset: 1,
        },
      },
      {
        id: "mobileNumber",
        name: "mobileNumber",
        inputType: "string",
        rule: "string",
        placeholder: "Mobile Number",
        label: "Mobile Number",
        required: true,
        initialValue: currentCompanyContact?.mobileNumber,
        colConfig: {
          span: 11,
        },
      },
      {
        id: "contactLevelIds",
        name: "contactLevelIds",
        inputType: "multipleSelect",
        rule: "string",
        placeholder: "Contact Level",
        label: "Contact Level",
        selectOptions: contactLevels,
        isArrayField: true,
        required: true,
        selectHandler: this.handleContactLevelsChange,
        initialValue: contactLevelsIds,
        colConfig: {
          span: 11,
          offset: 1,
        },
      },
      {
        id: "role",
        name: "role",
        inputType: "string",
        rule: "string",
        placeholder: "Role",
        label: "Role",
        required: true,
        initialValue: currentCompanyContact?.role,
        colConfig: {
          span: 11,
        },
      },
      {
        id: "isExistingCustomer",
        name: "isExistingCustomer",
        inputType: "checkbox",
        required: false,
        rule: "boolean",
        label: "Is Existing Customer ?",
        checkboxChangeHandler: (e) =>
          this.handleIsExistingCustomerchecked(e.target.checked),
        checkboxCheckedValue: isExistingCustomerValue,
        colConfig: {
          span: 11,
          offset: 1,
        },
      },
      {
        id: "documentUrl",
        name: "documentUrl",
        label: "Upload Document",
        inputType: "fileUpload",
        defaultFileList: documentDefaultFileList,
        placeholder: "Upload Document",
        rule: "string",
        required: true,
        changeHandler: (combinedInfo: string) =>
          this.handleFileUploadChange("documentUrl", combinedInfo),
        colConfig: {
          span: documentColSpan,
        },
      },
      {
        id: "customerId",
        name: "customerId",
        inputType: "search",
        required: true,
        placeholder: "Seach by name or petraId",
        rule: "string",
        label: "Customer",
        selectOptions: convertCustomersToSelectOptions(customerOptionsSource),
        changeHandler: this.handleCustomerSearchInput,
        onFocus: () => {
          if (this.state.isExistingCustomer && !this.state.customers.length) {
            void this.triggerCustomerSearch();
          }
        },
        initialValue: currentCompanyContact?.customer?.id,
        colConfig: {
          span: 11,
          offset: isExistingCustomerValue ? 1 : 0,
        },
      },
    ];

    const moveToNextLink = `/companies/${this.props.location?.state?.requests?.[currentRequestsToProcess + 1]?.id
      }`;

    const moveToPreviousLink = `/companies/${
      this.props.location?.state?.requests?.[currentRequestsToProcess - 1]?.id
    }`;

    const nextPreviousUI = (
      <>
        <Row
          gutter={10}
          style={{
            float: "right",
            marginTop: "10px",
          }}
        >
          <Col>
            {this.state.currentRequestsToProcess > 0 && (
              <NavLink
                to={{
                  pathname: moveToPreviousLink,
                  state: {
                    type: "redemption",
                    requests: this.props?.location?.state?.requests ?? [],
                  },
                }}
              >
                <Tooltip placement="left" title={"Previous"}>
                  <LeftOutlined style={{ color: "#1D3764" }} />
                </Tooltip>
              </NavLink>
            )}
          </Col>

          <Col>
            {this.props?.location?.state?.requests &&
              this.state.currentRequestsToProcess <
                this.props?.location?.state?.requests?.length - 1 && (
                <NavLink
                  to={{
                    pathname: moveToNextLink,
                    state: {
                      type: "redemption",
                      requests: this.props?.location?.state?.requests ?? [],
                    },
                  }}
                >
                  <Tooltip placement="right" title={"Next"}>
                    <RightOutlined style={{ color: "#1D3764" }} />
                  </Tooltip>
                </NavLink>
              )}
          </Col>

          <Col>
            {this.props?.location?.state?.requests &&
              `${currentRequestsToProcess + 1} / ${
                this.props?.location?.state?.requests?.length
              }`}
          </Col>
        </Row>
      </>
    );

    if (company) {
      userInterface = (
          <Fragment>
            {ModalCreator({
              title:
                contactModalType && contactModalMode
                  ? `${contactModalMode === "edit" ? "Edit" : "Add"} ${
                    contactModalType === "email"
                      ? "Email"
                      : contactModalType === "phone"
                        ? "Phone"
                        : "Address"
                  }`
                  : "Contact",
              okType: "primary",
              okText: contactModalMode === "edit" ? "Update" : "Save",
              showModal: showContactModal,
              onOkay:
                contactModalType === "email"
                  ? this.saveContactEmail
                  : contactModalType === "phone"
                    ? this.saveContactPhone
                    : this.saveContactAddress,
              toggleModal: this.closeContactModal,
              isLoading: contactModalLoading,
              width: contactModalType === "address" ? 800 : 560,
              inscription: (
                <BaseForm
                  key={`${contactModalType}-${contactModalMode}-${
                    contactModalType === "email"
                      ? selectedEmail?.id ?? "new"
                      : contactModalType === "phone"
                        ? selectedPhone?.id ?? "new"
                        : selectedAddress?.id ?? "new"
                  }`}
                  layout="vertical"
                  reference={
                    contactModalType === "email"
                      ? this.contactEmailReference
                      : contactModalType === "phone"
                        ? this.contactPhoneReference
                        : this.contactAddressReference
                  }
                  fieldsToHide={
                    contactModalType === "address"
                      ? contactAddressFieldsToHide
                      : []
                  }
                  fields={contactModalFields}
                />
              ),
            })}
            {ModalCreator({
              title:
                deleteContactType === "email"
                  ? "Delete Email"
                  : deleteContactType === "phone"
                    ? "Delete Phone"
                    : "Delete Address",
              okType: "primary",
              okText: "Delete",
              showModal: showContactDeleteModal,
              onOkay: this.confirmDeleteContact,
              toggleModal: this.closeDeleteContactModal,
              isLoading: contactModalLoading,
              inscription:
                deleteContactType === "email"
                  ? "Are you sure you want to delete this email?"
                  : deleteContactType === "phone"
                    ? "Are you sure you want to delete this phone?"
                    : "Are you sure you want to delete this address?",
            })}
            {ModalCreator({
              title: currentCompanyContact
                ? "Update Contact Person"
                : "Add Contact Person",
              okType: "primary",
              okText: currentCompanyContact ? "Update" : "Create",
              showModal: showCompanyContactModal,
              width: 700,
              onOkay: () => {
                currentCompanyContact
                  ? this.updateCompanyContact()
                  : this.createCompanyContact();
              },
              toggleModal: () => this.toggleCompanyContactModal(false),
              inscription: (
                <BaseForm
                  key={`company-contact-form-${currentCompanyContact?.id ?? "new"}`}
                  layout="vertical"
                  reference={this.newCompanyContactPersonFormReference}
                  fields={companyContactPersonFormFields}
                  fieldsToHide={this.state.companyContactFieldsToHide}
                />
              ),
            })}
            {ModalCreator({
              title: "Delete company contact",
              okType: "primary",
              okText: "Delete",
              showModal: showCompanyContactDeleteModal,
              onOkay: this.deleteCompanyContact,
              toggleModal: this.closeCompanyContactDeleteModal,
              inscription: "Are you sure you want to delete this record ?",
            })}
            {ModalCreator({
              title: "Delete director",
              okType: "primary",
              okText: "Delete",
              showModal: this.state.showCompanyDirectorDeleteModal,
              onOkay: this.deleteCompanyDirector,
              toggleModal: this.closeCompanyDirectorDeleteModal,
              inscription: this.state.directorToDelete
                ? `Are you sure you want to remove ${this.state.directorToDelete.firstName} ${this.state.directorToDelete.lastName}?`
                : "Are you sure you want to remove this director?",
            })}
            {ModalCreator({
              title: "Payment Accounts",
              showModal: showCompanyPaymentModal,
              toggleModal: this.closePaymentAccountsModal,
              showFooter: false,
              width: 900,
              inscription: company ? (
                <CompanyOnboardingDetails
                  ref={this.companyPaymentModalRef}
                  isEditing={true}
                  opportunity={{ company } as Opportunity}
                  company={company}
                  loadOpportunity={this.getCompany}
                  financialInstitutions={financialInstitutions}
                  branchMap={branchMap}
                  updateCompanyPaymentInformation={
                    this.updateCompanyPaymentInformation
                  }
                  onCancelEdit={this.closePaymentAccountsModal}
                  visibleViews={[CompanyOnboardingViews.payout]}
                  showList={false}
                  renderInline={true}
                  hideFormOnDelete={true}
                  activekey={CompanyOnboardingViews.payout}
                />
              ) : (
                <div />
              ),
            })}
            {ModalCreator({
              title: "Edit Subscription",
              okType: "primary",
              okText: "Save",
              showModal: showSubscriptionEditModal,
              onOkay: this.saveSubscriptionEdits,
              toggleModal: this.closeSubscriptionEditModal,
              isLoading: isSavingSubscriptionEdits,
              width: 700,
              inscription: subscriptionToEdit ? (
                <BaseForm
                  key={subscriptionToEdit.id + JSON.stringify(subscriptionToEdit)}
                  layout="vertical"
                  reference={this.subscriptionEditReference}
                  fields={[
                    {
                      id: "salesPersonId",
                      name: "salesPersonId",
                      placeholder: "Enter user's name ...",
                      required: false,
                      inputType: "search",
                      label: "Sales Person",
                      changeHandler: this.handleSalesPersonSearchInput,
                      selectOptions: subscriptionToEdit.salesPerson?.id
                        ? [
                            ...(this.state.salesPersons ?? []),
                            {
                              id: subscriptionToEdit.salesPerson.id,
                              name: subscriptionToEdit.salesPerson.name,
                            },
                          ]
                        : this.state.salesPersons ?? [],
                      initialValue: subscriptionToEdit.salesPerson?.id,
                      elementStyle: {
                        width: "100%",
                        color: "#333",
                      },
                      colConfig: {
                        span: 24,
                      },
                    },
                    {
                      id: "subscriptionTagIds",
                      name: "subscriptionTagIds",
                      placeholder: "Add or remove tags...",
                      required: false,
                      inputType: "multipleSelect",
                      label: "Tags",
                      selectOptions: companySubscriptionTagOptions,
                      initialValue: subscriptionInitialTags(
                        subscriptionToEdit.companySubscriptionTags ?? [],
                      ),
                      elementStyle: {
                        width: "100%",
                      },
                      colConfig: {
                        span: 24,
                      },
                    },
                    {
                      id: "contributionAllocationTypes",
                      name: "contributionAllocationTypes",
                      placeholder: "Add or remove contribution types...",
                      required: false,
                      inputType: "multipleSelect",
                      label: "Contribution Allocation Types",
                      selectOptions: contributionTypes,
                      initialValue:
                        subscriptionToEdit.contributionAllocationTypes ?? [],
                      elementStyle: {
                        width: "100%",
                      },
                      colConfig: {
                        span: 24,
                      },
                    },
                  ]}
                  fieldsToHide={[]}
                />
              ) : (
                <div />
              ),
            })}
            {ModalCreator({
              title: "Edit Company Details",
              okType: "primary",
              okText: "Save",
              showModal: showCompanyEditModal,
              onOkay: this.saveCompanyEdit,
              toggleModal: this.closeCompanyEditModal,
              isLoading: isCompanyEditSaving,
              width: 1000,
              inscription: (
                <BaseForm
                  layout="vertical"
                  reference={this.companyEditReference}
                  fieldsToHide={[]}
                  fields={companyEditFields}
                />
              ),
            })}
  
            <Details
              company={company}
              contactPersons={contactPersons ?? []}
              toggleDrawer={this.toggleDrawer}
              toggleDrawerWithDataLoad={this.toggleDrawerWithDataLoad}
              contributions={contributions && contributions}
              portReference={this.portReference}
              ports={ports}
              assignPortToCompany={this.assignPortToCompany}
              toggleAccountMergerModal={this.toggleAccountMergerModal}
              toggleReverseMergeModal={this.toggleReverseMergeModal}
              onReverse={(duplicateId) => this.reverseMerge(duplicateId)}
              onReverseAll={this.reverseAllMerges}
              isReversingMerge={this.state.isReversingMerge}
              isBulkReversing={this.state.isBulkReversingMerge}
              numberPerPage={numberPerPage}
              currentEmployeesPage={this.state.currentEmployeesPage}
              paginatedResourceNextPage={this.paginatedResourceNextPage}
              openCompanyEditModal={this.openCompanyEditModal}
              openContactModal={this.openContactModal}
              openDeleteContactModal={this.openDeleteContactModal}
              onMakePrimaryEmail={this.markEmailAsPrimary}
              onMakePrimaryPhone={this.markPhoneAsPrimary}
              onMakePrimaryAddress={this.markAddressAsPrimary}
              onReactivateEmail={this.reactivateEmail}
              onReactivatePhone={this.reactivatePhone}
              onReactivateAddress={this.reactivateAddress}
              onAddCompanyContact={() => this.toggleCompanyContactModal(true)}
              onEditCompanyContact={this.editCompanyContact}
              onDeleteCompanyContact={this.openCompanyContactDeleteModal}
              onUploadCompanyInfoFile={() => this.toggleFileModal(true)}
              onDeleteCompanyInfoFile={this.toggleDeleteConfirmationModal}
              onSetEntityToBeDeleted={this.setEntityToBeDeleted}
              onAddCompanyDirector={() => this.toggleCompanyDirectorModal(true)}
              onDeleteCompanyDirector={this.openCompanyDirectorDeleteModal}
              onAddDirectorContact={this.openCompanyDirectorContactModal}
              onDeleteDirectorContact={this.deleteDirectorContact}
            />
            {this.state.selectedReturnedChequePayment && (
              <ReturnedChequeNotificationModal
                showModal={!!this.state.selectedReturnedChequePayment}
                chequeNumber={
                  this.state.selectedReturnedChequePayment.returnChequeNumber ||
                  ""
                }
                chequeAmount={
                  this.state.selectedReturnedChequePayment.transactionAmount
                }
                preview={this.state.returnedChequePreview}
                isLoading={this.state.isReturnedChequePreviewLoading}
                isSending={this.state.isSendingReturnedCheque}
                onSend={this.sendReturnedChequeNotification}
                onClose={this.closeNotifyPaymentModal}
              />
            )}
            {this.state.showCompanyDirectorModal && (
              <ModalCreator
                showModal={this.state.showCompanyDirectorModal}
                toggleModal={() => this.toggleCompanyDirectorModal(false)}
                onOkay={this.createCompanyDirector}
                title="Add Company Director"
                okText="Create Director"
                okType="primary"
                width={520}
                inscription={
                  <BaseForm
                    layout="vertical"
                    reference={this.newCompanyDirectorFormReference}
                    fields={[
                      {
                        id: "firstName",
                        name: "firstName",
                        inputType: "string",
                        rule: "string",
                        placeholder: "First Name",
                        label: "First Name",
                        required: true,
                        colConfig: { span: 11 },
                      },
                      {
                        id: "lastName",
                        name: "lastName",
                        inputType: "string",
                        rule: "string",
                        placeholder: "Last Name",
                        label: "Last Name",
                        required: true,
                        colConfig: { span: 11, offset: 1 },
                      },
                    ]}
                    fieldsToHide={[]}
                  />
                }
              />
            )}
            {this.state.showCompanyDirectorContactModal && (
              <ModalCreator
                showModal={this.state.showCompanyDirectorContactModal}
                toggleModal={this.closeCompanyDirectorContactModal}
                onOkay={this.createCompanyDirectorContact}
                title="Add Director Contact"
                okText="Add Contact"
                okType="primary"
                width={520}
                inscription={
                  <BaseForm
                    layout="vertical"
                    reference={this.newCompanyDirectorContactFormReference}
                    fields={[
                      {
                        id: "phoneNumber",
                        name: "phoneNumber",
                        inputType: "string",
                        rule: "string",
                        placeholder: "Phone Number",
                        label: "Phone Number",
                        required: false,
                        colConfig: { span: 11 },
                      },
                      {
                        id: "emailAddress",
                        name: "emailAddress",
                        inputType: "string",
                        rule: "string",
                        placeholder: "Email Address",
                        label: "Email Address",
                        required: false,
                        colConfig: { span: 11, offset: 1 },
                      },
                    ]}
                    fieldsToHide={[]}
                  />
                }
              />
            )}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "30px",
              }}
            >
              <PaymentAccountsView
                payoutAccounts={company.companyPayoutAccounts}
                bankDetailsTitle="Company Bank Details"
                editEntitlement={entitlements.Companies.edit}
                deleteEntitlement={entitlements.Companies.payoutAccount.delete}
                onAddPayoutAccount={() => this.openPaymentAccountsModal()}
                onEditPayoutAccount={(account) =>
                  this.openPaymentAccountsModal(account)
                }
              />

              <div className="section-card">
                <Spin spinning={contributionsLoader}>
                  {showConfirmProductDelete &&
                    subscriptionIdToDelete &&
                    ModalCreator({
                      title: "Delete Product Subscription",
                      okType: "primary",
                      okText: "Delete",
                      showModal: showConfirmProductDelete,
                      onOkay: () =>
                        this.deleteCompanySubscription(subscriptionIdToDelete),
                      toggleModal: () =>
                        this.toggleConfirmProductDelete(undefined),
                      inscription: "Are you sure you want to delete product ?",
                    })}
                  <Descriptions
                    title={<div>Contributions </div>}
                  ></Descriptions>
                  <Collapse
                    accordion
                    style={{
                      marginBottom: "12px",
                    }}
                    onChange={this.getContributionData}
                  >
                    {hasSubscription &&
                      subscriptionsWithContributions.map((item) => {
                        const currentFundCodePage = this.getFundCodeInformation(
                          item.subscription?.product?.fundCode ?? "",
                        );

                        const productSignOnDate = item.subscription
                          ? moment(
                              item.subscription?.createdAt,
                              "YYYY-MM-DD HH:mm:ss",
                            ).format("DD/MM/YYYY")
                          : "n/a";

                        const isPhasedOut =
                          item.subscription.product?.isActive === false;

                        return (
                          <Panel
                            header={
                              <span>
                                {item.subscription.product.name}
                                {isPhasedOut && (
                                  <Tag color="red" style={{ marginLeft: 8 }}>
                                    Phased Out
                                  </Tag>
                                )}
                              </span>
                            }
                            key={item.subscription?.product?.fundCode ?? ""}
                          >
                            <div
                              style={{
                                display: "flex",
                                columnGap: 8,
                                marginBottom: 12,
                              }}
                            >
                              <Button
                                className="base-button"
                                id="generate-company-statement-btn"
                                onClick={() =>
                                  this.setCurrentSubscription(
                                    item.subscription.id,
                                  )
                                }
                              >
                                Generate Statement
                              </Button>
                              {!isPhasedOut && (
                                <Button
                                  className="base-button"
                                  id="generate-vesting-btn"
                                  onClick={() =>
                                    this.toggleVestingRule(item.subscription)
                                  }
                                >
                                  Vesting Rule
                                </Button>
                              )}
                              <EntitledSection
                                entitlement={
                                  entitlements.CompanySubscriptions.create
                                }
                              >
                                {!isPhasedOut && (
                                  <Button
                                    className="base-button"
                                    id="edit-subscription-btn"
                                    onClick={() =>
                                      this.openSubscriptionEditModal(
                                        item.subscription,
                                      )
                                    }
                                  >
                                    Edit
                                  </Button>
                                )}
                              </EntitledSection>
                              <EntitledSection
                                entitlement={
                                  entitlements.CompanySubscriptions.delete
                                }
                              >
                                <Button
                                  danger
                                  id="generate-vesting-btn"
                                  onClick={() =>
                                    this.toggleConfirmProductDelete(
                                      item.subscription.id,
                                    )
                                  }
                                  style={{ marginLeft: "auto" }}
                                >
                                  Delete Product
                                </Button>
                              </EntitledSection>
                            </div>
                            <Row
                              key={item.subscription.companyVan?.id}
                              style={{
                                marginTop: 24,
                              }}
                            >
                              <Col span={8}>
                                Product Sign On Date: {productSignOnDate}
                              </Col>
                              <Col span={5}>
                                VAN:{" "}
                                <Tag>{item.subscription.companyVan?.van || "N/A"}</Tag>
                              </Col>
                              {isSavingsBoosterProduct(
                                item.subscription.product?.name,
                              ) && (
                                <Col span={6}>
                                  Old VAN:{" "}
                                  <Tag>
                                    {item.subscription.companyVan?.oldVan ||
                                      "N/A"}
                                  </Tag>
                                </Col>
                              )}
                              <Col
                                span={
                                  isSavingsBoosterProduct(
                                    item.subscription.product?.name,
                                  )
                                    ? 5
                                    : 11
                                }
                              >
                                Institution:{" "}
                                {
                                  item.subscription.companyVan
                                    ?.financialInstitution.name || "N/A"
                                }
                              </Col>
                            </Row>
                            <Row style={{ marginTop: 16 }}>
                              <Col span={8}>
                                Sales Person:{" "}
                                {item.subscription.salesPerson?.name || "N/A"}
                              </Col>
                              <Col span={10}>
                                Contribution Allocation Types:{" "}
                                {(item.subscription.contributionAllocationTypes
                                  ?.length ?? 0) > 0
                                  ? item.subscription.contributionAllocationTypes?.join(
                                      ", ",
                                    )
                                  : "N/A"}
                              </Col>
                            </Row>
                            {item.subscription.companySubscriptionTags.length >
                              0 && (
                              <Row
                                style={{
                                  marginTop: "10px",
                                  marginBottom: "10px",
                                }}
                              >
                                <TagsSection
                                  tags={item.subscription.companySubscriptionTags.map(
                                    (subscriptionTag) => subscriptionTag.tag,
                                  )}
                                />
                              </Row>
                            )}

                            {ContributionsTableFactory(
                              item.clientContributions,
                              generateCompanyContributionColumns(
                                item.clientContributions[0],
                              ),
                              this.contributionsNextPage,
                              currentFundCodePage?.page ?? 1,
                              currentFundCodePage?.total ?? 10,
                              item.subscription?.product?.fundCode ?? "",
                            )}
                          </Panel>
                        );
                      })}
                  </Collapse>
                </Spin>
              </div>

              <div className="section-card">
                <Descriptions
                  title={<div>Schedules, Payments, Requests</div>}
                ></Descriptions>

                <Collapse
                  style={{
                    marginBottom: "12px",
                  }}
                  accordion={true}
                  onChange={this.getSchedulesPaymentsRequestsData}
                >
                  <Panel key="redemptionRequests" header="Redemption Requests">
                    {RedemptionsRequestsTableFactory(redemptionRequests)}
                  </Panel>
                  <Panel key="transferRequests" header="Transfer Requests">
                    <Table
                      bordered={true}
                      columns={transferRequestsColumns}
                      dataSource={injectKey(transferRequests, "id")}
                      pagination={{
                        defaultPageSize: 10,
                        total: transferRequests.length,
                      }}
                    />
                  </Panel>
                  <Panel key="payments" header="Payments">
                    {(() => {
                      const filteredPayments = payments.filter((payment) => {
                        if (this.state.paymentStatusFilter === "returned")
                          return !!payment.returnedAt;
                        if (this.state.paymentStatusFilter === "identified")
                          return !payment.returnedAt;
                        return true;
                      });

                      return (
                        <>
                          <div
                            style={{
                              marginBottom: 12,
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <Radio.Group
                              size="small"
                              value={this.state.paymentStatusFilter}
                              onChange={(event) =>
                                this.handlePaymentStatusFilterChange(
                                  event.target.value,
                                )
                              }
                            >
                              <Radio.Button value="all">All</Radio.Button>
                              <Radio.Button value="identified">
                                Identified
                              </Radio.Button>
                              <Radio.Button value="returned">
                                Returned
                              </Radio.Button>
                            </Radio.Group>
                          </div>
                          <Table
                            bordered={true}
                            columns={buildPaymentColumns(
                              this.openNotifyPaymentModal,
                            )}
                            dataSource={injectKey(filteredPayments, "id")}
                            pagination={{
                              defaultPageSize: 10,
                              total: filteredPayments.length,
                            }}
                          />
                        </>
                      );
                    })()}
                  </Panel>
                  <Panel key="schedules" header="Schedules">
                    <Table
                      bordered={true}
                      columns={scheduleColumns}
                      dataSource={injectKey(schedules, "id")}
                      pagination={{
                        defaultPageSize: 10,
                        total: schedules.length,
                      }}
                    />
                  </Panel>
                </Collapse>
              </div>

              <div className="section-card">
                <Descriptions title={<div>Statements</div>}></Descriptions>

                <Collapse
                  style={{
                    marginBottom: "12px",
                  }}
                  accordion={true}
                  onChange={this.handleCompanyStatementsData}
                >
                  <Panel key="companyStatements" header="Statements">
                    <Table
                      bordered={true}
                      columns={getCompanyStatementTableColumns()}
                      dataSource={companyStatements}
                      pagination={{
                        defaultPageSize: 10,
                        total: companyStatements.length,
                      }}
                    />
                  </Panel>
                </Collapse>
              </div>

              <div className="section-card">
                <Descriptions title={<div>Tickets</div>}></Descriptions>

                <Collapse
                  style={{
                    marginBottom: "12px",
                  }}
                  accordion={true}
                  onChange={this.getSchedulesPaymentsRequestsData}
                >
                  <Panel key="phoenixTickets" header="Tickets">
                    <Table
                      bordered={true}
                      columns={ticketColumns}
                      dataSource={injectKey(phoenixTickets, "id")}
                      pagination={{
                        defaultPageSize: 10,
                        total: schedules.length,
                      }}
                    />
                  </Panel>
                </Collapse>
              </div>

              {company.opportunities && company.opportunities.length > 0 && (
                <div className="section-card">
                  <Descriptions
                    title={<div>Product Interactions</div>}
                  ></Descriptions>

                  <Collapse
                    style={{
                      marginBottom: "12px",
                    }}
                  >
                    {company.opportunities &&
                      company.opportunities.map(
                        (opportunity: Opportunity): JSX.Element => {
                          return (
                            <Panel
                              header={
                                <span>
                                  {opportunity.product &&
                                    opportunity.product.name}
                                </span>
                              }
                              key={opportunity.id as string}
                            >
                              <InteractionsSection
                                reference={this.reference}
                                createInteraction={this.createInteraction}
                                interactions={
                                  opportunity.opportunityInteractions
                                }
                                showForm={false}
                              />
                            </Panel>
                          );
                        },
                      )}
                  </Collapse>
                </div>
              )}

              <Spin spinning={this.state.areInteractionsLoading}>
                <ActivitiesSection
                  showBorder={true}
                  showRequests={true}
                  isInteractionLoading={isCreateInteractionLoading}
                  forCustomer={false}
                  forCompany={true}
                  showHeading={true}
                  showInteraction={showInteractionModal}
                  toggleInteractionEdit={this.toggleInteractionEdit}
                  toggleViewRequestsSection={this.toggleViewRequestsSection}
                  toggleViewInteractionSection={
                    this.toggleViewInteractionSection
                  }
                  toggleViewRedemptionRequestsSection={
                    this.toggleViewRedemptionRequestsSection
                  }
                  reference={this.reference}
                  toggleCreateTicket={this.toggleTicketCreate}
                  toggleCreateInteractionModal={this.toggleShowInteractionModal}
                  createInteraction={this.createCompanyInteraction}
                  hasAttachment={true}
                  attachments={this.state.attachments}
                  updateAttachments={this.updateAttachments}
                  removeAttachment={
                    this.unassignAttachmentFromCompanyInteraction
                  }
                  activities={this.state.activities as Activity[]}
                  showForm={true}
                  useBaseColumn={false}
                  transferRequests={[]}
                  customer={undefined}
                  company={company}
                  activitiesCount={this.state.activitiesCount}
                  nextPage={this.interactionsNextPage}
                  disableCreateInteractionButton={
                    disableCreateInteractionButton
                  }
                  currentInteractionId={this.state.currentInteractionId}
                />
              </Spin>
              {company && (
                <EntitledSection
                  entitlement={entitlements.Companies.tags.manage}
                >
                  <div className="section-card">
                    <Descriptions title={<div>Tags</div>} />
                    <Collapse style={{ marginBottom: "12px" }}>
                      <Panel
                        key="tags"
                        header={
                          <span>
                            Company Tags
                            <Badge
                              count={
                                this.state.allCompanyTags.filter(
                                  (r) => r.isActive,
                                ).length
                              }
                              style={tabPaneStyle}
                            />
                          </span>
                        }
                      >
                        <TagsManagement
                          tagRecords={this.state.allCompanyTags}
                          tagScope={{ forCompany: true, forAccount: true }}
                          supportsEffectiveDate
                          companyId={company.id}
                          isSubmitting={this.state.isLoadingCompanyTags}
                          onAssignTags={this.assignCompanyTags}
                        />
                      </Panel>
                    </Collapse>
                  </div>
                </EntitledSection>
              )}
              {company && (
                <EntitledSection entitlement={entitlements.Companies.edit}>
                  <div className="section-card">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Descriptions
                        title={<div>Company Closure Periods</div>}
                      />
                      <EntitledSection
                        entitlement={entitlements.Companies.closurePeriods.add}
                      >
                        <Button
                          className="base-button"
                          onClick={() => this.toggleAddIntervalModal(true)}
                        >
                          Add Period
                        </Button>
                      </EntitledSection>
                    </div>
                    <Collapse style={{ marginBottom: "12px" }}>
                      <Panel
                        key="closureIntervals"
                        header={
                          <span>
                            Company Closure Periods
                            <Badge
                              count={this.state.companyClosedIntervals.length}
                              style={tabPaneStyle}
                            />
                          </span>
                        }
                      >
                        <Table
                          rowKey="id"
                          dataSource={this.state.companyClosedIntervals}
                          pagination={false}
                          size="small"
                          columns={[
                            {
                              title: "Closed At",
                              dataIndex: "closedAt",
                              key: "closedAt",
                              render: (value: string) =>
                                value
                                  ? moment(value).format("DD MMM YYYY")
                                  : "—",
                            },
                            {
                              title: "Reopened At",
                              dataIndex: "reopenedAt",
                              key: "reopenedAt",
                              render: (value: string) =>
                                value
                                  ? moment(value).format("DD MMM YYYY")
                                  : "—",
                            },
                            {
                              title: "Notes",
                              dataIndex: "notes",
                              key: "notes",
                              render: (value: string) => value || "—",
                            },
                            {
                              title: "Proof of Closure",
                              key: "proofOfClosureDocumentUrls",
                              render: (
                                _: unknown,
                                record: import("../helpers/shared-interfaces").CompanyClosedInterval,
                              ) =>
                                this.renderProofDocuments(
                                  record.proofOfClosureDocumentUrls,
                                ),
                            },
                            {
                              title: "Proof of Reopening",
                              key: "proofOfReopeningDocumentUrls",
                              render: (
                                _: unknown,
                                record: import("../helpers/shared-interfaces").CompanyClosedInterval,
                              ) =>
                                this.renderProofDocuments(
                                  record.proofOfReopeningDocumentUrls,
                                ),
                            },
                            {
                              title: "Actions",
                              key: "actions",
                              render: (
                                _: unknown,
                                record: import("../helpers/shared-interfaces").CompanyClosedInterval,
                              ) =>
                                // The current open interval (no reopenedAt) is
                                // not deletable, per the agreed behaviour.
                                record.reopenedAt ? (
                                  <EntitledSection
                                    entitlement={
                                      entitlements.Companies.closurePeriods
                                        .delete
                                    }
                                  >
                                    <Popconfirm
                                      title="Delete this closure period?"
                                      okText="Delete"
                                      okType="danger"
                                      cancelText="Cancel"
                                      onConfirm={() =>
                                        this.handleDeleteInterval(record.id)
                                      }
                                    >
                                      <Button type="link" danger size="small">
                                        Delete
                                      </Button>
                                    </Popconfirm>
                                  </EntitledSection>
                                ) : null,
                            },
                          ]}
                        />
                      </Panel>
                    </Collapse>
                  </div>
                  <ModalCreator
                    title="Add Closure Period"
                    showModal={this.state.showAddIntervalModal}
                    toggleModal={() => this.toggleAddIntervalModal(false)}
                    onOkay={this.handleAddInterval}
                    okText="Add Period"
                    okType="primary"
                    isLoading={this.state.isSubmittingInterval}
                    inscription={
                      // Rendered only while open so the file uploads start
                      // empty on every visit; the modal keeps its children
                      // mounted once opened, and FileUpload holds its own list.
                      this.state.showAddIntervalModal ? (
                        <BaseForm
                          key={`closure-period-${this.state.intervalFormSession}`}
                          layout="vertical"
                          gutter={[16, 0]}
                          reference={this.addIntervalReference}
                          fieldsToHide={[]}
                          fields={this.addIntervalFormFields()}
                        />
                      ) : (
                        <Fragment />
                      )
                    }
                  />
                </EntitledSection>
              )}
              <div className="section-card">
                <Descriptions
                  title={<div>Company Activities</div>}
                ></Descriptions>
                <Collapse
                  style={{
                    marginBottom: "12px",
                  }}
                >
                  <Panel key="companyActivities" header="Company Activities">
                    <Spin spinning={this.state.areInteractionsLoading}>
                      <EntitledSection
                        entitlement={entitlements.CompanyActivities.list}
                      >
                        <CompanyActivityList
                          companyId={company?.id}
                          {...this.props}
                        />
                      </EntitledSection>
                    </Spin>
                  </Panel>
                </Collapse>
              </div>

              {company.opportunities && company.opportunities.length > 0 && (
                <div className="section-card">
                  <Descriptions
                    title={<div>Client Documents</div>}
                  ></Descriptions>
                  <Collapse
                    style={{
                      marginBottom: "12px",
                    }}
                  >
                    {company.opportunities &&
                      company.opportunities.map(
                        (opportunity: Opportunity): JSX.Element => {
                          const documents = transformDocumentsData(opportunity);
                          return (
                            <Panel
                              header={
                                <span>
                                  {opportunity.product &&
                                    opportunity.product.name}
                                </span>
                              }
                              key={opportunity.id as string}
                            >
                              {DocumentTableFactory(documents, this.setEntityToBeDeleted, this.toggleDeleteConfirmationModal)}
                            </Panel>
                          );
                        },
                      )}
                  </Collapse>
                </div>
              )}
            </div>
          </Fragment>
      );
    } else {
      userInterface = <Fragment />;
    }

    return (
      <>
        <EntitledEntity
          id={String(this.state.id)}
          entitlement={this.props.entitlement}
          user={this.props.user}
        >
          {this.state.showAccountMergerModal &&
            ModalCreator({
              title: "Account Merger Section",
              okType: "primary",
              okText: "Merge Account",
              okayButtonProps: {
                disabled: this.state.selectedCompanies.length === 0,
              },
              showModal: true,
              onOkay: this.mergeAccounts,
              toggleModal: this.toggleAccountMergerModal,
              inscription: AccountMergerUI({
                selectedCompanies: this.state.selectedCompanies,
                handleSearchInput: this.handleSearchInput,
                searchQuery: this.state.companySearchQuery,
                companies: this.state.companies,
                isLoading: this.state.isSearchingForCompany,
                isMerging: this.state.isMerging,
                handleCheckboxGroupChange: this.handleCheckboxGroupChange,
              }),
            })}

          {this.state.showStatementModal &&
            ModalCreator({
              title: "Generate Company Statement",
              okType: "primary",
              okText: "Generate Statement",
              showModal: this.state.showStatementModal,
              isLoading: this.state.isStatementLoading,
              onOkay: this.generateCompanyStatement,
              toggleModal: this.toggleShowStatementModal,
              inscription: GenerateStatementUI({
                reference: this.statementReference,
                url: this.state.generatedStatementUrl,
              }),
            })}
          {this.state.showAddDocumentModal &&
            ModalCreator({
              title: "Add Required Document",
              okType: "primary",
              okText: "Close",
              showModal: this.state.showAddDocumentModal,
              showFooter: true,
              onOkay: () => this.toggleFileModal(false),
              toggleModal: () => this.toggleFileModal(false),
              width: 700,
              inscription: (() => {
                // For View Company, upload company-scoped documents only (via companyId)
                // No opportunity needed—all files go to companyInfoFileUploads
                const fakeOpportunity: Opportunity = { id: "company-scope", company } as Opportunity;

                const requiredDocExists = (fileType: string): boolean => {
                  // Only check company-level file uploads
                  return company?.companyInfoFileUploads?.some((f) => f.fileType === fileType) ?? false;
                };

                let allFields = createDocumentUploadFormFields({
                  opportunity: fakeOpportunity,
                  company: company,
                  handleFileUploadSuccess: this.handleDocumentUploadSuccess,
                  initialValues: {
                    npraForm: undefined,
                    vestingRuleDocument: undefined,
                    employeeDatasheet: undefined,
                    signedApplicationForm: undefined,
                    companyInfoFileUploads: company?.companyInfoFileUploads,
                  },
                });

                // Override fileUploadProps: use companyId only, no opportunityId
                allFields = allFields.map(field => {
                  if (field.fileUploadProps) {
                    field.fileUploadProps = {
                      ...field.fileUploadProps,
                      opportunityId: undefined,
                      companyId: company?.id,
                    };
                  }
                  return field;
                });
                allFields = allFields.map(field => {
                  let fileTypeToCheck = '';
                  if (field.name === 'npraFormUrl') fileTypeToCheck = FileTypes.npraForm;
                  else if (field.name === 'signedApplicationFormUrl') fileTypeToCheck = FileTypes.signedApplicationForm;
                  else if (field.name === 'employeeDatasheetUrl') fileTypeToCheck = FileTypes.employeeDatasheet;
                  else if (field.name === 'vestingRuleDocumentUrl') fileTypeToCheck = FileTypes.vestingRuleDocument;
                  if (fileTypeToCheck && requiredDocExists(fileTypeToCheck)) {
                    return { ...field, initialValue: 'exists' };
                  }
                  return field;
                });
                const documentModalFields = allFields.filter(field => !field.initialValue);
                return documentModalFields.length === 0 ? (
                  <Empty description="All required documents are already on file." />
                ) : (
                  <BaseForm
                    reference={this.docsReference}
                    fields={documentModalFields}
                    layout="vertical"
                    fieldsToHide={[]}
                  />
                );
              })(),
            })}

            {ModalToggler({
              modalTarget: this.state.modalTarget,
              showModal: this.state.showDeleteConfirmationModal,
              toggleModal: this.toggleDeleteConfirmationModal,
              deleteSignedApplicationForm: this.deleteSignedApplicationForm,
              deleteVestingRuleDocument: this.deleteVestingRuleDocument,
              deleteEmployeeDatasheet: this.deleteEmployeeDatasheet,
              deleteNPRAForm: this.deleteNPRAForm,
              deleteCompanyDocument: this.deleteCompanyDocument,
            })}

          <Spin spinning={isLoading}>
            <Card
              style={{
                overflow: "hidden",
                borderTopWidth: 1,
                borderTopColor: "#f0f0f0",
              }}
            >
              <Row
                style={{
                  marginBottom: "20px",
                }}
              >
                <Col span={24}>{userInterface}</Col>
              </Row>
            </Card>
          </Spin>
          <Drawer
            title={this.getTitleBasedOnDrawerContent()}
            width={1300}
            onClose={this.toggleDrawer("")}
            visible={this.state.showDrawer}
            bodyStyle={{ paddingBottom: 80 }}
          >
            {this.getDrawerContent()}
          </Drawer>
        </EntitledEntity>
        <span style={{ position: "absolute", top: 60, right: 40 }}>
          {nextPreviousUI}
        </span>
      </>
    );
  }
}